import React, { useRef } from 'react';
import { useState, useEffect } from "react";
import { useHistory, useLocation, useParams  } from 'react-router-dom';
import Select from "react-select";
import swal from "sweetalert";
import { toast } from "react-toastify";

// Api's
import {getAllCategoryCombinations, createNewEclScenario, getOneLoanECLScenario, updateLoanECLScenario, deleteLoanECLScenario} from "../../../../Bookclosure/Services/ApiHandler"

import CompanyEditSideMenu from "../CompanyEditSideMenu"
import Breadcrumb from "../../../components/Breadcrumb";

import commoncss from "../../../css/common.module.css"; 
import eclCss from "../../../css/createLoansScenarioEcl.module.css"
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

import  { ReactComponent as QuestionMartInfo }  from '../../../../myfin_v2/assets/icons/questionECL.svg'
import  { ReactComponent as PervBtnIcon }  from '../../../../myfin_v2/assets/icons/pervECLBtnIcon.svg'
import  { ReactComponent as BreadCrumbsdor }  from '../../../../myfin_v2/assets/icons/breadCrumbsDot.svg'
import  { ReactComponent as NumUpArrow }  from '../../../../myfin_v2/assets/icons/numberIncreaseUp.svg'
import  { ReactComponent as NumDownArrow }  from '../../../../myfin_v2/assets/icons/numberIncreaseDown.svg'
import  { ReactComponent as PercebtageIcn }  from '../../../../myfin_v2/assets/icons/eclPercentageIcon.svg'
import  { ReactComponent as RightArrowECL }  from '../../../../myfin_v2/assets/icons/rightArrowEcl.svg'
import  { ReactComponent as AddEclPlusIcon }  from '../../../../myfin_v2/assets/icons/addEcl.svg'
import  { ReactComponent as EclExcaclamater }  from '../../../../myfin_v2/assets/icons/eclExcaclamater.svg'
import  { ReactComponent as EditIcon }  from '../../../../myfin_v2/assets/icons/editCard.svg'
import  { ReactComponent as CompleteECLIcon }  from '../../../../myfin_v2/assets/icons/completeECL.svg'
import  { ReactComponent as ActiveRadioBtn }  from '../../../../myfin_v2/assets/icons/activeRadioBtn.svg'
import  { ReactComponent as InactiveRadioBtn }  from '../../../../myfin_v2/assets/icons/inactiveRadioBtn.svg'
import  { ReactComponent as UploadIcon }  from '../../../../myfin_v2/assets/icons/loansUploadIcon.svg'
import  { ReactComponent as GrayAddIcon }  from '../../../../myfin_v2/assets/icons/grayAddIcon.svg'
import  { ReactComponent as AddFactorBtn }  from '../../../../myfin_v2/assets/icons/addFactorBtn.svg'


const CreateLoansEclScenario = () => {
    // const { companyId } = useParams();
    // const { eclId: scenarioId } = useParams();
    const { companyId, eclId: scenarioId } = useParams();

    const [companyID, setCompanyID] = useState(companyId);

    // active stage
    const [ActiveStage, setActiveStage] = useState(1)

    // ====================================================================
    // Start Stage One
        const [StageOneScenarioName, setStageOneScenarioName] = useState()
        const [StageOneScenarioApproach, setStageOneScenarioApproach] = useState('generalApproach')
    // End Stage One
    // ====================================================================
    
    // ====================================================================
    // Start Stage Two
        const [StageTwoScenarioModel, setStageTwoScenarioModel]   = useState('Vintage Model')
        const [StageTwoCategorization, setStageTwoCategorization] = useState('No')
        const [StageTwoPDInpt, setStageTwoPDInpt]                 = useState('count')
        const [StageTwoPDCalculation, setStageTwoPDCalculation]   = useState('yearly')
        const [StageTwoNumberOfPeriods, setStageTwoNumberOfPeriods] = useState(10)
        const [StageTwoLoanSect, setStageTwoLoanSect] = useState('total')
        const [StageTwoDefaultPayment, setStageTwoDefaultPayment] = useState('Yes')
        const [StageTwoCalCulPD, setStageTwoCalCulPD] = useState('Yes')
        const [StageTwoConsiderPerd, setStageTwoConsiderPerd] = useState('financialYear')
        const [StageTwoExtraploation, setStageTwoExtraploation] = useState('Yes')
        const [StageTwoSAWApE, setStageTwoSAWApE] = useState('weightedAverage')
        const [StageTwoPercentage, setStageTwoPercentage] = useState(2.3)
        const [StageTwoSpecificWe, setStageTwoSpecificWe] = useState("Yes")
        const [listOfYears, setlistOfYears] = useState([])
        const [StageTwoMulpliyPDSelect, setStageTwoMulpliyPDSelect] = useState('multiply')
        const [StageTwoMulpliyPDInpt, setStageTwoMulpliyPDInpt] = useState(2.3)

        const stageTwoOptions = [
            { value: 'Vintage Model', label: 'PD - Vintage Model' },
        ];

        const stageTwoOptionsAddOrMulti = [ 
            { value: 'multiply', label: 'Multiply by' },
            { value: 'add', label: 'Add' },
        ];
        
        const stageTwoMin = 1;
        const stageTwoMax = 100;
        const stageTwoPercentage = ((StageTwoNumberOfPeriods - stageTwoMin) / (stageTwoMax - stageTwoMin)) * 100;

        
    // End Stage Two
    // ====================================================================
    
    // ====================================================================
    // Start StageTwo Catgeory
        const [StageTwoActiveCategory, setStageTwoActiveCategory] = useState(0)
        const [StageTwoCategoryScenarioModel, setStageTwoCategoryScenarioModel]   = useState('PDV')
        const [StageTwoCategoryCategorization, setStageTwoCategoryCategorization] = useState('Yes')
        // const [StageTwoCategoryUnDrawnCommitment, setStageTwoCategoryUnDrawnCommitment] = useState('Yes')
        const [StageTwoCategoryPDInpt, setStageTwoCategoryPDInpt]         = useState('count')
        // const [StageTwoCategoryPayments, setStageTwoCategoryPayments]             = useState('Yes')
        const [StageTwoCategoryPDCalculation, setStageTwoCategoryPDCalculation]   = useState('yearly')
        // const [StageTwoCategoryPeriodCons, setStageTwoCategoryPeriodCons]         = useState(10)
        const [StageTwoCategoryLoanSect, setStageTwoCategoryLoanSect]             = useState('total')
        // const [StageTwoCategoryCalCulPD, setStageTwoCategoryCalCulPD]             = useState('Yes')
        const [StageTwoCategoryConsiderPeriod, setStageTwoCategoryConsiderPeriod] = useState('financialYear')
        const [StageTwoCategoryExtraploation, setStageTwoCategoryExtraploation]   = useState('Yes')
        const [StageTwoCategorySAWApE, setStageTwoCategorySAWApE]                 = useState('weightedAverage')
        const [StageTwoCategoryPercentage, setStageTwoCategoryPercentage]         = useState(2.3)
        const [StageTwoCategorySpecificWe, setStageTwoCategorySpecificWe]         = useState("Yes")
        const [StageTwoCategoryMulpliyPDSelect, setStageTwoCategoryMulpliyPDSelect] = useState('multiply')
        const [StageTwoCategoryMulpliyPDInpt, setStageTwoCategoryMulpliyPDInpt] = useState(2.3)

    // End StageTwo Catgeory
    // ====================================================================
    
    const optionsMultiplePDPercentage = [
        { value: 'multiply', label: 'Multiply by' },
        { value: 'add', label: 'Add' },
    ];

    const StageTwoCategoryoptions = [
        { value: 'Vintage Model', label: 'PD - Vintage Model' },
    ];
    // End StageTwo Catgeory
    // ====================================================================

    // ====================================================================
    // Start StageThree
        const [StageThreeScenarioModel, setStageThreeScenarioModel]   = useState('Basic LGD')
        const [StageThreeCategorization, setStageThreeCategorization] = useState('No')
        const [StageThreeComputeLoss, setStageThreeComputeLoss] = useState('loanSanctionedValue')
        const [considerInterestEMIDelayedPayment, setconsiderInterestEMIDelayedPayment] = useState('No')
        const [considerPenalCharges, setconsiderPenalCharges] = useState('No')
        const [considerRecoveryCharges, setconsiderRecoveryCharges] = useState('No')
        const [onlyActiveNPA, setonlyActiveNPA] = useState('No')
        const [writtenOffOnly, setwrittenOffOnly] = useState('No')
        const [considerSecurityValue, setconsiderSecurityValue] = useState('No')
        const [considerSecondarySecurity, setconsiderSecondarySecurity] = useState('No')
        const [baseValuePrimarySecurity, setbaseValuePrimarySecurity] = useState('cost')
        const [baseValueSecondarySecurity, setbaseValueSecondarySecurity] = useState('fairValue')
        const [percentageOfPrimarySecurity, setpercentageOfPrimarySecurity] = useState()
        const [percentageOfSecondarySecurity, setpercentageOfSecondarySecurity] = useState()
        // const [badDebtConsider, setbadDebtConsider] = useState('Yes')
        const [addOverlayFactor, setaddOverlayFactor] = useState('Yes')
        const [overlayFactorCount, setoverlayFactorCount] = useState(1)
        
        const overlayFactorsRef = useRef();
        const [overlayFactorDataList, setoverlayFactorDataList] = useState([{
            method: 'multiply',
            percentage: 2.3,
            remarks: 'Remark',
        }])
        
        function saveOveryLayFactores(inptValue, InputType, indexNumber) {

            setoverlayFactorDataList((prevList) => {

                const newList = [...prevList];

                // If entry doesn't exist, initialize it
                if (!newList[indexNumber]) {
                    newList[indexNumber] = {
                        method: '',
                        percentage: '',
                        remarks: ''
                    };
                }

                // Update based on InputType
                if (InputType === 'FactoreMethod') {
                    newList[indexNumber].method = inptValue;
                } else if (InputType === 'FactoreInput') {
                    newList[indexNumber].percentage = inptValue;
                } else if (InputType === 'RemarkInput') {
                    newList[indexNumber].remarks = inptValue;
                }

                return newList;
            });
        }


        const StageThreeOptions = [
            { value: 'Basic LGD', label: 'Basic LGD' },
        ];

        const initialLeftItems = [
            { id: '1', heading: 'Category 1', desc: 'Home Loans › Salaried'},
            { id: '2', heading: 'Category 2', desc: 'Car Loans › Salaried'},
            { id: '3', heading: 'Category 3', desc: 'Education Loans › Salaried'},
        ];

        const initialRightItems = [
            { id: '4', heading: 'Posible Category', desc: 'Home Loans › Salaried', active : 'Y' },
            { id: '5', heading: 'Posible Category', desc: 'Car Loans › Salaried', active : 'Y' },
            { id: '6', heading: 'Posible Category', desc: 'Education Loans › Salaried', active : 'Y' },
        ];

        const [leftItems, setLeftItems] = useState(initialLeftItems);
        const [rightItems, setRightItems] = useState(initialRightItems);

    // End StageThree
    // ====================================================================
    
    // ====================================================================
    // start Stage three category
        const [StageThreeActiveCategory, setStageThreeActiveCategory] = useState(0)
    // End Stage three category
    // ====================================================================
    
    // ====================================================================
    // Start StageFour
        // const [StageFourFactoryAddOrMultiply, setStageFourFactoryAddOrMultiply] = useState('multiply')
        const [StageFourfactorsCount, setStageFourfactorsCount] = useState(1)
        const [StageFourCategorization, setStageFourCategorization] = useState('No')
        const [StageFourfactors, setStageFourfactors] = useState([{
                method: 'multiply', // add | multiply
                percentage: 2.3,
                description: 'Desc...'
        }])

    // ====================================================================
    // Start StageFour Category
        const [StageFourActiveCategory, setStageFourActiveCategory] = useState(0)
        
    // End StageFour Category
    // ====================================================================

    // ++++++++++++++++++++++++++++++++++++++++++++++++
    // Start Category all stages data and send to api
        
        const [categorysData,setcategorysData] = useState([])

        const [categorysPDObj, setcategorysPDObj] = useState({})
        const [categorysLGDObj, setcategorysLGDObj] = useState({})
        const [categorysFLFObj, setcategorysFLFObj] = useState({})

        useEffect( () => {
            
            getAllCategoryCombinations(companyID).then(response => {

                // setCategorysList(response.data.categoryCombinations)
                setcategorysData(response.data.categoryCombinations);

                const CategorysList = response.data.categoryCombinations

                let pdObj = {};
                let lgdObj = {};
                let flfObj = {};

                if(CategorysList.length > 0){

                    // Deafault values for category inputs
                    for (let index = 0; index < CategorysList.length; index++) {
    
                        let objPD = { ...CategorysList[index] };
                        let objLGD = { ...CategorysList[index] };
                        let objFLF = { ...CategorysList[index] };
    
                        objPD['values'] = {
                            StageTwoCategoryScenarioModel: '',
                            StageTwoCategoryPDInpt:  "count",
                            StageTwoCategoryPDCalculation:  "yearly",
                            StageTwoCategoryNumberOfPeriods:  10,
                            StageTwoDefaultPayment:  "Yes",
                            calculateTwelveMonthsPD:  "Yes",
                            StageTwoCategoryLoanSect:  "total",
                            StageTwoCategoryConsiderPeriod:  "financialYear",
                            StageTwoCategoryExtraploation:  "Yes",
                            StageTwoCategorySAWApE:  "simpleAverage",
                            StageTwoCategoryPercentage:  2.3,
                            StageTwoCategorySpecificWe:  "Yes",
                            StageTwoCategoryMulpliyPDSelect:  "multiply",
                            StageTwoCategoryMulpliyPDInpt:  2.3,
                            min: 1,
                            max: 100,
                            percentage:  10,
                            weights: Array.from({ length: 10 }, (_, i) => ({ period: `${ index + 1}`, percentage: 20 }))
                        };
    
                        objLGD['values'] = {
                            computeLossOn: 'loanDisbursedValue',
                            considerInterestEMIDelayedPayment: 'Yes',
                            considerPenalCharges: 'No',
                            considerRecoveryCharges: 'Yes',
                            onlyActiveNPA: 'No',
                            writtenOffOnly: 'Yes',
                            considerSecurityValue: 'Yes',
                            considerSecondarySecurity: 'No',
                            baseValuePrimarySecurity: 'cost',
                            baseValueSecondarySecurity: 'fairValue',
                            percentageOfPrimarySecurity: '',
                            percentageOfSecondarySecurity: '',
                            addOverlayFactor: 'Yes',
                            overlayFactorCount: 1,
                            overlayFactor: [{
                                method: 'multiply',
                                percentage: 23,
                                remarks: 'LGD Remark',
                            }],
                            badDebtConsider: 'Yes',
                        };
    
                        objFLF['values'] = {
                            factorsCount: 1,
                            factors: [{
                                method: 'multiply',
                                percentage: 12,
                                description: 'FLF description',
                            }]
                        };
    
                        pdObj[objPD.subcategoryID] = objPD;
                        lgdObj[objLGD.subcategoryID] = objLGD;
                        flfObj[objFLF.subcategoryID] = objFLF;
                    }
                }
                else{
                    updateDefaultValues();
                }

                // Single updates after loop
                setcategorysPDObj(pdObj);
                setcategorysLGDObj(lgdObj);
                setcategorysFLFObj(flfObj);

                // updateDefaultValues(categorysPDObj,categorysLGDObj,categorysFLFObj) 

            })
        }
        ,[companyID])

        const [hasInitialized, setHasInitialized] = useState(false);

    // ++++++++++++++++++++++++++++++++++++++++++++++++
    //  store all stages data
        const [stageOneWholeData, setstageOneWholeData] = useState({
            name:StageOneScenarioName,
            indASProvisioning:StageOneScenarioApproach,
        })

        useEffect(() => {
            setstageOneWholeData({
                name:StageOneScenarioName,
                indASProvisioning:StageOneScenarioApproach,
            });
        },
        [ // when any states get update new data update in to stage two whole data
            StageOneScenarioName,
            StageOneScenarioApproach
        ]);

        const [stageTwoWholeData, setstageTwoWholeData] = useState({
            model:StageTwoScenarioModel,
            categorize:StageTwoCategorization,
            global:{
                rateCalculation:StageTwoPDInpt,
                frequency:StageTwoPDCalculation,
                periods:StageTwoNumberOfPeriods,
                baseValuePostPeriodOne:StageTwoLoanSect,
                includeInterestDefaultPayments: StageTwoDefaultPayment,
                calculateTwelveMonthsPD:StageTwoCalCulPD,
                considerAsPeriodOne:StageTwoConsiderPerd,
                extrapolationForMissingPeriod:StageTwoExtraploation,
                extrapolationMethod:StageTwoSAWApE,
                extrapolationPercentage:StageTwoPercentage,
                useWeights:StageTwoSpecificWe,
                weights: listOfYears,
                addOrMultiplyFactor:StageTwoMulpliyPDSelect,
                addOrMultiplyPercentage:StageTwoMulpliyPDInpt,
            }
        })

        // UPDATE Section when any state update keep updating into whole data this are going to send data to api
        // update stage two whole data 
        useEffect(() => {
            setstageTwoWholeData({
                model: StageTwoScenarioModel,
                categorize: StageTwoCategorization,
                global: {
                    rateCalculation: StageTwoPDInpt,
                    frequency: StageTwoPDCalculation,
                    periods: StageTwoNumberOfPeriods,
                    baseValuePostPeriodOne: StageTwoLoanSect,
                    includeInterestDefaultPayments: StageTwoDefaultPayment,
                    calculateTwelveMonthsPD: StageTwoCalCulPD,
                    considerAsPeriodOne: StageTwoConsiderPerd,
                    extrapolationForMissingPeriod: StageTwoExtraploation,
                    extrapolationMethod: StageTwoSAWApE,
                    extrapolationPercentage: StageTwoPercentage,
                    useWeights: StageTwoSpecificWe,
                    weights: listOfYears,
                    addOrMultiplyFactor: StageTwoMulpliyPDSelect,
                    addOrMultiplyPercentage: StageTwoMulpliyPDInpt,
                }
            });
            }, [ // when any states get update new data update in to stage two whole data
            StageTwoScenarioModel,
            StageTwoCategorization,
            StageTwoPDInpt,
            StageTwoPDCalculation,
            StageTwoNumberOfPeriods,
            StageTwoLoanSect,
            StageTwoDefaultPayment,
            StageTwoCalCulPD,
            StageTwoConsiderPerd,
            StageTwoExtraploation,
            StageTwoSAWApE,
            StageTwoPercentage,
            StageTwoSpecificWe,
            listOfYears,
            StageTwoMulpliyPDSelect,
            StageTwoMulpliyPDInpt
        ]);

        const [stageTwoCategoryWholeData, setstageTwoCategoryWholeData] = useState(categorysPDObj)
        
        useEffect(() => {
            setstageTwoCategoryWholeData(categorysPDObj)
        }, [categorysPDObj]);

        const [stageThreeWholeData, setstageThreeWholeData] = useState({
            model:StageThreeScenarioModel,
            categorize:StageThreeCategorization,
            global:{
                computeLossOn:StageThreeComputeLoss,
                considerInterestEMIDelayedPayment:considerInterestEMIDelayedPayment,
                considerPenalCharges:considerPenalCharges,
                considerRecoveryCharges:considerRecoveryCharges,
                onlyActiveNPA:onlyActiveNPA,
                writtenOffOnly:writtenOffOnly,
                considerSecurityValue:considerSecurityValue,
                considerSecondarySecurity:considerSecondarySecurity,
                baseValuePrimarySecurity:baseValuePrimarySecurity,
                baseValueSecondarySecurity:baseValueSecondarySecurity,
                percentageOfPrimarySecurity:percentageOfPrimarySecurity,
                percentageOfSecondarySecurity:percentageOfSecondarySecurity,
                // badDebtConsider:badDebtConsider,
                addOverlayFactor:addOverlayFactor,
                overlayFactor:overlayFactorDataList
            }
        })

        useEffect(() => {
            setstageThreeWholeData({
                model: StageThreeScenarioModel,
                categorize: StageThreeCategorization,
                global: {
                    computeLossOn: StageThreeComputeLoss,
                    considerInterestEMIDelayedPayment: considerInterestEMIDelayedPayment,
                    considerPenalCharges: considerPenalCharges,
                    considerRecoveryCharges: considerRecoveryCharges,
                    onlyActiveNPA: onlyActiveNPA,
                    writtenOffOnly: writtenOffOnly,
                    considerSecurityValue: considerSecurityValue,
                    considerSecondarySecurity: considerSecondarySecurity,
                    baseValuePrimarySecurity: baseValuePrimarySecurity,
                    baseValueSecondarySecurity: baseValueSecondarySecurity,
                    percentageOfPrimarySecurity: percentageOfPrimarySecurity,
                    percentageOfSecondarySecurity: percentageOfSecondarySecurity,
                    // badDebtConsider:badDebtConsider,
                    addOverlayFactor: addOverlayFactor,
                    overlayFactor: overlayFactorDataList
                }
            });
            }, [
            StageThreeScenarioModel,
            StageThreeCategorization,
            StageThreeComputeLoss,
            considerInterestEMIDelayedPayment,
            considerPenalCharges,
            considerRecoveryCharges,
            onlyActiveNPA,
            writtenOffOnly,
            considerSecurityValue,
            considerSecondarySecurity,
            baseValuePrimarySecurity,
            baseValueSecondarySecurity,
            percentageOfPrimarySecurity,
            percentageOfSecondarySecurity,
            // badDebtConsider,
            addOverlayFactor,
            overlayFactorDataList
        ]);


        const [stageThreeCategoryWholeData, setstageThreeCategoryWholeData] = useState(categorysLGDObj)

        useEffect(() => {
            setstageThreeCategoryWholeData(categorysLGDObj)
        }, [categorysLGDObj]);

        const [stageFourWholeData, setstageFourWholeData] = useState({
            model:"Simple FLF",
            categorize:StageFourCategorization,
            global:{
                factors:StageFourfactors
            }
        })

        useEffect(() => {
            setstageFourWholeData({
                categorize: StageFourCategorization,
                global: {
                    factors: StageFourfactors
                }
            });
            }, [StageFourCategorization, StageFourfactors]);


        const [stageFourCategoryWholeData, setstageFourWholeCategoryData] = useState(categorysFLFObj)

        useEffect(() => {
            setstageFourWholeCategoryData(categorysFLFObj)
        }, [categorysFLFObj]);
       
    // ++++++++++++++++++++++++++++++++++++++++++++++++

        const location = useLocation();
        const [createOrupdate, setcreateOrupdate] = useState('createFlow')

        const isUpdate = location.pathname.includes('update');
        
        useEffect(() => {
            if (isUpdate) {
                setcreateOrupdate('updateFlow');
            } else {
                setcreateOrupdate('createFlow');
            }
        }, [isUpdate]);

        useEffect(() => {
            if ( createOrupdate === 'updateFlow' && Object.keys(categorysPDObj).length > 0 && Object.keys(categorysLGDObj).length > 0 && Object.keys(categorysFLFObj).length > 0 && !hasInitialized ) {

                updateDefaultValues(categorysPDObj, categorysLGDObj, categorysFLFObj);
                setHasInitialized(true);

            }
        }, 
        [createOrupdate, hasInitialized, categorysPDObj, categorysLGDObj, categorysFLFObj]);

        const updateDefaultValues = () => {

            if (createOrupdate === 'updateFlow') {

                console.log('Update this shit');

                getOneLoanECLScenario(scenarioId)
                .then(response => {

                    let senarioData = response.data.loanECLScenario

                    setStageOneScenarioName(senarioData.name)
                    setStageOneScenarioApproach(senarioData.indASProvisioning)

                    let senarioPDdata = senarioData.pd
                    let senarioLGDdata = senarioData.lgd
                    let senarioFLFdata = senarioData.flf

                    if(senarioPDdata.categorize === 'Yes'){

                        setStageTwoCategorization('Yes')

                        console.log('categorysPDObj :: ', categorysPDObj);
                        console.log('categorysLGDObj :: ', categorysLGDObj);
                        console.log('categorysFLFObj :: ',categorysFLFObj);

                        // merge in place
                        for (let i = 0; i < senarioData.pd.categorized.length; i++) {
                            const entry = senarioData.pd.categorized[i];
                            const key = entry.subcategoryID;
                            if (categorysPDObj[key] && entry.values) {

                                categorysPDObj[key].values = {
                                    StageTwoCategoryConsiderPeriod: entry.values.considerAsPeriodOne, 
                                    StageTwoCategoryExtraploation: entry.values.extrapolationForMissingPeriod, 
                                    StageTwoCategoryLoanSect: entry.values.baseValuePostPeriodOne, 
                                    StageTwoCategoryMulpliyPDInpt: entry.values.addOrMultiplyPercentage, 
                                    StageTwoCategoryMulpliyPDSelect: entry.values.addOrMultiplyFactor,
                                    StageTwoCategoryNumberOfPeriods: entry.values.periods, 
                                    StageTwoCategoryPDCalculation: entry.values.frequency, 
                                    StageTwoCategoryPDInpt: entry.values.rateCalculation, 
                                    StageTwoCategoryPercentage: 2.3, 
                                    StageTwoCategorySAWApE: entry.values.extrapolationMethod, 
                                    StageTwoCategorySpecificWe: entry.values.useWeights, 
                                    StageTwoDefaultPayment: entry.values.includeInterestDefaultPayments, 
                                    calculateTwelveMonthsPD: entry.values.calculateTwelveMonthsPD,
                                    max : 100,
                                    min : 1,
                                    percentage : entry.values.periods,
                                    weights : entry.values.weights
                                }

                            }
                        }

                        // now categorysPDObj has your scenario’s values where IDs matched
                    }
                    else{
                        setStageTwoScenarioModel(senarioPDdata.model)
                        setStageTwoCategorization(senarioPDdata.categorize)
                        setStageTwoPDInpt(senarioPDdata.global.rateCalculation)
                        setStageTwoPDCalculation(senarioPDdata.global.frequency)
                        setStageTwoNumberOfPeriods(senarioPDdata.global.periods)
                        setStageTwoLoanSect(senarioPDdata.global.baseValuePostPeriodOne)
                        setStageTwoDefaultPayment(senarioPDdata.global.includeInterestDefaultPayments)
                        setStageTwoCalCulPD(senarioPDdata.global.calculateTwelveMonthsPD)
                        setStageTwoConsiderPerd(senarioPDdata.global.considerAsPeriodOne)
                        setStageTwoExtraploation(senarioPDdata.global.extrapolationForMissingPeriod)
                        setStageTwoSAWApE(senarioPDdata.global.extrapolationMethod)
                        setStageTwoPercentage(senarioPDdata.global.extrapolationPercentage)
                        setStageTwoSpecificWe(senarioPDdata.global.useWeights)
                        setlistOfYears(senarioPDdata.global.weights)
                        setStageTwoMulpliyPDSelect(senarioPDdata.global.addOrMultiplyFactor)
                        setStageTwoMulpliyPDInpt(senarioPDdata.global.addOrMultiplyPercentage)
                    }

                    if(senarioLGDdata.categorize === 'Yes'){

                        setStageThreeCategorization('Yes')

                        const newObj = { ...categorysLGDObj };

                        for (let i = 0; i < senarioData.lgd.categorized.length; i++) {
                            const entry = senarioData.lgd.categorized[i];
                            const key = entry.subcategoryID;

                            if (newObj[key] && entry.values) {
                                // entry.values['badDebtConsider'] = 'No';
                                newObj[key] = {
                                ...newObj[key],
                                values: entry.values,
                                };
                            }
                        }

                        setcategorysLGDObj(newObj);

                        // now categorysPDObj has your scenario’s values where IDs matched
                    }
                    else{
                        setStageThreeScenarioModel(senarioLGDdata.model)
                        setStageThreeCategorization(senarioLGDdata.categorize)
                        setStageThreeComputeLoss(senarioLGDdata.global.computeLossOn)
                        setconsiderInterestEMIDelayedPayment(senarioLGDdata.global.considerInterestEMIDelayedPayment)
                        setconsiderPenalCharges(senarioLGDdata.global.considerPenalCharges)
                        setconsiderRecoveryCharges(senarioLGDdata.global.considerRecoveryCharges)
                        setonlyActiveNPA(senarioLGDdata.global.onlyActiveNPA)
                        setwrittenOffOnly(senarioLGDdata.global.writtenOffOnly)
                        setconsiderSecurityValue(senarioLGDdata.global.considerSecurityValue)
                        setconsiderSecondarySecurity(senarioLGDdata.global.considerSecondarySecurity)
                        setbaseValuePrimarySecurity(senarioLGDdata.global.baseValuePrimarySecurity)
                        setbaseValueSecondarySecurity(senarioLGDdata.global.baseValueSecondarySecurity)
                        setpercentageOfPrimarySecurity(senarioLGDdata.global.percentageOfPrimarySecurity)
                        setpercentageOfSecondarySecurity(senarioLGDdata.global.percentageOfSecondarySecurity)
                        // setbadDebtConsider(senarioLGDdata.global.badDebtConsider)
                        setoverlayFactorCount(senarioLGDdata.global.overlayFactor?.length)
                        setoverlayFactorDataList(senarioLGDdata.global.overlayFactor)
                    }


                    if(senarioFLFdata.categorize === 'Yes'){

                        setStageFourCategorization('Yes')

                        // fetchCategoryData(false,companyID,senarioFLFdata.categorized);
                        for (let i = 0; i < senarioData.flf.categorized.length; i++) {
                            const entry = senarioData.flf.categorized[i];
                            const key = entry.subcategoryID;

                            if (categorysFLFObj[key] && entry.values) {

                                categorysFLFObj[key].values = {};
                                categorysFLFObj[key].values['factors'] = entry.values.factors;
                                categorysFLFObj[key].values.factorsCount = entry.values.factors.length;
                            }

                        }
                    }
                    else{
                        setStageFourfactorsCount(senarioFLFdata.global.factors?.length)
                        setStageFourCategorization(senarioFLFdata.categorize)
                        setStageFourfactors(senarioFLFdata.global.factors)
                    }
                    
                })
                    .catch(error => {
                    swal("Error", error.response?.data?.error || "fetching error while get update data !", 'error');
                });
            }
        }

    const PDCalculationInpts = useRef([]);

    // it store the input values in the useRef
    function setUseRefIntoInput(InptElement, index) {
        if (InptElement) {
            PDCalculationInpts.current[index] = InptElement;
        } else {
            // Clear the ref if the input is removed (when range is decreased)
            PDCalculationInpts.current[index] = null;
        }

        // Optional cleanup: trim the ref array length if needed
        PDCalculationInpts.current = PDCalculationInpts.current.slice(0, StageTwoNumberOfPeriods);
    }


    const getPdInputVals = () => {
        
        const values = PDCalculationInpts.current
            .filter(Boolean) // Remove nulls
            .map((input, i) => ({
                period: (i + 1).toString(),
                percentage: parseFloat(input.value) || 0
            }));
        
        setlistOfYears(values)
        return values;
        
    };


    useEffect(() => {
            getPdInputVals();
    }, [StageTwoNumberOfPeriods]); // when this state update use effect will be trigered

    // =========================
    // finall object data 

    const [finallObjectData, setfinallObjectData] = useState()

    // Review page tabs states
    
    const [stageFourActiveTab, setstageFourActiveTab] = useState()
    const [stageTwoActiveTab, setstageTwoActiveTab] = useState()
    const [stageThreeActiveTab, setstageThreeActiveTab] = useState()

    // activing the first tab in review & submit page FLF
    useEffect(() => {
        if (finallObjectData?.flf?.categorized?.length > 0) {
            setstageFourActiveTab(0);
        }
    }, [finallObjectData?.flf?.categorized]);
    
    useEffect(() => {
        if (finallObjectData?.pd?.categorized?.length > 0) {
            setstageTwoActiveTab(0);
        }
    }, [finallObjectData?.pd?.categorized]);

    useEffect(() => {
        if (finallObjectData?.lgd?.categorized?.length > 0) {
            setstageThreeActiveTab(0);
        }
    }, [finallObjectData?.lgd?.categorized]);

    const [companyName, setcompanyName] = useState('');  // company name

    return (
        <div style={{ display: 'flex' }} className={eclCss.custmfadein}>
            <CompanyEditSideMenu 
                activeTab={'Accounting Policies'} 
                companyID={companyID}
                companyDataCheck={true}
                setcompanyName={setcompanyName}
            />

            <div className={eclCss.mainContainer}>

                <EclHeader 
                    companyID={companyID}
                    createOrupdate={createOrupdate}
                    scenarioId={scenarioId}
                    ActiveStage={ActiveStage}
                    setActiveStage={setActiveStage}
                    companyName={companyName}
                    StageOneScenarioName={StageOneScenarioName}
                />
                
                <StageNumberBadge 
                    ActiveStage={ActiveStage}
                    setActiveStage={setActiveStage}
                />

                {
                    ActiveStage === 1 ? 

                        <div className={ [1, 2, 3, 4, 5].includes(ActiveStage) ? eclCss.subContainer : eclCss.subCatgeoryContainer}>
                            <div className={
                                [1, 2, 3, 4, 5].includes(ActiveStage)
                                    ? eclCss.stagesContantHoldContainer
                                    : eclCss.stagesTwoCategoryContantHoldContainerNoMargTp
                                }>
                                <StageOne 
                                    className={eclCss.custmfadein}
                                    StageOneScenarioName={StageOneScenarioName}
                                    setStageOneScenarioName={setStageOneScenarioName}

                                    StageOneScenarioApproach = {StageOneScenarioApproach}
                                    setStageOneScenarioApproach = {setStageOneScenarioApproach}
                                /> 
                            </div>
                        </div>
                    
                    :
                    
                    ActiveStage === 2 ? 

                        <div className={ [1, 2, 3, 4, 5].includes(ActiveStage) ? eclCss.subContainer : eclCss.subCatgeoryContainer}>
                            <div className={
                                [1, 2, 3, 4, 5].includes(ActiveStage)
                                    ? eclCss.stagesContantHoldContainer
                                    : eclCss.stagesTwoCategoryContantHoldContainerNoMargTp
                                }>
                                    <StageTwo    
                                        ActiveStage = {ActiveStage} 
                                        setActiveStage = {setActiveStage}

                                        StageTwoScenarioModel={StageTwoScenarioModel}
                                        setStageTwoScenarioModel={setStageTwoScenarioModel}
                                        StageTwoCategorization={StageTwoCategorization}
                                        setStageTwoCategorization={setStageTwoCategorization}
                                        // StageTwoUnDrawnCommitment={StageTwoUnDrawnCommitment}
                                        // setStageTwoUnDrawnCommitment={setStageTwoUnDrawnCommitment}
                                        StageTwoPDInpt={StageTwoPDInpt}
                                        setStageTwoPDInpt={setStageTwoPDInpt}
                                        // StageTwoPayments={StageTwoPayments}
                                        // setStageTwoPayments={setStageTwoPayments}
                                        StageTwoPDCalculation={StageTwoPDCalculation}
                                        setStageTwoPDCalculation={setStageTwoPDCalculation}
                                        StageTwoNumberOfPeriods={StageTwoNumberOfPeriods}
                                        setStageTwoNumberOfPeriods={setStageTwoNumberOfPeriods}
                                        StageTwoLoanSect={StageTwoLoanSect}
                                        setStageTwoLoanSect={setStageTwoLoanSect}
                                        StageTwoCalCulPD={StageTwoCalCulPD}
                                        setStageTwoCalCulPD={setStageTwoCalCulPD}
                                        StageTwoDefaultPayment={StageTwoDefaultPayment}
                                        setStageTwoDefaultPayment={setStageTwoDefaultPayment}
                                        StageTwoConsiderPerd={StageTwoConsiderPerd}
                                        setStageTwoConsiderPerd={setStageTwoConsiderPerd}
                                        StageTwoExtraploation={StageTwoExtraploation}
                                        setStageTwoExtraploation={setStageTwoExtraploation}
                                        StageTwoSAWApE={StageTwoSAWApE}
                                        setStageTwoSAWApE={setStageTwoSAWApE}
                                        StageTwoPercentage={StageTwoPercentage}
                                        setStageTwoPercentage={setStageTwoPercentage}
                                        StageTwoSpecificWe={StageTwoSpecificWe}
                                        setStageTwoSpecificWe={setStageTwoSpecificWe}

                                        StageTwoMulpliyPDSelect={StageTwoMulpliyPDSelect}
                                        setStageTwoMulpliyPDSelect={setStageTwoMulpliyPDSelect}
                                        StageTwoMulpliyPDInpt={StageTwoMulpliyPDInpt}
                                        setStageTwoMulpliyPDInpt={setStageTwoMulpliyPDInpt}

                                        // createObjForData={createObjForData}

                                        PDCalculationInpts={PDCalculationInpts}
                                        setUseRefIntoInput={setUseRefIntoInput}
                                        getPdInputVals={getPdInputVals}
                                        stageTwoOptions={stageTwoOptions}
                                        stageTwoOptionsAddOrMulti={stageTwoOptionsAddOrMulti}

                                        stageTwoMin={stageTwoMin}
                                        stageTwoMax={stageTwoMax}
                                        stageTwoPercentage={stageTwoPercentage}
                                        listOfYears={listOfYears}
                                    />
                            </div>
                        </div>
                    :

                    ActiveStage === 'C2' ? 
                                
                        <React.Fragment>

                            <div className={ [1, 2, 3, 4, 5].includes(ActiveStage) ? eclCss.subContainer : eclCss.subCatgeoryContainer_}>
                                    <div className={
                                        [1, 2, 3, 4, 5].includes(ActiveStage)
                                            ? eclCss.stagesContantHoldContainer
                                            : eclCss.stagesTwoCategoryContantHoldContainerNoMargTp
                                        }>

                                    <StageTwoCategoryHeader
                                        StageTwoCategoryScenarioModel = {StageTwoCategoryScenarioModel}
                                        setStageTwoCategoryScenarioModel = {setStageTwoCategoryScenarioModel}
                                        StageTwoCategoryoptions={StageTwoCategoryoptions}
                                        StageTwoCategoryCategorization = {StageTwoCategoryCategorization}
                                        setStageTwoCategoryCategorization={setStageTwoCategoryCategorization}
                                        ActiveStage={ActiveStage}
                                        setActiveStage={setActiveStage}
                                        setStageTwoCategorization={setStageTwoCategorization}
                                    />

                                    <StageTwoCategory 
                                        categorysPDObj={categorysPDObj}
                                        setcategorysPDObj={setcategorysPDObj}
                                        StageTwoCategoryScenarioModel = {StageTwoCategoryScenarioModel}
                                        setStageTwoCategoryScenarioModel={setStageTwoCategoryScenarioModel}
                                        StageTwoCategoryCategorization = {StageTwoCategoryCategorization}
                                        setStageTwoCategoryCategorization={setStageTwoCategoryCategorization}
                                        StageTwoCategoryPDInpt = {StageTwoCategoryPDInpt}
                                        setStageTwoCategoryPDInpt={setStageTwoCategoryPDInpt}
                                        StageTwoCategoryPDCalculation = {StageTwoCategoryPDCalculation}
                                        setStageTwoCategoryPDCalculation={setStageTwoCategoryPDCalculation}
                                        StageTwoCategoryLoanSect = {StageTwoCategoryLoanSect}
                                        setStageTwoCategoryLoanSect={setStageTwoCategoryLoanSect}
                                        StageTwoCategoryConsiderPeriod = {StageTwoCategoryConsiderPeriod}
                                        setStageTwoCategoryConsiderPeriod={setStageTwoCategoryConsiderPeriod}
                                        StageTwoCategoryExtraploation = {StageTwoCategoryExtraploation}
                                        setStageTwoCategoryExtraploation={setStageTwoCategoryExtraploation}
                                        StageTwoCategorySAWApE = {StageTwoCategorySAWApE}
                                        setStageTwoCategorySAWApE={setStageTwoCategorySAWApE}
                                        StageTwoCategoryPercentage = {StageTwoCategoryPercentage}
                                        setStageTwoCategoryPercentage={setStageTwoCategoryPercentage}
                                        StageTwoCategorySpecificWe = {StageTwoCategorySpecificWe}
                                        setStageTwoCategorySpecificWe={setStageTwoCategorySpecificWe}
                                        StageTwoCategoryMulpliyPDSelect = {StageTwoCategoryMulpliyPDSelect}
                                        setStageTwoCategoryMulpliyPDSelect={setStageTwoCategoryMulpliyPDSelect}
                                        StageTwoCategoryMulpliyPDInpt = {StageTwoCategoryMulpliyPDInpt}
                                        setStageTwoCategoryMulpliyPDInpt={setStageTwoCategoryMulpliyPDInpt}
                                        StageTwoCategoryoptions={StageTwoCategoryoptions}
                                        optionsMultiplePDPercentage={optionsMultiplePDPercentage}
                                        StageTwoActiveCategory={StageTwoActiveCategory}
                                        setStageTwoActiveCategory={setStageTwoActiveCategory}
                                        categorysData={categorysData}
                                    /> 
                                </div>
                            </div>
                        </React.Fragment>
                    
                    :

                    ActiveStage === 3 ? 
                    
                        <div className={ [1, 2, 3, 4, 5].includes(ActiveStage) ? eclCss.subContainer : eclCss.subCatgeoryContainer}>
                            <div className={
                                [1, 2, 3, 4, 5].includes(ActiveStage)
                                    ? eclCss.stagesContantHoldContainer
                                    : eclCss.stagesTwoCategoryContantHoldContainerNoMargTp
                                }>

                                <StageThree     
                                    ActiveStage={ActiveStage}
                                    setActiveStage={setActiveStage}

                                    StageThreeScenarioModel={StageThreeScenarioModel}
                                    setStageThreeScenarioModel={setStageThreeScenarioModel}
                                    StageThreeCategorization={StageThreeCategorization}
                                    setStageThreeCategorization={setStageThreeCategorization}
                                    leftItems={leftItems}
                                    setLeftItems={setLeftItems}     
                                    rightItems={rightItems}
                                    setRightItems={setRightItems}
                                    StageThreeComputeLoss={StageThreeComputeLoss}
                                    setStageThreeComputeLoss={setStageThreeComputeLoss}

                                    StageThreeOptions={StageThreeOptions}

                                    considerInterestEMIDelayedPayment={considerInterestEMIDelayedPayment}
                                    setconsiderInterestEMIDelayedPayment={setconsiderInterestEMIDelayedPayment}
                                    considerPenalCharges={considerPenalCharges}
                                    setconsiderPenalCharges={setconsiderPenalCharges}
                                    considerRecoveryCharges={considerRecoveryCharges} 
                                    setconsiderRecoveryCharges={setconsiderRecoveryCharges}
                                    onlyActiveNPA={onlyActiveNPA} 
                                    setonlyActiveNPA={setonlyActiveNPA}
                                    writtenOffOnly={writtenOffOnly} 
                                    setwrittenOffOnly={setwrittenOffOnly}
                                    considerSecurityValue={considerSecurityValue} 
                                    setconsiderSecurityValue={setconsiderSecurityValue}
                                    considerSecondarySecurity={considerSecondarySecurity}
                                    setconsiderSecondarySecurity={setconsiderSecondarySecurity}
                                    baseValuePrimarySecurity={baseValuePrimarySecurity} 
                                    setbaseValuePrimarySecurity={setbaseValuePrimarySecurity}
                                    baseValueSecondarySecurity={baseValueSecondarySecurity}
                                    setbaseValueSecondarySecurity={setbaseValueSecondarySecurity}
                                    percentageOfPrimarySecurity={percentageOfPrimarySecurity}
                                    setpercentageOfPrimarySecurity={setpercentageOfPrimarySecurity}
                                    percentageOfSecondarySecurity={percentageOfSecondarySecurity}
                                    setpercentageOfSecondarySecurity={setpercentageOfSecondarySecurity}
                                    // badDebtConsider={badDebtConsider}
                                    // setbadDebtConsider={setbadDebtConsider}
                                    addOverlayFactor={addOverlayFactor}
                                    setaddOverlayFactor={setaddOverlayFactor}
                                    overlayFactorCount={overlayFactorCount}
                                    setoverlayFactorCount={setoverlayFactorCount}
                                    overlayFactorsRef={overlayFactorsRef}
                                    saveOveryLayFactores={saveOveryLayFactores}
                                    overlayFactorDataList={overlayFactorDataList}
                                    setoverlayFactorDataList={setoverlayFactorDataList}
                                    /> 
                            </div>
                        </div>
                                        
                    :
                    
                    ActiveStage === 'C3' ? 

                        <div className={ [1, 2, 3, 4, 5].includes(ActiveStage) ? eclCss.subContainer : eclCss.subCatgeoryContainer}>
                            <div className={
                                [1, 2, 3, 4, 5].includes(ActiveStage)
                                    ? eclCss.stagesContantHoldContainer
                                    : eclCss.stagesTwoCategoryContantHoldContainerNoMargTp
                                }>

                                <StageThreeCategoryHeader
                                    StageTwoCategoryScenarioModel = {StageTwoCategoryScenarioModel}
                                    setStageTwoCategoryScenarioModel = {setStageTwoCategoryScenarioModel}
                                    StageTwoCategoryoptions={StageTwoCategoryoptions}
                                    StageTwoCategoryCategorization = {StageTwoCategoryCategorization}
                                    setStageTwoCategoryCategorization={setStageTwoCategoryCategorization}
                                    ActiveStage={ActiveStage}
                                    setActiveStage={setActiveStage}
                                    setStageThreeCategorization={setStageThreeCategorization}
                                />

                                <StageThreeCategory 
                                    categorysData={categorysData}
                                    categorysLGDObj={categorysLGDObj}
                                    setcategorysLGDObj={setcategorysLGDObj}
                                    StageTwoCategoryCategorization = {StageTwoCategoryCategorization}
                                    setStageTwoCategoryCategorization={setStageTwoCategoryCategorization}
                                    StageThreeActiveCategory={StageThreeActiveCategory}
                                    setStageThreeActiveCategory={setStageThreeActiveCategory}
                                /> 
                            </div>
                        </div>
                        
                    :

                    ActiveStage === 4 ? 

                        <div className={ [1, 2, 3, 4, 5].includes(ActiveStage) ? eclCss.subContainer : eclCss.subCatgeoryContainer}>
                            <div className={
                                [1, 2, 3, 4, 5].includes(ActiveStage)
                                    ? eclCss.stagesContantHoldContainer
                                    : eclCss.stagesTwoCategoryContantHoldContainerNoMargTp
                                }>
                                <StageFour 
                                    ActiveStage={ActiveStage}
                                    setActiveStage={setActiveStage}
                                    StageFourfactorsCount={StageFourfactorsCount} 
                                    setStageFourfactorsCount={setStageFourfactorsCount}
                                    StageFourfactors={StageFourfactors} 
                                    setStageFourfactors={setStageFourfactors}
                                    StageFourCategorization={StageFourCategorization} 
                                    setStageFourCategorization={setStageFourCategorization}
                                /> 
                            </div>
                        </div>
                    :
                    
                    ActiveStage === 'C4' ? 
                    
                        <div className={ [1, 2, 3, 4, 5].includes(ActiveStage) ? eclCss.subContainer : eclCss.subCatgeoryContainer}>
                            <div className={
                                [1, 2, 3, 4, 5].includes(ActiveStage)
                                    ? eclCss.stagesContantHoldContainer
                                    : eclCss.stagesTwoCategoryContantHoldContainerNoMargTp
                                }>

                                <StageFourCategoryHeader 
                                    ActiveStage={ActiveStage}
                                    setActiveStage={setActiveStage}
                                    setStageFourCategorization={setStageFourCategorization}
                                />

                                <StageFourCategory 
                                    StageFourActiveCategory={StageFourActiveCategory}
                                    setStageFourActiveCategory={setStageFourActiveCategory}
                                    setStageThreeActiveCategory={setStageThreeActiveCategory}
                                    categorysData={categorysData}
                                    categorysFLFObj={categorysFLFObj}
                                    setcategorysFLFObj={setcategorysFLFObj}
                                />
                            </div>
                        </div>

                    :

                    ActiveStage === 5 ? 
                    
                        <div className={ [1, 2, 3, 4, 5].includes(ActiveStage) ? eclCss.subContainerReviewAndSubmit : eclCss.subCatgeoryContainer}>
                            <div className={
                                [1, 2, 3, 4, 5].includes(ActiveStage)
                                ? eclCss.stagesContantHoldContainer
                                : eclCss.stagesTwoCategoryContantHoldContainerNoMargTp
                            }>
                                <StageFive
                                    finallObjectData={finallObjectData} 
                                    setfinallObjectData={setfinallObjectData}
                                    stageFourActiveTab={stageFourActiveTab} 
                                    setstageFourActiveTab={setstageFourActiveTab}
                                    stageTwoActiveTab={stageTwoActiveTab} 
                                    setstageTwoActiveTab={setstageTwoActiveTab}
                                    stageThreeActiveTab={stageThreeActiveTab} 
                                    setstageThreeActiveTab={setstageThreeActiveTab}
                                    categorysData={categorysData}
                                /> 
                            </div>
                        </div>
                    
                    :
                    null
                }
            
                <EclFooter
                    finallObjectData={finallObjectData}
                    setfinallObjectData = {setfinallObjectData}
                    scenarioId={scenarioId}
                    createOrupdate={createOrupdate}
                    StageTwoCategorization={StageTwoCategorization}
                    StageThreeCategorization={StageThreeCategorization}
                    StageFourCategorization={StageFourCategorization}

                    companyID={companyID}
                    setCompanyID={setCompanyID}

                    ActiveStage={ActiveStage}
                    setActiveStage={setActiveStage}

                    stageOneWholeData={stageOneWholeData}
                    setstageOneWholeData={setstageOneWholeData}

                    stageTwoWholeData={stageTwoWholeData}
                    setstageTwoWholeData={setstageTwoWholeData}

                    stageTwoCategoryWholeData={stageTwoCategoryWholeData}
                    setstageTwoCategoryWholeData={setstageTwoCategoryWholeData}

                    stageThreeWholeData={stageThreeWholeData}
                    setstageThreeWholeData={setstageThreeWholeData}

                    stageThreeCategoryWholeData={stageThreeCategoryWholeData}
                    setstageThreeCategoryWholeData={setstageThreeCategoryWholeData}

                    stageFourWholeData={stageFourWholeData}
                    setstageFourWholeData={setstageFourWholeData}

                    stageFourCategoryWholeData={stageFourCategoryWholeData}
                    setstageFourWholeCategoryData={setstageFourWholeCategoryData}
                />

            </div>
        </div>
    );
};

export default CreateLoansEclScenario;


const StageOne = ({ 
    StageOneScenarioName,
    setStageOneScenarioName,

    StageOneScenarioApproach, 
    setStageOneScenarioApproach

    }) => {
        
    return(
        <div className={`${eclCss.stage1MainContainer} ${eclCss.custmfadein}`}>
            <div className={eclCss.stage1SubContainer}>
                
                <div>
                    <span className={eclCss.scenarioLabelClr}>Scenario Name</span>
                    <input className={eclCss.scenarioName} type="text" name="" id="" 
                        value={StageOneScenarioName}
                        onChange={(e) => setStageOneScenarioName(e.target.value)}
                        placeholder='Type scenario name'
                        style={{ marginTop : '0px !important' }}
                    />
                </div>
                
                <div className={eclCss.approchContainer}>
                    <span className={eclCss.scenarioLabelClr}>IndAS Provisioning</span>
                    <div className={eclCss.radioContainer}>

                        <label style={{ marginRight: '30px' }} className={eclCss.LabelContant} onClick={() => {setStageOneScenarioApproach('simplifiedApproach')}}>
                                {StageOneScenarioApproach === 'simplifiedApproach' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                            Simplified Approach
                        </label>

                        <label className={eclCss.LabelContant} onClick={() => {setStageOneScenarioApproach('generalApproach')}}>
                                {StageOneScenarioApproach === 'generalApproach' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} /> : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                            General Approach
                        </label>

                    </div>
                </div>

                <div className={eclCss.infoStage1}>
                    <div className={eclCss.infoStageBox}>
                        <div className={eclCss.stage1IconBox}>
                            <QuestionMartInfo />
                        &nbsp; &nbsp;
                        </div>
                        <div className={eclCss.stage1InfoText}>
                            Lorem ipsum dolor sit amet consectetur. Vivamus scelerisque orci et pellentesque nunc ut
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    )
    
}


const StageTwo = ({
    listOfYears,
    ActiveStage,
    setActiveStage,

    StageTwoScenarioModel,
    setStageTwoScenarioModel,
    StageTwoCategorization,
    setStageTwoCategorization,
    StageTwoPDInpt,
    setStageTwoPDInpt,
    StageTwoPDCalculation,
    setStageTwoPDCalculation,
    StageTwoNumberOfPeriods,
    setStageTwoNumberOfPeriods,
    StageTwoLoanSect,
    setStageTwoLoanSect,
    StageTwoCalCulPD,
    setStageTwoCalCulPD,
    StageTwoDefaultPayment,
    setStageTwoDefaultPayment,
    StageTwoConsiderPerd,
    setStageTwoConsiderPerd,
    StageTwoExtraploation,
    setStageTwoExtraploation,
    StageTwoSAWApE,
    setStageTwoSAWApE,
    StageTwoPercentage,
    setStageTwoPercentage,
    StageTwoSpecificWe,
    setStageTwoSpecificWe,

    StageTwoMulpliyPDSelect,
    setStageTwoMulpliyPDSelect,
    StageTwoMulpliyPDInpt,
    setStageTwoMulpliyPDInpt,

    PDCalculationInpts,
    setUseRefIntoInput,
    getPdInputVals,

    stageTwoOptions,
    stageTwoOptionsAddOrMulti,
    stageTwoMin,
    stageTwoMax,
    stageTwoPercentage,
    }) => {

    const initialLeftItems = [
        { id: '1', heading: 'Category 1', desc: 'Home Loans › Salaried'},
        { id: '2', heading: 'Category 2', desc: 'Car Loans › Salaried'},
        { id: '3', heading: 'Category 3', desc: 'Education Loans › Salaried'},
    ];

    const initialRightItems = [
        { id: '4', heading: 'Posible Category', desc: 'Home Loans › Salaried', active : 'Y' },
        { id: '5', heading: 'Posible Category', desc: 'Car Loans › Salaried', active : 'Y' },
        { id: '6', heading: 'Posible Category', desc: 'Education Loans › Salaried', active : 'Y' },
    ];

    const [leftItems, setLeftItems] = useState(initialLeftItems);
    const [rightItems, setRightItems] = useState(initialRightItems);

    function onDragEnd(result) {
        const { source, destination } = result;
        if (!destination) return;

        // If dropped in the same list
        if (source.droppableId === destination.droppableId) {
        const items = source.droppableId === 'left' ? Array.from(leftItems) : Array.from(rightItems);
        const [moved] = items.splice(source.index, 1);
        items.splice(destination.index, 0, moved);

        if (source.droppableId === 'left') {
            setLeftItems(items);
        } else {
            setRightItems(items);
        }
        return;
        }

        // Moving between different lists
        const sourceList = source.droppableId === 'left' ? Array.from(leftItems) : Array.from(rightItems);
        const destList = destination.droppableId === 'left' ? Array.from(leftItems) : Array.from(rightItems);

        const [movedItem] = sourceList.splice(source.index, 1);
        destList.splice(destination.index, 0, movedItem);

        if (source.droppableId === 'left') {
            setLeftItems(sourceList);
            setRightItems(destList);
        } else {
            setRightItems(sourceList);
            setLeftItems(destList);
        }
    }

    const options = [
        { value: 'Vintage Model', label: 'PD - Vintage Model' },
    ];

    return(
        <div className={`${eclCss.stage2Container} ${eclCss.custmfadein}`}>

            <DragDropContext onDragEnd={onDragEnd}>
                <div className={eclCss.stageLeftContainer}>
                    
                    <div className={`${eclCss.stageLeftSubContainer}`}>
                        <div className={eclCss.stagelabel}>Model</div>
                        <Select
                            defaultValue={stageTwoOptions[0]}
                            components={{ IndicatorSeparator: () => null }} // remove separator
                            onChange={(selectedOption) => setStageTwoScenarioModel(selectedOption)}
                            options={stageTwoOptions}
                            placeholder="Select Status"
                            name="status"
                            className={`w-100 mt-0 ${eclCss.selectstyl}`}
                            classNamePrefix="select"
                            styles={customStyles}
                            isClearable={false}
                            isSearchable={false}
                        />
                    </div>

                    {/* Hide and un hide left container */}

                    {/* <div className={ `${StageTwoCategorization == 'N' ? eclCss.UnhideContainerHideCategoryContainer : eclCss.hideContainerUnHideCategoryContainer}` }> */}
                        {/* <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                            <span className={eclCss.stage2labelSide}>Include undrawn commitments?</span>
                            <div className={eclCss.stage2radioContainer}>
                                <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageTwoUnDrawnCommitment('Y')}}>
                                    <div className={eclCss.customRadioOuter}>
                                        {StageTwoUnDrawnCommitment == 'Y' ? <div className={eclCss.customRadioInner}></div> : ''}
                                    </div>
                                    YES
                                </label>

                                <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageTwoUnDrawnCommitment('N')}}>
                                    <div className={eclCss.customRadioOuter}>
                                        {StageTwoUnDrawnCommitment == 'N' ? <div className={eclCss.customRadioInner}></div> : ''}
                                    </div>
                                    NO
                                </label>
                            </div>
                        </div> */}

                        <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}>
                            <div className={eclCss.stagelabel}>PD rate calculation</div>
                            <div className={eclCss.pdsInptsContainer}>
                                <div className={`${eclCss.pdInpts} ${StageTwoPDInpt == 'count' ? eclCss.pdInptsActive : eclCss.pdInptsInActive}`} onClick={() => { setStageTwoPDInpt('count') }}>
                                    Count of loans
                                </div>
                                <div className={`${eclCss.pdInpts} ${StageTwoPDInpt == 'loanSanctionedValue' ? eclCss.pdInptsActive : eclCss.pdInptsInActive}`} onClick={() => { setStageTwoPDInpt('loanSanctionedValue') }}>
                                    Loan Sanctioned Value
                                </div>
                                <div className={`${eclCss.pdInpts} ${StageTwoPDInpt == 'loanOutstandingValue' ? eclCss.pdInptsActive : eclCss.pdInptsInActive}`} onClick={() => { setStageTwoPDInpt('loanOutstandingValue') }}>
                                    Loan Outstanding Value
                                </div>
                                <div className={`${eclCss.pdInpts} ${StageTwoPDInpt == 'loanDisbursedValue' ? eclCss.pdInptsActive : eclCss.pdInptsInActive}`} onClick={() => { setStageTwoPDInpt('loanDisbursedValue') }}>
                                    Loan disbursed value
                                </div>
                            </div>
                        </div>
                        
                        <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}>
                            <div className={eclCss.infoStage2}>
                                <div className={eclCss.infoStageBox}>
                                    <div className={eclCss.stage1IconBox}>
                                        <QuestionMartInfo />
                                    &nbsp; &nbsp;
                                    </div>
                                    <div className={eclCss.stage1InfoText}>
                                        Lorem ipsum dolor sit amet consectetur. Vivamus scelerisque orci et pellentesque nunc ut
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                            <span className={eclCss.stage2labelSide}>Include interest on defaulted payments?</span>
                            <div className={eclCss.stage2radioContainer}>
                                <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageTwoPayments('Y')}}>
                                    <div className={eclCss.customRadioOuter}>
                                        {StageTwoPayments == 'Y' ? <div className={eclCss.customRadioInner}></div> : ''}
                                    </div>
                                    YES
                                </label>
                                <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageTwoPayments('N')}}>
                                    <div className={eclCss.customRadioOuter}>
                                        {StageTwoPayments == 'N' ? <div className={eclCss.customRadioInner}></div> : ''}
                                    </div>
                                    NO
                                </label>
                            </div>
                        </div> */}

                        <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}>
                            <div className={eclCss.stagelabel}>Frequency for PD Calculation</div>
                            <div className={eclCss.pdsInptsContainer}>
                                <div className={`${eclCss.pdInpts} ${eclCss.mr10} ${StageTwoPDCalculation == 'yearly' ? eclCss.pdInptsActive : eclCss.pdInptsInActive}`} onClick={() => { setStageTwoPDCalculation('yearly') }}>
                                    Yearly Basis
                                </div>
                                <div className={`${eclCss.pdInpts} ${eclCss.mr10} ${StageTwoPDCalculation == 'quarterly' ? eclCss.pdInptsActive : eclCss.pdInptsInActive}`} onClick={() => { setStageTwoPDCalculation('quarterly') }}>
                                    Quarterly Basis
                                </div>
                                <div className={`${eclCss.pdInpts} ${StageTwoPDCalculation == 'monthly' ? eclCss.pdInptsActive : eclCss.pdInptsInActive}`} onClick={() => { setStageTwoPDCalculation('monthly') }}>
                                    Monthly Basis
                                </div>
                            </div>
                        </div>

                        <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}>
                            <div className={eclCss.stagelabel}>How many periods to consider?</div>
                            <div className={eclCss.pdsInptsContainer}>
                                <input
                                    type="range"
                                    min={stageTwoMin}
                                    max={stageTwoMax}
                                    value={StageTwoNumberOfPeriods}
                                    data-value={StageTwoNumberOfPeriods}
                                    onChange={(e) => {
                                        const val = Number(e.target.value);
                                        setStageTwoNumberOfPeriods(val);
                                    }}
                                    style={{
                                        background: `linear-gradient(to right, #3AB67D ${stageTwoPercentage}%, #CCD5D3 ${stageTwoPercentage}%)`,
                                        '--percent': `${stageTwoPercentage}%`,


                                    }}
                                    className={eclCss.slider}
                                />
                                <div className={eclCss.custNumInptContainer}>
                                    <div className={eclCss.custInptBox}>
                                        {/* <input className={eclCss.custInpt}  type="number" name="" id="" value={10} onChange={() => {e.this.value(setStageTwoNumberOfPeriods(value))}} /> */}
                                       
                                        <input
                                            className={eclCss.custInpt}
                                            type="text"
                                            value={`${StageTwoNumberOfPeriods} years`}
                                            onChange={(e) => {
                                                const numberOnly = e.target.value.replace(/[^\d]/g, '');
                                                setStageTwoNumberOfPeriods(Number(numberOnly));
                                            }}
                                        />

                                    </div>
                                    <div className={eclCss.custInptIncDescContainer}>
                                        <div className={eclCss.custInptNumUpArrCont}><NumUpArrow className={eclCss.custInptNumSvg}/></div>
                                        <div className={eclCss.custInptNumDowArrCont}><NumDownArrow className={eclCss.custInptNumSvg} /></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}>
                            <div className={eclCss.stagelabel}>Best value for PD calculation post period-1</div>
                            <div className={eclCss.pdsInptsContainer}>
                                <div className={`${eclCss.pdInpts} ${eclCss.mr10} ${StageTwoLoanSect == 'total' ? eclCss.pdInptsActive : eclCss.pdInptsInActive}`} onClick={() => { setStageTwoLoanSect('total') }}>
                                    Total Loans
                                </div>
                                <div className={`${eclCss.pdInpts} ${StageTwoLoanSect == 'nonDefault' ? eclCss.pdInptsActive : eclCss.pdInptsInActive}`} onClick={() => { setStageTwoLoanSect('nonDefault') }}>
                                    Non-default Loans
                                </div>
                            </div>
                        </div>
                        
                        <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                            <span className={eclCss.stage2labelSide}>Include interest on default payments?</span>
                            <div className={eclCss.stage2radioContainer}>
                                <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageTwoDefaultPayment('Yes')}}>
                                    {/* <div className={eclCss.customRadioOuter}>
                                        {StageTwoDefaultPayment === 'Yes' ? <div className={eclCss.customRadioInner}></div> : ''}
                                    </div> */}
                                    {StageTwoDefaultPayment === 'Yes' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                    YES
                                </label>

                                <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageTwoDefaultPayment('No')}}>
                                    {/* <div className={eclCss.customRadioOuter}>
                                        {StageTwoDefaultPayment === 'No' ? <div className={eclCss.customRadioInner}></div> : ''}
                                    </div> */}
                                    {StageTwoDefaultPayment === 'No' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                    NO
                                </label>
                            </div>
                        </div>

                        <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                            <span className={eclCss.stage2labelSide}>Do you want calculate 12 months PD?</span>
                            <div className={eclCss.stage2radioContainer}>
                                <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageTwoCalCulPD('Yes')}}>
                                    {/* <div className={eclCss.customRadioOuter}>
                                        {StageTwoCalCulPD === 'Yes' ? <div className={eclCss.customRadioInner}></div> : ''}
                                    </div> */}
                                    {StageTwoCalCulPD === 'Yes' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                    YES
                                </label>

                                <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageTwoCalCulPD('No')}}>
                                    {/* <div className={eclCss.customRadioOuter}>
                                        {StageTwoCalCulPD === 'No' ? <div className={eclCss.customRadioInner}></div> : ''}
                                    </div> */}
                                    {StageTwoCalCulPD === 'No' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                    NO
                                </label>
                            </div>
                        </div>
                    {/* </div> */}
                    
                    {/* Left Category Container Drag and Drop */}
                    {/* <div className={ `${StageTwoCategorization == 'Y' ? eclCss.UnhideContainerHideCategoryContainer : eclCss.hideContainerUnHideCategoryContainer}` }>

                        <div className={`${eclCss.defineCatgegorysContainer}`}>
                            <div className={eclCss.stagelabel}>Define Categories</div>
                            <Droppable droppableId="left">
                                {(provided) => (
                                    <div className={`${eclCss.defineCardsContainer}`} ref={provided.innerRef} {...provided.droppableProps}>

                                        {leftItems.map((item, index) => (
                                            <Draggable key={item.id} draggableId={item.id} index={index}>
                                                {(provided) => (
                                                    <div className={eclCss.defineCategorycardContainer}  ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} >
                                                        <div className={eclCss.defineCategoryCardHead}>{item.heading}</div>
                                                        <div className={eclCss.defineCategoryCardDesc}>
                                                            <div>
                                                                {item.desc}
                                                            </div> 
                                                        </div>
                                                    </div>
                                                )}
                                            </Draggable>
                                        ))}
                                
                                </div>
                                )}
                            </Droppable>
                            <div className={eclCss.defineCategoryBTNContainer}>
                                <button type="button" onClick={()=>{setActiveStage('C2')}} className={eclCss.defineCategoryPDBtn}>Define PD</button>
                            </div>
                        </div>

                    </div> */}

                </div>

            {/* seprator */}

            <div className={eclCss.containerSeprator}></div>

            <div className={eclCss.stage2RightContainer}>

                {/* <div className={ `${StageTwoCategorization == 'N' ? eclCss.UnhideContainerHideCategoryContainer : eclCss.hideContainerUnHideCategoryContainer}`}> */}

                    <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                        <span className={eclCss.stage2labelSide}>Do you want categorization?</span>
                        <div className={eclCss.stage2radioContainer}>
                            <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setActiveStage('C2'); setStageTwoCategorization('Yes');}}>
                                {/* <div className={eclCss.customRadioOuter}>
                                    {ActiveStage === Number.isInteger(ActiveStage) ? <div className={eclCss.customRadioInner}></div> : ''}
                                </div> */}
                                {ActiveStage === Number.isInteger(ActiveStage) ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                YES
                            </label>

                            <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setActiveStage(2); setStageTwoCategorization('No');}}>
                                {/* <div className={eclCss.customRadioOuter}>
                                    {ActiveStage !== Number.isInteger(ActiveStage) ? <div className={eclCss.customRadioInner}></div> : ''}
                                </div> */}
                                {ActiveStage !== Number.isInteger(ActiveStage) ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                NO
                            </label>
                        </div>
                    </div>

                    <div className={`${eclCss.stageRightSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}>
                        <div className={eclCss.stagelabel}>What should be considered as period 1?</div>
                        <div className={eclCss.pdsInptsContainer}>
                            <div className={`${eclCss.pdInpts} ${eclCss.mr10} ${StageTwoConsiderPerd == 'financialYear' ? eclCss.pdInptsActive : eclCss.pdInptsInActive}`} onClick={() => { setStageTwoConsiderPerd('financialYear') }}>
                                Financial Year
                            </div>
                            <div className={`${eclCss.pdInpts} ${StageTwoConsiderPerd == 'disbursementYear' ? eclCss.pdInptsActive : eclCss.pdInptsInActive}`} onClick={() => { setStageTwoConsiderPerd('disbursementYear') }}>
                                Loan disbursement Year
                            </div>
                            {/* <div className={`${eclCss.pdInpts} ${StageTwoConsiderPerd == 'LP' ? eclCss.pdInptsActive : eclCss.pdInptsInActive}`} onClick={() => { setStageTwoConsiderPerd('LP') }}>
                                Lorem ipsum
                            </div> */}
                        </div>
                    </div>

                    <div className={`${eclCss.stageRightSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}>
                        <div className={eclCss.infoStage2}>
                            <div className={eclCss.infoStageBox}>
                                <div className={eclCss.stage1IconBox}>
                                    <QuestionMartInfo />
                                &nbsp; &nbsp;
                                </div>
                                <div className={eclCss.stage1InfoText}>
                                    Lorem ipsum dolor sit amet consectetur. Vivamus scelerisque orci et pellentesque nunc ut
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                        <span className={eclCss.stage2labelSide}>Extrapolation based on past history for missing periods?</span>
                        <div className={eclCss.stage2radioContainer}>
                            <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageTwoExtraploation('Yes')}}>
                                {/* <div className={eclCss.customRadioOuter}>
                                    {StageTwoExtraploation == 'Yes' ? <div className={eclCss.customRadioInner}></div> : ''}
                                </div> */}
                                {StageTwoExtraploation === 'Yes' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                YES
                            </label>
                            <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageTwoExtraploation('No')}}>
                                {/* <div className={eclCss.customRadioOuter}>
                                    {StageTwoExtraploation == 'No' ? <div className={eclCss.customRadioInner}></div> : ''}
                                </div> */}
                                {StageTwoExtraploation === 'No' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                NO
                            </label>
                        </div>
                    </div>

                    <div className={`${eclCss.stageRightSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}>
                        <div className={eclCss.stagelabel}></div>
                        <div className={eclCss.pdsInptsContainer}>
                            <div className={`${eclCss.pdInpts} ${eclCss.mr10} ${StageTwoSAWApE == 'simpleAverage' ? eclCss.pdInptsActive : eclCss.pdInptsInActive}`} onClick={() => { setStageTwoSAWApE('simpleAverage') }}>
                                Simple Average
                            </div>
                            <div className={`${eclCss.pdInpts} ${eclCss.mr10} ${StageTwoSAWApE == 'weightedAverage' ? eclCss.pdInptsActive : eclCss.pdInptsInActive}`} onClick={() => { setStageTwoSAWApE('weightedAverage') }}>
                                Weighted Average
                            </div>
                            <div className={`${eclCss.pdInpts} ${StageTwoSAWApE == 'proportionateExtrapolation' ? eclCss.pdInptsActive : eclCss.pdInptsInActive}`} onClick={() => { setStageTwoSAWApE('proportionateExtrapolation') }}>
                                Proportionate Extrapolation
                            </div>
                        </div>
                    </div>

                    <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}>
                        <div className={eclCss.pdsInptsContainer}>
                            <div 
                                // className={eclCss.stage2labelSide}
                                className={`${eclCss.pdInpts} ${eclCss.pdInptsInActive}`}
                            >
                                Enter Percentage
                            </div>
                            <div className={ ` ${eclCss.custNumInptContainer} ${eclCss.ml0}`}>
                                <div className={eclCss.custInptBox}>
                                    <input
                                        className={eclCss.custInpt}
                                        type="text"
                                        value={StageTwoPercentage}
                                        onChange={(e) => setStageTwoPercentage(Number(e.target.value))}
                                    />
                                </div>
                                <div className={eclCss.custInptIncDescContainerRitPer}>
                                    <div className={eclCss.custInptNumUpArrCont}><PercebtageIcn/></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}>
                        <div className={eclCss.infoStage2}>
                            <div className={eclCss.infoStageBox}>
                                <div className={eclCss.stage1IconBox}>
                                    <QuestionMartInfo />
                                &nbsp; &nbsp;
                                </div>
                                <div className={eclCss.stage1InfoText}>
                                    Lorem ipsum dolor sit amet consectetur. Vivamus scelerisque orci et pellentesque nunc ut
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                        <span className={eclCss.stage2labelSide}>Do you want specific weights assigned to periods while calculating PD?</span>
                        <div className={eclCss.stage2radioContainer}>
                            <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageTwoSpecificWe('Yes')}}>
                                {/* <div className={eclCss.customRadioOuter}>
                                    {StageTwoSpecificWe == 'Yes' ? <div className={eclCss.customRadioInner}></div> : ''}
                                </div> */}
                                {StageTwoSpecificWe == 'Yes' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                YES
                            </label>
                            <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageTwoSpecificWe('No')}}>
                                {/* <div className={eclCss.customRadioOuter}>
                                    {StageTwoSpecificWe == 'No' ? <div className={eclCss.customRadioInner}></div> : ''}
                                </div> */}
                                {StageTwoSpecificWe == 'No' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                NO
                            </label>
                        </div>
                    </div>

                    <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInptGRP}`}>
                        <div className={eclCss.pdsInptsContainerGRP}>
                            
                            {[...Array(StageTwoNumberOfPeriods)].map((_, i) => (
                                <div key={i} className={eclCss.assIgnedPeriodCalculPD}>
                                    <div key={i} className={eclCss.inptLabelGrp}>
                                        Period-{i + 1}
                                    </div>
                                    <div key={i} className={eclCss.custNumInptContainerGrp}>
                                        <div key={i} className={eclCss.custInptBoxgrp}>
                                            <input
                                                key={i}
                                                ref={inptElem => setUseRefIntoInput(inptElem, i)}
                                                className={eclCss.custInpt}
                                                type="text"
                                                defaultValue={''}
                                                value={listOfYears[i]?.percentage || ''}
                                                // we call this function when user update any one values any one input we get all input values and stores in useRef
                                                onChange={(e) => {getPdInputVals()}}
                                            />
                                        </div>
                                        <div className={eclCss.custInptIncDescContainerGRP}>
                                            <div className={eclCss.custInptNumUpArrCont}>
                                                <NumUpArrow className={eclCss.custInptNumSvg} />
                                            </div>
                                            <div className={eclCss.custInptNumDowArrCont}>
                                                <NumDownArrow className={eclCss.custInptNumSvg} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}


                            {/* {[...Array(StageTwoNumberOfPeriods)].map((_, i) => (
                                <div key={i} className={eclCss.assIgnedPeriodCalculPD}>
                                <div className={eclCss.inptLabelGrp}>Year-{i + 1}</div>
                                <div className={eclCss.custNumInptContainerGrp}>
                                    <div className={eclCss.custInptBoxgrp}>
                                    <input
                                        className={eclCss.custInpt}
                                        type="text"
                                        value={periodPercentages[i]?.percentage || ""}
                                        onChange={(e) => setStageTwoNumberOfPeriods(i, e.target.value)}
                                    />
                                    </div>
                                    <div className={eclCss.custInptIncDescContainerGRP}>
                                    <div className={eclCss.custInptNumUpArrCont}>
                                        <NumUpArrow className={eclCss.custInptNumSvg} />
                                    </div>
                                    <div className={eclCss.custInptNumDowArrCont}>
                                        <NumDownArrow className={eclCss.custInptNumSvg} />
                                    </div>
                                    </div>
                                </div>
                                </div>
                            ))} */}


                        </div>
                    </div>

                    <div className={`${eclCss.stageRightSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}>
                        <div className={eclCss.stagelabel}>Add or multiply PD% by </div>
                        <div className={eclCss.pdsInptsContainer}>
                            <Select
                                defaultValue={stageTwoOptionsAddOrMulti[0]}
                                components={{ IndicatorSeparator: () => null }} // remove separator
                                value={stageTwoOptionsAddOrMulti.find(option => option.value === StageTwoMulpliyPDSelect)}
                                onChange={(selectedOption) => setStageTwoMulpliyPDSelect(selectedOption?.value)}
                                options={stageTwoOptionsAddOrMulti}
                                placeholder="Select Status"
                                name="status"
                                className={`mt-0 ${eclCss.eclMultiPDSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        
                        <div className={eclCss.custNumInptContainer}>
                            <div className={eclCss.custInptBox}>
                                <input
                                    className={eclCss.custInpt}
                                    type="text"
                                    value={`${StageTwoMulpliyPDInpt}`}
                                    onChange={(e) => setStageTwoMulpliyPDInpt(Number(e.target.value))}
                                />
                            </div>
                            <div className={eclCss.custInptIncDescContainer}>
                                <div className={eclCss.custInptNumUpArrCont}><NumUpArrow className={eclCss.custInptNumSvg}/></div>
                                <div className={eclCss.custInptNumDowArrCont}><NumDownArrow className={eclCss.custInptNumSvg} /></div>
                            </div>
                        </div>
                            
                        </div>
                    </div>

                {/* </div> */}

                {/* Right Category Container */}
                {/* <div className={ `${StageTwoCategorization == 'Y' ? eclCss.UnhideContainerHideCategoryContainer : eclCss.hideContainerUnHideCategoryContainer}` }>
                     <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                        <span className={eclCss.stage2CategoryDesc}>All possible permutations from definitions have been listed below,
                            Select and click add to continue 
                        </span>
                        <div className={eclCss.stage2radioContainer}>
                           
                        </div>
                        <button type="button" className={eclCss.catgeoryAddSeclectedBtn}>
                                Add Selected
                        </button>
                    </div>
                    
                    <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                        <Droppable droppableId="right" >
                            {(provided) => (
                                <div className={`${eclCss.defineCardsRightContainer} ${eclCss.Stage2RightDragCustStyl}}`} ref={provided.innerRef} {...provided.droppableProps}> 
                                    
                                    {rightItems.map((item, index) => (
                                        <Draggable key={item.id} draggableId={item.id} index={index}>
                                        {(provided) => (
                                            <div className={eclCss.defineCategorycardContainerRight} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} >
                                                <div className={eclCss.stage2rightCategoryCardInnerContainer} >
                                                    <div>
                                                        <input type="checkbox" name="" id="" 
                                                            defaultChecked={item.active === 'Y'}
                                                        />
                                                    </div>
                                                    <div>
                                                        <div className={eclCss.defineCategoryCardHead}>{item.heading}</div>
                                                        <div className={eclCss.defineCategoryCardDesc}>
                                                            <div>
                                                                {item.desc}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                        </Draggable>
                                    ))}

                                </div>
                            )}
                        </Droppable>
                    </div>
                        <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}>
                            <div className={eclCss.infoStage2}>
                                <div className={eclCss.infoStageBoxNoBg}>
                                    <div className={eclCss.stage1IconBox}>
                                        <QuestionMartInfo />
                                    &nbsp; &nbsp;
                                    </div>
                                    <div className={eclCss.stage1InfoText}>
                                        Lorem ipsum dolor sit amet consectetur. Vivamus scelerisque
                                    </div>
                                    <div className={eclCss.categoryRightBtnNoBgclr}>
                                        Define Category
                                    </div>
                                </div>
                            </div>
                        </div>
                </div> */}
                    
                
            </div>
            </DragDropContext>
        </div>
    )
}


const StageTwoCategoryHeader = ({
    StageTwoCategoryScenarioModel,
    setStageTwoCategoryScenarioModel,
    StageTwoCategoryoptions,
    StageTwoCategoryCategorization,
    setStageTwoCategoryCategorization,
    ActiveStage,
    setActiveStage,
    setStageTwoCategorization,
    }) => {

    
    return(
        <div>
            <div className={`${eclCss.stageTwoCatgorSelecContainer} ${eclCss.custmfadein}`}>

                <div className={eclCss.width40Per}>
                    <Select
                        defaultValue={StageTwoCategoryoptions[0]}
                        components={{ IndicatorSeparator: () => null }} // remove separator
                        onChange={(selectedOption) => setStageTwoCategoryScenarioModel(selectedOption)}
                        options={StageTwoCategoryoptions}
                        placeholder="Select Status"
                        name="status"
                        className={`w-100 mt-0 ${eclCss.selectstyl}`}
                        classNamePrefix="select"
                        styles={customStyles}
                        isClearable={false}
                        isSearchable={false}
                    />
                </div>

                <div className={eclCss.width40Per}>
                    <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer_}`}>
                        <span className={eclCss.stage2labelSide}>Do you want categorization?</span>
                        <div className={eclCss.stage2radioContainer}>
                            <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setActiveStage('C2'); setStageTwoCategorization('Yes');}}>
                                {/* <div className={eclCss.customRadioOuter}>
                                    {ActiveStage !== Number.isInteger(ActiveStage) ? <div className={eclCss.customRadioInner}></div> : ''}
                                </div> */}
                                {ActiveStage !== Number.isInteger(ActiveStage) ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                YES
                            </label>

                            <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setActiveStage(2); setStageTwoCategorization('No');}}>
                                {/* <div className={eclCss.customRadioOuter}>
                                    {ActiveStage === Number.isInteger(ActiveStage) ? <div className={eclCss.customRadioInner}></div> : ''}
                                </div> */}
                                {ActiveStage === Number.isInteger(ActiveStage) ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                NO
                            </label>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}


const StageTwoCategory = ({
    categorysPDObj,
    setcategorysPDObj,
    categorysData,
    StageTwoActiveCategory,
    setStageTwoActiveCategory,
    optionsMultiplePDPercentage,
    categorysObj,
    StageTwoCategoryMulpliyPDSelect,
    }) =>{

    return(

        <React.Fragment>
            {/* Category Tabs */}
            <div className={`${eclCss.custmfadein} ${eclCss.categoryContainerMain}`}>
                
                <div className={eclCss.catgegoryContainer}>
                    {categorysData.map((item, index) => (
                        <div key={index} className={ StageTwoActiveCategory === index ?  index === 0 ? eclCss.activeCategoryTab : eclCss.activeCategoryTabNoRadius : eclCss.inActiveCategoryTab} onClick={() => {setStageTwoActiveCategory(index)}}>
                            <div key={index} style={{ height:'100%', padding: '5px', display:'flex', alignItems:'center' }}>
                                <div className={eclCss.WMaxContant} > {item.category} - {item.subcategory}</div>
                                {/* {item.categoryID} */}
                                {/* <small className={eclCss.smallTxt}>{item.subcategory}</small> */}
                                {/* {item.subcategoryID} */}
                            </div>
                        </div>
                    ))}
                </div>

                {categorysData.map((item, index) => (

                    // StageTwoActiveCategory === index ? 
                        <div key={index} className={StageTwoActiveCategory === index ? eclCss.containerShow : eclCss.containerNone}>
                            <div key={index} className={eclCss.stage2CategoryContainer_}>
                                <div className={eclCss.stageLeftContainer} key={index}>
                                    <div key={index}>
                                        <div key={index} className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}>
                                            <div key={index} className={eclCss.stagelabel}>PD rate calculation</div>
                                            <div key={index} className={eclCss.pdsInptsContainer}>
                                                <div key={index} className={`${eclCss.pdInpts} ${ categorysPDObj[item.subcategoryID]?.values.StageTwoCategoryPDInpt === 'count' ? eclCss.pdInptsActive : eclCss.pdInptsInActive}`} 
                                                    onClick={() => {
                                                        setcategorysPDObj(prev => ({
                                                            ...prev,
                                                            [item.subcategoryID]: {
                                                            ...prev[item.subcategoryID],
                                                            values: {
                                                                ...prev[item.subcategoryID]?.values,
                                                                StageTwoCategoryPDInpt: 'count'
                                                            }
                                                            }
                                                        }));
                                                    }}
                                                >
                                                    Count of loans
                                                </div>
                                                <div key={index} className={`${eclCss.pdInpts} ${categorysPDObj[item.subcategoryID]?.values.StageTwoCategoryPDInpt == 'loanSanctionedValue' ? eclCss.pdInptsActive : eclCss.pdInptsInActive}`} 
                                                    onClick={() => {
                                                            setcategorysPDObj(prev => ({
                                                                ...prev,
                                                                [item.subcategoryID]: {
                                                                ...prev[item.subcategoryID],
                                                                values: {
                                                                    ...prev[item.subcategoryID]?.values,
                                                                    StageTwoCategoryPDInpt: 'loanSanctionedValue'
                                                                }
                                                                }
                                                            }));
                                                        }}
                                                >
                                                    Loan Sanctioned Value
                                                </div>
                                                <div key={index}
                                                    className={`${eclCss.pdInpts} ${categorysPDObj[item.subcategoryID]?.values.StageTwoCategoryPDInpt == 'loanOutstandingValue' ? eclCss.pdInptsActive : eclCss.pdInptsInActive}`} 
                                                        onClick={() => {
                                                            setcategorysPDObj(prev => ({
                                                                ...prev,
                                                                [item.subcategoryID]: {
                                                                ...prev[item.subcategoryID],
                                                                values: {
                                                                    ...prev[item.subcategoryID]?.values,
                                                                    StageTwoCategoryPDInpt: 'loanOutstandingValue'
                                                                }
                                                                }
                                                            }));
                                                        }}
                                                    >
                                                    Loan Outstanding Value
                                                </div>
                                                <div key={index}
                                                    className={`${eclCss.pdInpts} ${categorysPDObj[item.subcategoryID]?.values.StageTwoCategoryPDInpt == 'loanDisbursedValue' ? eclCss.pdInptsActive : eclCss.pdInptsInActive}`} 
                                                    onClick={() => {
                                                            setcategorysPDObj(prev => ({
                                                                ...prev,
                                                                [item.subcategoryID]: {
                                                                ...prev[item.subcategoryID],
                                                                values: {
                                                                    ...prev[item.subcategoryID]?.values,
                                                                    StageTwoCategoryPDInpt: 'loanDisbursedValue'
                                                                }
                                                                }
                                                            }));
                                                        }}
                                                >
                                                    Loan disbursed value
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <div key={index} className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}>
                                            <div key={index} className={eclCss.infoStage2}>
                                                <div key={index} className={eclCss.infoStageBox}>
                                                    <div key={index} className={eclCss.stage1IconBox}>
                                                        <QuestionMartInfo />
                                                    &nbsp; &nbsp;
                                                    </div>
                                                    <div className={eclCss.stage1InfoText}>
                                                        Lorem ipsum dolor sit amet consectetur. Vivamus scelerisque orci et pellentesque nunc ut
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div key={index} className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}>
                                            <div className={eclCss.stagelabel}>Frequency for PD Calculation</div>
                                            <div className={eclCss.pdsInptsContainer}>
                                                <div className={`${eclCss.pdInpts} ${categorysPDObj[item.subcategoryID]?.values.StageTwoCategoryPDCalculation === 'yearly' ? eclCss.pdInptsActive : eclCss.pdInptsInActive}`} 
                                                    onClick={() => {
                                                                        setcategorysPDObj(prev => ({
                                                                            ...prev,
                                                                            [item.subcategoryID]: {
                                                                            ...prev[item.subcategoryID],
                                                                            values: {
                                                                                ...prev[item.subcategoryID]?.values,
                                                                                StageTwoCategoryPDCalculation: 'yearly'
                                                                            }
                                                                            }
                                                                        }));
                                                                    }}
                                                >
                                                    Yearly Basis
                                                </div>
                                                <div key={index} className={`${eclCss.pdInpts} ${categorysPDObj[item.subcategoryID]?.values.StageTwoCategoryPDCalculation === 'quarterly' ? eclCss.pdInptsActive : eclCss.pdInptsInActive}`} 
                                                    onClick={() => {
                                                                        setcategorysPDObj(prev => ({
                                                                            ...prev,
                                                                            [item.subcategoryID]: {
                                                                            ...prev[item.subcategoryID],
                                                                            values: {
                                                                                ...prev[item.subcategoryID]?.values,
                                                                                StageTwoCategoryPDCalculation: 'quarterly'
                                                                            }
                                                                            }
                                                                        }));
                                                                    }}
                                                >
                                                    Quarterly Basis
                                                </div>
                                                <div key={index} className={`${eclCss.pdInpts} ${categorysPDObj[item.subcategoryID]?.values.StageTwoCategoryPDCalculation === 'monthly' ? eclCss.pdInptsActive : eclCss.pdInptsInActive}`} 
                                                    onClick={() => {
                                                                    setcategorysPDObj(prev => ({
                                                                        ...prev,
                                                                        [item.subcategoryID]: {
                                                                        ...prev[item.subcategoryID],
                                                                        values: {
                                                                            ...prev[item.subcategoryID]?.values,
                                                                            StageTwoCategoryPDCalculation: 'monthly'
                                                                        }
                                                                        }
                                                                    }));
                                                                }}
                                                >
                                                    Monthly Basis
                                                </div>
                                            </div>
                                        </div>

                                        <div key={index} className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}>
                                            <div className={eclCss.stagelabel}>How many periods to consider?</div>
                                            <div className={eclCss.pdsInptsContainer}>
            
                                                <input
                                                    type="range"
                                                    min={categorysPDObj[item.subcategoryID]?.values.min}
                                                    max={categorysPDObj[item.subcategoryID]?.values.max}
                                                    value={categorysPDObj[item.subcategoryID]?.values.StageTwoCategoryNumberOfPeriods}
                                                    onChange={(e) => {
                                                        const val = Number(e.target.value);
                                                        setcategorysPDObj(prev => {
                                                            const subID = item.subcategoryID;
                                                            const old = prev[subID] || {};
                                                            const oldGlobal = old.values || {};

                                                            const min = oldGlobal.min || 1;
                                                            const max = oldGlobal.max || 100;
                                                            const percentage = ((val - min) / (max - min)) * 100;

                                                            return {
                                                            ...prev,
                                                            [subID]: {
                                                                ...old,
                                                                values: {
                                                                ...oldGlobal,
                                                                StageTwoCategoryNumberOfPeriods: val,
                                                                percentage: percentage,
                                                                weights: Array.from({ length: val }, (_, i) => ({
                                                                    period: (i + 1).toString(),
                                                                    percentage: 0
                                                                }))
                                                                }
                                                            }
                                                            };
                                                        });
                                                    }}

                                                    style={{
                                                    background: `linear-gradient(to right, #3AB67D ${categorysPDObj[item.subcategoryID]?.values.percentage}%, #CCD5D3 ${categorysPDObj[item.subcategoryID]?.values.percentage}%)`,
                                                    }}
                                                    className={eclCss.slider}
                                                />
                                                <div key={index} className={eclCss.custNumInptContainer}>
                                                    <div className={eclCss.custInptBox}>
                                                        <input
                                                            className={eclCss.custInpt}
                                                            type="text"
                                                            value={categorysPDObj[item.subcategoryID]?.values.StageTwoCategoryNumberOfPeriods}
                                                            onChange={(e) => {
                                                                const val = Number(e.target.value);

                                                                    setcategorysPDObj(prev => {
                                                                        const subID = item.subcategoryID;
                                                                        const old = prev[subID] || {};
                                                                        const oldGlobal = old.values || {};

                                                                        const min = oldGlobal.min || 1;
                                                                        const max = oldGlobal.max || 100;
                                                                        const percentage = ((val - min) / (max - min)) * 100;

                                                                        return {
                                                                        ...prev,
                                                                        [subID]: {
                                                                            ...old,
                                                                            values: {
                                                                            ...oldGlobal,
                                                                            StageTwoCategoryNumberOfPeriods: val,
                                                                            percentage: percentage,
                                                                            weights: Array.from({ length: val }, (_, i) => ({
                                                                                period: (i + 1).toString(),
                                                                                percentage: 0
                                                                            }))
                                                                            }
                                                                        }
                                                                        };
                                                                    });

                                                                }}

                                                        />
                                                    </div>
                                                    <div key={index} className={eclCss.custInptIncDescContainer}>
                                                        <div className={eclCss.custInptNumUpArrCont}><NumUpArrow className={eclCss.custInptNumSvg}/></div>
                                                        <div className={eclCss.custInptNumDowArrCont}><NumDownArrow className={eclCss.custInptNumSvg} /></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div key={index} className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}>
                                            <div className={eclCss.stagelabel}>Best value for PD calculation post period-1</div>
                                            <div className={eclCss.pdsInptsContainer}>
                                                    <div className={`${eclCss.pdInpts} ${categorysPDObj[item.subcategoryID]?.values.StageTwoCategoryLoanSect == 'total' ? eclCss.pdInptsActive : eclCss.pdInptsInActive}`} 
                                                        onClick={() => {
                                                                        setcategorysPDObj(prev => ({
                                                                            ...prev,
                                                                            [item.subcategoryID]: {
                                                                            ...prev[item.subcategoryID],
                                                                            values: {
                                                                                ...prev[item.subcategoryID]?.values,
                                                                                StageTwoCategoryLoanSect: 'total'
                                                                            }
                                                                            }
                                                                        }));
                                                                    }}
                                                    >
                                                        Total Loans
                                                    </div>
                                                    <div className={`${eclCss.pdInpts} ${categorysPDObj[item.subcategoryID]?.values.StageTwoCategoryLoanSect == 'nonDefault' ? eclCss.pdInptsActive : eclCss.pdInptsInActive}`} 
                                                        onClick={() => {
                                                                    setcategorysPDObj(prev => ({
                                                                            ...prev,
                                                                            [item.subcategoryID]: {
                                                                            ...prev[item.subcategoryID],
                                                                            values: {
                                                                                ...prev[item.subcategoryID]?.values,
                                                                                StageTwoCategoryLoanSect: 'nonDefault'
                                                                            }
                                                                            }
                                                                        }));
                                                                }}
                                                    >
                                                        Non-default Loans
                                                    </div>
                                            </div>
                                        </div>

                                        <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                                            <span className={eclCss.stage2labelSide}>Include interest on default payments?</span>
                                            <div className={eclCss.stage2radioContainer}>
                                                <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} 
                                                    onClick={() => {
                                                        setcategorysPDObj(prev => ({
                                                                ...prev,
                                                                [item.subcategoryID]: {
                                                                ...prev[item.subcategoryID],
                                                                values: {
                                                                    ...prev[item.subcategoryID]?.values,
                                                                    StageTwoDefaultPayment: 'Yes'
                                                                }
                                                                }
                                                        }));
                                                    }}
                                                >
                                                    {/* <div className={eclCss.customRadioOuter}>
                                                        {categorysPDObj[item.subcategoryID]?.values.StageTwoDefaultPayment === 'Yes' ? <div className={eclCss.customRadioInner}></div> : ''}
                                                    </div> */}
                                                    {categorysPDObj[item.subcategoryID]?.values.StageTwoDefaultPayment === 'Yes' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                                    YES
                                                </label>

                                                <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} 
                                                    onClick={() => {
                                                        setcategorysPDObj(prev => ({
                                                                ...prev,
                                                                [item.subcategoryID]: {
                                                                ...prev[item.subcategoryID],
                                                                values: {
                                                                    ...prev[item.subcategoryID]?.values,
                                                                    StageTwoDefaultPayment: 'No'
                                                                }
                                                                }
                                                        }));
                                                    }}
                                                >
                                                    {/* <div className={eclCss.customRadioOuter}>
                                                        {categorysPDObj[item.subcategoryID]?.values.StageTwoDefaultPayment === 'No' ? <div className={eclCss.customRadioInner}></div> : ''}
                                                    </div> */}
                                                    {categorysPDObj[item.subcategoryID]?.values.StageTwoDefaultPayment === 'No' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                                    NO
                                                </label>
                                            </div>
                                        </div>

                                        <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                                            <span className={eclCss.stage2labelSide}>Do you want calculate 12 months PD?</span>
                                            <div className={eclCss.stage2radioContainer}>
                                                <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} 
                                                    onClick={() => {
                                                                    setcategorysPDObj(prev => ({
                                                                            ...prev,
                                                                            [item.subcategoryID]: {
                                                                            ...prev[item.subcategoryID],
                                                                            values: {
                                                                                ...prev[item.subcategoryID]?.values,
                                                                                calculateTwelveMonthsPD: 'Yes'
                                                                            }
                                                                            }
                                                                    }));
                                                                }}
                                                >
                                                    {/* <div className={eclCss.customRadioOuter}>
                                                        {categorysPDObj[item.subcategoryID]?.values.calculateTwelveMonthsPD === 'Yes' ? <div className={eclCss.customRadioInner}></div> : ''}
                                                    </div> */}
                                                    {categorysPDObj[item.subcategoryID]?.values.calculateTwelveMonthsPD === 'Yes' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                                    YES
                                                </label>

                                                <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} 
                                                    onClick={() => {
                                                                    setcategorysPDObj(prev => ({
                                                                            ...prev,
                                                                            [item.subcategoryID]: {
                                                                            ...prev[item.subcategoryID],
                                                                            values: {
                                                                                ...prev[item.subcategoryID]?.values,
                                                                                calculateTwelveMonthsPD: 'No'
                                                                            }
                                                                            }
                                                                    }));
                                                                }}
                                                >
                                                    {/* <div className={eclCss.customRadioOuter}>
                                                        {categorysPDObj[item.subcategoryID]?.values.calculateTwelveMonthsPD === 'No' ? <div className={eclCss.customRadioInner}></div> : ''}
                                                    </div> */}
                                                    {categorysPDObj[item.subcategoryID]?.values.calculateTwelveMonthsPD === 'No' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                                    NO
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                </div>

                                {/* seprator */}
                                <div key={index} className={eclCss.containerSeprator}></div>

                                <div key={index} className={eclCss.stage2RightContainer}>

                                    <div key={index} className={ `${ eclCss.UnhideContainerHideCategoryContainer }`}>

                                        <div key={index} className={`${eclCss.stageRightSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}>
                                            <div className={eclCss.stagelabel}>What should be considered as period 1?</div>
                                            <div className={eclCss.pdsInptsContainer}>
                                                <div className={`${eclCss.pdInpts} ${categorysPDObj[item.subcategoryID]?.values.StageTwoCategoryConsiderPeriod == 'financialYear' ? eclCss.pdInptsActive : eclCss.pdInptsInActive}`} 
                                                    onClick={() => {
                                                                    setcategorysPDObj(prev => ({
                                                                        ...prev,
                                                                        [item.subcategoryID]: {
                                                                        ...prev[item.subcategoryID],
                                                                        values: {
                                                                            ...prev[item.subcategoryID]?.values,
                                                                            StageTwoCategoryConsiderPeriod: 'financialYear'
                                                                        }
                                                                        }
                                                                    }));
                                                                }}

                                                    >
                                                    Financial Year
                                                </div>
                                                <div key={index} className={`${eclCss.pdInpts} ${categorysPDObj[item.subcategoryID]?.values.StageTwoCategoryConsiderPeriod == 'disbursementYear' ? eclCss.pdInptsActive : eclCss.pdInptsInActive}`} 
                                                    onClick={() => {
                                                                    setcategorysPDObj(prev => ({
                                                                        ...prev,
                                                                        [item.subcategoryID]: {
                                                                        ...prev[item.subcategoryID],
                                                                        values: {
                                                                            ...prev[item.subcategoryID]?.values,
                                                                            StageTwoCategoryConsiderPeriod: 'disbursementYear'
                                                                        }
                                                                        }
                                                                    }));
                                                                }}
                                                    >
                                                    Loan disbursement Year
                                                </div>
                                            </div>
                                        </div>

                                        <div key={index} className={`${eclCss.stageRightSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}>
                                            <div className={eclCss.infoStage2}>
                                                <div className={eclCss.infoStageBox}>
                                                    <div className={eclCss.stage1IconBox}>
                                                        <QuestionMartInfo />
                                                        
                                                    &nbsp; &nbsp;
                                                    </div>
                                                    <div className={eclCss.stage1InfoText}>
                                                        Lorem ipsum dolor sit amet consectetur. Vivamus scelerisque orci et pellentesque nunc ut
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div key={index} className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                                            <span className={eclCss.stage2labelSide}>Extrapolation based on past history for missing periods?</span>
                                            <div className={eclCss.stage2radioContainer}>
                                                <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} 
                                                    onClick={() => {
                                                        setcategorysPDObj(prev => ({
                                                                        ...prev,
                                                                        [item.subcategoryID]: {
                                                                        ...prev[item.subcategoryID],
                                                                        values: {
                                                                            ...prev[item.subcategoryID]?.values,
                                                                            StageTwoCategoryExtraploation: 'Yes'
                                                                        }
                                                                        }
                                                                    }));
                                                                }}
                                                
                                                >
                                                    { categorysPDObj[item.subcategoryID]?.values.StageTwoCategoryExtraploation  === 'Yes' ? 
                                                        <ActiveRadioBtn className={eclCss.custuRadioBtn} /> 
                                                    :
                                                        <InactiveRadioBtn className={eclCss.custuRadioBtn} />
                                                    }
                                                    YES
                                                </label>
                                                <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} 
                                                    onClick={() => {
                                                  
                                                        setcategorysPDObj(prev => ({
                                                                    ...prev,
                                                                    [item.subcategoryID]: {
                                                                    ...prev[item.subcategoryID],
                                                                    values: {
                                                                        ...prev[item.subcategoryID]?.values,
                                                                        StageTwoCategoryExtraploation: 'No'
                                                                    }
                                                                    }
                                                                }));

                                                                    }}
                                                >
                                                    { categorysPDObj[item.subcategoryID]?.values.StageTwoCategoryExtraploation  === 'No' ? 
                                                        <ActiveRadioBtn className={eclCss.custuRadioBtn} /> 
                                                    : 
                                                        <InactiveRadioBtn className={eclCss.custuRadioBtn} />
                                                    }
                                                    NO
                                                </label>
                                            </div>
                                        </div>

                                        <div key={index} className={`${eclCss.stageRightSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}>
                                            <div className={eclCss.stagelabel}></div>
                                            <div className={eclCss.pdsInptsContainer}>
                                                <div className={`${eclCss.pdInpts} ${categorysPDObj[item.subcategoryID]?.values.StageTwoCategorySAWApE === 'simpleAverage' ? eclCss.pdInptsActive : eclCss.pdInptsInActive}`} 
                                                    onClick={() => {
                                                        setcategorysPDObj(prev => ({
                                                                        ...prev,
                                                                        [item.subcategoryID]: {
                                                                        ...prev[item.subcategoryID],
                                                                        values: {
                                                                            ...prev[item.subcategoryID]?.values,
                                                                            StageTwoCategorySAWApE: 'simpleAverage'
                                                                        }
                                                                        }
                                                                    }));
                                                        }}
                                                >
                                                    Simple Average
                                                </div>
                                                <div className={`${eclCss.pdInpts} ${categorysPDObj[item.subcategoryID]?.values.StageTwoCategorySAWApE === 'weightedAverage' ? eclCss.pdInptsActive : eclCss.pdInptsInActive}`}
                                                    onClick={() => {
                                                        setcategorysPDObj(prev => ({
                                                                        ...prev,
                                                                        [item.subcategoryID]: {
                                                                        ...prev[item.subcategoryID],
                                                                        values: {
                                                                            ...prev[item.subcategoryID]?.values,
                                                                            StageTwoCategorySAWApE: 'weightedAverage'
                                                                        }
                                                                        }
                                                                    }));
                                                        }}
                                                >
                                                    Weighted Average
                                                </div>
                                                <div className={`${eclCss.pdInpts} ${categorysPDObj[item.subcategoryID]?.values.StageTwoCategorySAWApE === 'proportionateExtrapolation' ? eclCss.pdInptsActive : eclCss.pdInptsInActive}`}
                                                    onClick={() => {
                                                                    setcategorysPDObj(prev => ({
                                                                        ...prev,
                                                                        [item.subcategoryID]: {
                                                                        ...prev[item.subcategoryID],
                                                                        values: {
                                                                            ...prev[item.subcategoryID]?.values,
                                                                            StageTwoCategorySAWApE: 'proportionateExtrapolation'
                                                                        }
                                                                        }
                                                                    }));
                                                                }}
                                                >
                                                    Proportionate Extrapolation
                                                </div>
                                            </div>
                                        </div>

                                        <div key={index} className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}>
                                            <div className={eclCss.pdsInptsContainer}>
                                                <div 
                                                    // className={eclCss.stage2labelSide}
                                                    className={`${eclCss.pdInpts} ${eclCss.pdInptsInActive}`}
                                                >
                                                    Enter Percentage
                                                </div>
                                                <div className={`${eclCss.custNumInptContainer} ${eclCss.ml0}`}>
                                                    <div className={eclCss.custInptBox}>
                                                        <input
                                                            className={eclCss.custInpt}
                                                            type="text"
                                                            value={categorysPDObj[item.subcategoryID]?.values.StageTwoCategoryPercentage}
                                                            onChange={(e) => {
                                                                setcategorysPDObj(prev => ({
                                                                        ...prev,
                                                                        [item.subcategoryID]: {
                                                                        ...prev[item.subcategoryID],
                                                                        values: {
                                                                            ...prev[item.subcategoryID]?.values,
                                                                            StageTwoCategoryPercentage: Number(e.target.value)
                                                                        }
                                                                    }
                                                                }));
                                                            }}
                                                        />
                                                    </div>
                                                    <div className={eclCss.custInptIncDescContainerRitPer}>
                                                        <div className={eclCss.custInptNumUpArrCont}><PercebtageIcn/></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div key={index} className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}>
                                            <div className={eclCss.infoStage2}>
                                                <div className={eclCss.infoStageBox}>
                                                    <div className={eclCss.stage1IconBox}>
                                                        <QuestionMartInfo />
                                                    &nbsp; &nbsp;
                                                    </div>
                                                    <div className={eclCss.stage1InfoText}>
                                                        Lorem ipsum dolor sit amet consectetur. Vivamus scelerisque orci et pellentesque nunc ut
                                                    </div>
                                                </div> 
                                            </div>
                                        </div>

                                        <div key={index} className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                                            <span className={eclCss.stage2labelSide}>Do you want specific weights assigned to periods while calculating PD?</span>
                                            <div className={eclCss.stage2radioContainer}>
                                                <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} 
                                                    onClick={() => {
                                                                    setcategorysPDObj(prev => ({
                                                                            ...prev,
                                                                            [item.subcategoryID]: {
                                                                            ...prev[item.subcategoryID],
                                                                            values: {
                                                                                ...prev[item.subcategoryID]?.values,
                                                                                StageTwoCategorySpecificWe: 'Yes'
                                                                                }
                                                                            }
                                                                        }));
                                                                    }}
                                                >
                                                        { categorysPDObj[item.subcategoryID]?.values.StageTwoCategorySpecificWe == 'Yes' ? 
                                                        <ActiveRadioBtn className={eclCss.custuRadioBtn} /> 
                                                        : 
                                                        <InactiveRadioBtn className={eclCss.custuRadioBtn} /> 
                                                        }
                                                    YES
                                                </label>
                                                <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} 
                                                    onClick={() => {setcategorysPDObj(prev => ({
                                                                                ...prev,
                                                                                [item.subcategoryID]: {
                                                                                ...prev[item.subcategoryID],
                                                                                values: {
                                                                                    ...prev[item.subcategoryID]?.values,
                                                                                    StageTwoCategorySpecificWe: 'No'
                                                                                }
                                                                            }
                                                                        }));
                                                                    }}
                                                >
                                                { categorysPDObj[item.subcategoryID]?.values.StageTwoCategorySpecificWe == 'No' ? 
                                                        <ActiveRadioBtn className={eclCss.custuRadioBtn} /> 
                                                        : 
                                                        <InactiveRadioBtn className={eclCss.custuRadioBtn} /> 
                                                } 
                                                NO
                                                </label> 
                                            </div>
                                        </div>

                                        <div key={index} className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInptGRP}`}>
                                            <div className={eclCss.pdsInptsContainerGRP}>
                                                
                                                {[...Array(categorysPDObj[item.subcategoryID]?.values.StageTwoCategoryNumberOfPeriods)].map((_, i) => (
                                                    <div key={i} className={eclCss.assIgnedPeriodCalculPD}>
                                                        <div className={eclCss.inptLabelGrp}>
                                                            Period - {i + 1}
                                                        </div>
                                                        <div className={eclCss.custNumInptContainerGrp}>
                                                            <div className={eclCss.custInptBoxgrp}>
                                                                <input
                                                                    className={eclCss.custInpt}
                                                                    type="text"
                                                                    value={categorysPDObj?.[item.subcategoryID]?.values?.weights?.[i]?.percentage ?? '' }
                                                                    onChange={(e) => {
                                                                        const val = e.target.value;

                                                                        setcategorysPDObj(prev => {
                                                                            const subID = item.subcategoryID;
                                                                            const old = prev[subID] || {};
                                                                            const oldGlobal = old.values || {};
                                                                            const oldWeights = oldGlobal.weights || [];

                                                                            const updatedWeights = [...oldWeights];
                                                                            updatedWeights[i] = {
                                                                            period: `${i + 1}`,
                                                                            percentage: Number(val)
                                                                            };

                                                                            return {
                                                                            ...prev,
                                                                            [subID]: {
                                                                                ...old,
                                                                                values: {
                                                                                ...oldGlobal,
                                                                                weights: updatedWeights
                                                                                }
                                                                            }
                                                                            };
                                                                        });
                                                                    }}
                                                                />

                                                            </div>
                                                            <div className={eclCss.custInptIncDescContainerGRP}>
                                                                <div className={eclCss.custInptNumUpArrCont}>
                                                                    <NumUpArrow className={eclCss.custInptNumSvg} />
                                                                </div>
                                                                <div className={eclCss.custInptNumDowArrCont}>
                                                                    <NumDownArrow className={eclCss.custInptNumSvg} />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}

                                            </div>
                                        </div>

                                        <div key={index} className={`${eclCss.stageRightSubContainer} ${eclCss.stage2LeftLabelAndInpt}`} style={{ paddingBottom : '25px' }}>
                                            <div className={eclCss.stagelabel}>Add or multiply PD% by </div>
                                            <div className={eclCss.pdsInptsContainer}>
                                                <Select
                                                    defaultValue={optionsMultiplePDPercentage[0]}
                                                    components={{ IndicatorSeparator: () => null }} // remove separator
                                                    // onChange={(selectedOption) => setStageTwoCategoryMulpliyPDSelect(selectedOption)}
                                                    value={optionsMultiplePDPercentage.find(option => option.value === StageTwoCategoryMulpliyPDSelect)}
                                                    onChange={(selectedOption) => {
                                                                setcategorysPDObj(prev => ({
                                                                                ...prev,
                                                                                [item.subcategoryID]: {
                                                                                ...prev[item.subcategoryID],
                                                                                values: {
                                                                                    ...prev[item.subcategoryID]?.values,
                                                                                    setStageTwoCategoryMulpliyPDSelect: selectedOption
                                                                                }
                                                                                }   
                                                                            }));
                                                                }}
                                                    options={optionsMultiplePDPercentage}
                                                    placeholder="Select Status"
                                                    name="status"
                                                    className={`mt-0 ${eclCss.eclMultiPDSelect}`}
                                                    classNamePrefix="select"
                                                    styles={customStyles}
                                                    isClearable={false}
                                                    isSearchable={false}
                                                />
                                            
                                                <div className={eclCss.custNumInptContainer}>
                                                    <div className={eclCss.custInptBox}>
                                                        <input
                                                            className={eclCss.custInpt}
                                                            type="text"
                                                            value={categorysPDObj[item.subcategoryID]?.values.StageTwoCategoryMulpliyPDInpt}
                                                            onChange={(e) => {setcategorysPDObj(prev => ({
                                                                        ...prev,
                                                                        [item.subcategoryID]: {
                                                                        ...prev[item.subcategoryID],
                                                                        values: {
                                                                            ...prev[item.subcategoryID]?.values,
                                                                            StageTwoCategoryMulpliyPDInpt: Number(e.target.value)
                                                                        }
                                                                        }
                                                                    }));
                                                                }}
                                                        />
                                                    </div>
                                                    <div className={eclCss.custInptIncDescContainer}>
                                                        <div className={eclCss.custInptNumUpArrCont}><NumUpArrow className={eclCss.custInptNumSvg}/></div>
                                                        <div className={eclCss.custInptNumDowArrCont}><NumDownArrow className={eclCss.custInptNumSvg} /></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                </div>
                            </div>
                            <div className={eclCss.stage2CategorySaveBtnContainer} key={index} hidden>
                                <button className={eclCss.categorySaveBtn} type="button" key={index}>Save</button>
                            </div>
                        </div>
                    // : null
                    
                ))}


            </div>
        </React.Fragment>
        
    )
}


const StageThree = ({
    ActiveStage,
    setActiveStage,

    StageThreeScenarioModel,
    setStageThreeScenarioModel,
    StageThreeCategorization,
    setStageThreeCategorization,
    leftItems,
    setLeftItems,
    rightItems,
    setRightItems,

    StageThreeOptions,

    StageThreeComputeLoss, 
    setStageThreeComputeLoss,

    considerInterestEMIDelayedPayment,
    setconsiderInterestEMIDelayedPayment,
    considerPenalCharges,
    setconsiderPenalCharges,
    considerRecoveryCharges,
    setconsiderRecoveryCharges,
    onlyActiveNPA, 
    setonlyActiveNPA,
    writtenOffOnly, 
    setwrittenOffOnly,
    considerSecurityValue, 
    setconsiderSecurityValue,
    considerSecondarySecurity, 
    setconsiderSecondarySecurity,
    baseValuePrimarySecurity, 
    setbaseValuePrimarySecurity,
    baseValueSecondarySecurity,
    setbaseValueSecondarySecurity,
    percentageOfPrimarySecurity, 
    setpercentageOfPrimarySecurity,
    percentageOfSecondarySecurity, 
    setpercentageOfSecondarySecurity,
    // badDebtConsider, 
    // setbadDebtConsider,
    addOverlayFactor, 
    setaddOverlayFactor,
    overlayFactorCount, 
    setoverlayFactorCount,
    overlayFactorsRef,
    saveOveryLayFactores,
    overlayFactorDataList,
    setoverlayFactorDataList
    
    }) => {

    // // Stage Three States
    // const [StageThreeScenarioModel, setStageThreeScenarioModel]   = useState('LGDModel')
    // const [StageThreeCategorization, setStageThreeCategorization] = useState('N')
    // const [StageThreeValueSecurity, setStageThreeValueSecurity] = useState('CST')
    // const [StageThreePercentage, setStageThreePercentage] = useState(2.3)

    // const [StageThreeAddOverlayFactor, setStageThreeAddOverlayFactor] = useState('Y')
    // const [StageThreeRemarkPercentage, setStageThreeRemarkPercentage] = useState('')
    // const [StageThreeAddFutherFactor, setStageThreeAddFutherFactor] = useState('Y')
    // const [StageThreeAddOrMultiply, setStageThreeAddOrMultiply] = useState('multiply')
    // const [StageThreeMultiplyBy, setStageThreeMultiplyBy] = useState(2.3)
    // const [StageThreeRemarks, setStageThreeRemarks] = useState()

    // const options = [
    //     { value: 'LGDModel', label: 'LGD Model' },
    // ];

    // const initialLeftItems = [
    //     { id: '1', heading: 'Category 1', desc: 'Home Loans › Salaried'},
    //     { id: '2', heading: 'Category 2', desc: 'Car Loans › Salaried'},
    //     { id: '3', heading: 'Category 3', desc: 'Education Loans › Salaried'},
    // ];

    // const initialRightItems = [
    //     { id: '4', heading: 'Posible Category', desc: 'Home Loans › Salaried', active : 'Y' },
    //     { id: '5', heading: 'Posible Category', desc: 'Car Loans › Salaried', active : 'Y' },
    //     { id: '6', heading: 'Posible Category', desc: 'Education Loans › Salaried', active : 'Y' },
    // ];

    // const [leftItems, setLeftItems] = useState(initialLeftItems);
    // const [rightItems, setRightItems] = useState(initialRightItems);

    function onDragEnd(result) {
        const { source, destination } = result;
        if (!destination) return;

        // If dropped in the same list
        if (source.droppableId === destination.droppableId) {
            const items = source.droppableId === 'left' ? Array.from(leftItems) : Array.from(rightItems);
            const [moved] = items.splice(source.index, 1);
            items.splice(destination.index, 0, moved);

        if (source.droppableId === 'left') {
            setLeftItems(items);
        } else {
            setRightItems(items);
        }
        return;
        }

        // Moving between different lists
        const sourceList = source.droppableId === 'left' ? Array.from(leftItems) : Array.from(rightItems);
        const destList = destination.droppableId === 'left' ? Array.from(leftItems) : Array.from(rightItems);

        const [movedItem] = sourceList.splice(source.index, 1);
        destList.splice(destination.index, 0, movedItem);

        if (source.droppableId === 'left') {
        setLeftItems(sourceList);
        setRightItems(destList);
        } else {
        setRightItems(sourceList);
        setLeftItems(destList);
        }
    }

    return(
        <div className={`${eclCss.stage3Container} ${eclCss.custmfadein}`}>
            <DragDropContext onDragEnd={onDragEnd}>

                <div className={eclCss.stageLeftContainer}>

                    <div className={`${eclCss.stageLeftSubContainer}`}>
                        <div className={eclCss.stagelabel}>Model</div>
                        <Select
                            defaultValue={StageThreeOptions[0]}
                            components={{ IndicatorSeparator: () => null }} // remove separator
                            onChange={(selectedOption) => setStageThreeScenarioModel(selectedOption)}
                            options={StageThreeOptions}
                            placeholder="Select Status"
                            name="status"
                            className={`w-100 mt-0 ${eclCss.selectstyl}`}
                            classNamePrefix="select"
                            styles={customStyles}
                            isClearable={false}
                            isSearchable={false}
                        />
                    </div>

                    <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}>
                        <div className={eclCss.stagelabel}>What amount would you like to compute loss on ?</div>
                        <div className={eclCss.pdsInptsContainer}>
                            <div className={`${eclCss.pdInpts} ${StageThreeComputeLoss === 'loanSanctionedValue' ? eclCss.pdInptsActive : eclCss.pdInptsInActive}`} onClick={() => { setStageThreeComputeLoss('loanSanctionedValue') }}>
                                Loan sanctioned value
                            </div>
                            <div className={`${eclCss.pdInpts} ${StageThreeComputeLoss === 'loanDisbursedValue' ? eclCss.pdInptsActive : eclCss.pdInptsInActive}`} onClick={() => { setStageThreeComputeLoss('loanDisbursedValue') }}>
                                Loan disbursed value
                            </div>
                            <div className={`${eclCss.pdInpts} ${StageThreeComputeLoss === 'outstandingLoanValue' ? eclCss.pdInptsActive : eclCss.pdInptsInActive}`} onClick={() => { setStageThreeComputeLoss('outstandingLoanValue') }}>
                                Outstanding loan value
                            </div>
                        </div>
                    </div>

                    <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                        <span className={eclCss.stage2labelSide}>Do you want to consider interest on EMI for delayed payment ?</span>
                        <div className={eclCss.stage2radioContainer}>
                            <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setconsiderInterestEMIDelayedPayment('Yes')}}>
                                {/* <div className={eclCss.customRadioOuter}>
                                    {considerInterestEMIDelayedPayment === 'Yes' ? <div className={eclCss.customRadioInner}></div> : ''}
                                </div> */}
                                {considerInterestEMIDelayedPayment === 'Yes' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                YES
                            </label>

                            <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setconsiderInterestEMIDelayedPayment('No')}}>
                                {/* <div className={eclCss.customRadioOuter}>
                                    {considerInterestEMIDelayedPayment === 'No' ? <div className={eclCss.customRadioInner}></div> : ''}
                                </div> */}
                                {considerInterestEMIDelayedPayment === 'No' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                NO
                            </label>
                        </div>
                    </div>

                    <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                        <span className={eclCss.stage2labelSide}>Do you want to consider penal charges for computation ?</span>
                        <div className={eclCss.stage2radioContainer}>
                            <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setconsiderPenalCharges('Yes')}}>
                                {/* <div className={eclCss.customRadioOuter}>
                                    {considerPenalCharges === 'Yes' ? <div className={eclCss.customRadioInner}></div> : ''}
                                </div> */}
                                {considerPenalCharges === 'Yes' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                YES
                            </label>

                            <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setconsiderPenalCharges('No')}}>
                                {/* <div className={eclCss.customRadioOuter}>
                                    {considerPenalCharges === 'No' ? <div className={eclCss.customRadioInner}></div> : ''}
                                </div> */}
                                {considerPenalCharges === 'No' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                NO
                            </label>
                        </div>
                    </div>

                    <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                        <span className={eclCss.stage2labelSide}>Would you like to consider charges incurred on recovery of loan amount ?</span>
                        <div className={eclCss.stage2radioContainer}>
                            <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setconsiderRecoveryCharges('Yes')}}>
                                {/* <div className={eclCss.customRadioOuter}>
                                    {considerRecoveryCharges === 'Yes' ? <div className={eclCss.customRadioInner}></div> : ''}
                                </div> */}
                                {considerRecoveryCharges === 'Yes' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                YES
                            </label>

                            <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setconsiderRecoveryCharges('No')}}>
                                {/* <div className={eclCss.customRadioOuter}>
                                    {considerRecoveryCharges === 'No' ? <div className={eclCss.customRadioInner}></div> : ''}
                                </div> */}
                                {considerRecoveryCharges === 'No' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                NO
                            </label>
                        </div>
                    </div>

                    <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                        <span className={eclCss.stage2labelSide}>Do you want to consider only active NPA cases ?</span>
                        <div className={eclCss.stage2radioContainer}>
                            <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setonlyActiveNPA('Yes')}}>
                                {/* <div className={eclCss.customRadioOuter}>
                                    {onlyActiveNPA === 'Yes' ? <div className={eclCss.customRadioInner}></div> : ''}
                                </div> */}
                                {onlyActiveNPA === 'Yes' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                YES
                            </label>

                            <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setonlyActiveNPA('No')}}>
                                {/* <div className={eclCss.customRadioOuter}>
                                    {onlyActiveNPA === 'No' ? <div className={eclCss.customRadioInner}></div> : ''}
                                </div> */}
                                {onlyActiveNPA === 'No' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                NO
                            </label>
                        </div>
                    </div>

                    <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                        <span className={eclCss.stage2labelSide}>Is LGD computation only for written off loans, or for Live loans also?</span>
                        <div className={eclCss.stage2radioContainer}>
                            <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setwrittenOffOnly('Yes')}}>
                                {/* <div className={eclCss.customRadioOuter}>
                                    {writtenOffOnly === 'Yes' ? <div className={eclCss.customRadioInner}></div> : ''}
                                </div> */}
                                {writtenOffOnly === 'Yes' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                YES
                            </label>

                            <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setwrittenOffOnly('No')}}>
                                {/* <div className={eclCss.customRadioOuter}>
                                    {writtenOffOnly === 'No' ? <div className={eclCss.customRadioInner}></div> : ''}
                                </div> */}
                                {writtenOffOnly === 'No' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                NO
                            </label>
                        </div>
                    </div>

                    <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                        <span className={eclCss.stage2labelSide}>Do you want to consider security value ?</span>
                        <div className={eclCss.stage2radioContainer}>
                            <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setconsiderSecurityValue('Yes')}}>
                                {/* <div className={eclCss.customRadioOuter}>
                                    {considerSecurityValue === 'Yes' ? <div className={eclCss.customRadioInner}></div> : ''}
                                </div> */}
                                {considerSecurityValue === 'Yes' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                YES
                            </label>

                            <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setconsiderSecurityValue('No')}}>
                                {/* <div className={eclCss.customRadioOuter}>
                                    {considerSecurityValue === 'No' ? <div className={eclCss.customRadioInner}></div> : ''}
                                </div> */}
                                {considerSecurityValue === 'No' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                NO
                            </label>
                        </div>
                    </div>

                    <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                        <span className={eclCss.stage2labelSide}>Do you want to consider secondary security as well ?</span>
                        <div className={eclCss.stage2radioContainer}>
                            <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setconsiderSecondarySecurity('Yes')}}>
                                {/* <div className={eclCss.customRadioOuter}>
                                    {considerSecondarySecurity === 'Yes' ? <div className={eclCss.customRadioInner}></div> : ''}
                                </div> */}
                                {considerSecondarySecurity === 'Yes' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                YES
                            </label>

                            <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setconsiderSecondarySecurity('No')}}>
                                {/* <div className={eclCss.customRadioOuter}>
                                    {considerSecondarySecurity === 'No' ? <div className={eclCss.customRadioInner}></div> : ''}
                                </div> */}
                                {considerSecondarySecurity === 'No' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                NO
                            </label>
                        </div>
                    </div>

                    <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                        <span className={eclCss.stage2labelSide}>What is the base value of security? (Primary security)</span>
                        <div className={eclCss.stage2radioContainer}>
                            <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabelRadio} onClick={() => {setbaseValuePrimarySecurity('cost')}}>
                                {/* <div className={eclCss.customRadioOuter}>
                                    {baseValuePrimarySecurity === 'cost' ? <div className={eclCss.customRadioInner}></div> : ''}
                                </div> */}
                                {baseValuePrimarySecurity === 'cost' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                COST
                            </label>

                            <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabelRadio} onClick={() => {setbaseValuePrimarySecurity('fairValue')}}>
                                {/* <div className={eclCss.customRadioOuter}>
                                    {baseValuePrimarySecurity === 'fairValue' ? <div className={eclCss.customRadioInner}></div> : ''}
                                </div> */}
                                {baseValuePrimarySecurity === 'fairValue' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                FAIR VALUE
                            </label>
                        </div>
                    </div>

                    <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                        <span className={eclCss.stage2labelSide}>What is the base value of security? (Secondary security)</span>
                        <div className={eclCss.stage2radioContainer}>
                            <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabelRadio} onClick={() => {setbaseValueSecondarySecurity('cost')}}>
                                {/* <div className={eclCss.customRadioOuter}>
                                    {baseValueSecondarySecurity === 'cost' ? <div className={eclCss.customRadioInner}></div> : ''}
                                </div> */}
                                {baseValueSecondarySecurity === 'cost' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                COST
                            </label>

                            <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabelRadio} onClick={() => {setbaseValueSecondarySecurity('fairValue')}}>
                                {/* <div className={eclCss.customRadioOuter}>
                                    {baseValueSecondarySecurity === 'fairValue' ? <div className={eclCss.customRadioInner}></div> : ''}
                                </div> */}
                                {baseValueSecondarySecurity === 'fairValue' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                FAIR VALUE
                            </label>
                        </div>
                    </div>

                    {/* <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                        <div className={eclCss.pdsInptsContainer}>
                            <div className={eclCss.stage2labelSide}>
                                Enter Percentage
                                <div><small className={eclCss.secondaryLabel}>(Primary security)</small></div>
                            </div>
                            <div className={eclCss.custNumInptContainer}>
                                <div className={eclCss.custInptBox}>
                                    <input
                                        className={eclCss.custInpt}
                                        type="text"
                                        value={percentageOfPrimarySecurity}
                                        onChange={(e) => setpercentageOfPrimarySecurity(Number(e.target.value))}
                                    />
                                </div>
                                <div className={eclCss.custInptIncDescContainerRitPer}>
                                    <div className={eclCss.custInptNumUpArrCont}><PercebtageIcn/></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                        
                        <div className={eclCss.pdsInptsContainer}>
                            <div className={eclCss.stage2labelSide}>
                                Enter Percentage
                                <div><small className={eclCss.secondaryLabel}>(Secondary security)</small></div>
                            </div>
                            <div className={eclCss.custNumInptContainer}>
                                <div className={eclCss.custInptBox}>
                                    <input
                                        className={eclCss.custInpt}
                                        type="text"
                                        value={percentageOfSecondarySecurity}
                                        onChange={(e) => setpercentageOfSecondarySecurity(Number(e.target.value))}
                                    />
                                </div>
                                <div className={eclCss.custInptIncDescContainerRitPer}>
                                    <div className={eclCss.custInptNumUpArrCont}><PercebtageIcn/></div>
                                </div>
                            </div>
                        </div>
                    </div> */}

                    <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer} ${eclCss.jstSpaceBtw}`}>
                        <div className={`${eclCss.pdsInptsContainer} ${eclCss.jstSpaceBtw}`} style={{width: '47%'}}>
                            <div className={eclCss.stage2labelSide}>
                                Enter Percentage
                                <div><small className={eclCss.secondaryLabel}>(Secondary security)</small></div>
                            </div>
                            <div className={eclCss.custNumInptContainer} style={{width:'95px'}}>
                                <div className={eclCss.custInptBox}>
                                    <input
                                        className={eclCss.custInpt}
                                        type="text"
                                        value={percentageOfSecondarySecurity}
                                        onChange={(e) => setpercentageOfSecondarySecurity(Number(e.target.value))}
                                    />
                                </div>
                                <div className={eclCss.custInptIncDescContainerRitPer}>
                                    <div className={eclCss.custInptNumUpArrCont}><PercebtageIcn/></div>
                                </div>
                            </div>
                        </div>
                        <div className={`${eclCss.pdsInptsContainer} ${eclCss.jstSpaceBtw}`} style={{width: '47%'}}>
                            <div className={eclCss.stage2labelSide}>
                                Enter Percentage
                                <div><small className={eclCss.secondaryLabel}>(Secondary security)</small></div>
                            </div>
                            <div className={eclCss.custNumInptContainer} style={{width:'95px'}}>
                                <div className={eclCss.custInptBox}>
                                    <input
                                        className={eclCss.custInpt}
                                        type="text"
                                        value={percentageOfSecondarySecurity}
                                        onChange={(e) => setpercentageOfSecondarySecurity(Number(e.target.value))}
                                    />
                                </div>
                                <div className={eclCss.custInptIncDescContainerRitPer}>
                                    <div className={eclCss.custInptNumUpArrCont}><PercebtageIcn/></div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Hide and un hide left container */}

                    {/* <div className={ `${StageThreeCategorization == 'N' ? eclCss.UnhideContainerHideCategoryContainer : eclCss.hideContainerUnHideCategoryContainer}` }>
                        
                        <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                            <span className={eclCss.stage2labelSide}>What is the base value of security?</span>
                            <div className={eclCss.stage2radioContainer}>
                                <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageThreeValueSecurity('CST')}}>
                                    <div className={eclCss.customRadioOuter}>
                                        {StageThreeValueSecurity == 'CST' ? <div className={eclCss.customRadioInner}></div> : ''}
                                    </div>
                                    COST
                                </label>

                                <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageThreeValueSecurity('FIV')}}>
                                    <div className={eclCss.customRadioOuter}>
                                        {StageThreeValueSecurity == 'FIV' ? <div className={eclCss.customRadioInner}></div> : ''}
                                    </div>
                                    FAIR VALUE
                                </label>
                            </div>
                        </div>

                        <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                            <span className={eclCss.stage2labelSide}>What percentage of base value would you consider?</span>
                        </div>

                        <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}>
                            <div className={eclCss.pdsInptsContainer}>
                                <div className={eclCss.stage2labelSide}>
                                    Enter Percentage
                                </div>
                                <div className={eclCss.custNumInptContainer}>
                                    <div className={eclCss.custInptBox}>
                                        <input
                                            className={eclCss.custInpt}
                                            type="text"
                                            value={StageThreePercentage}
                                            onChange={(e) => setStageThreePercentage(Number(e.target.value))}
                                        />
                                    </div>
                                    <div className={eclCss.custInptIncDescContainerRitPer}>
                                        <div className={eclCss.custInptNumUpArrCont}><PercebtageIcn/></div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}>
                            <div className={eclCss.infoStage2}>
                                <div className={eclCss.infoStageBox}>
                                    <div className={eclCss.stage1IconBox}>
                                        <QuestionMartInfo />
                                    &nbsp; &nbsp;
                                    </div>
                                    <div className={eclCss.stage1InfoText}>
                                        Lorem ipsum dolor sit amet consectetur. Vivamus scelerisque orci et pellentesque nunc ut
                                    </div>
                                </div>
                            </div>
                        </div>
                    
                    </div> */}

                    {/* Left Category Container */}
                    {/* <div className={ `${StageThreeCategorization == 'Y' ? eclCss.UnhideContainerHideCategoryContainer : eclCss.hideContainerUnHideCategoryContainer}` }>

                        <div className={`${eclCss.defineCatgegorysContainer}`}>
                            <div className={eclCss.stagelabel}>Define Categories</div>
                            <Droppable droppableId="left">
                                {(provided) => (
                                    <div className={`${eclCss.defineCardsContainer}`} ref={provided.innerRef} {...provided.droppableProps}>

                                        {leftItems.map((item, index) => (
                                            <Draggable key={item.id} draggableId={item.id} index={index}>
                                                {(provided) => (
                                                    <div className={eclCss.defineCategorycardContainer}  ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} >
                                                        <div className={eclCss.defineCategoryCardHead}>{item.heading}</div>
                                                        <div className={eclCss.defineCategoryCardDesc}>
                                                            <div>
                                                                {item.desc}
                                                            </div> 
                                                        </div>
                                                    </div>
                                                )}
                                            </Draggable>
                                        ))}
                                
                                </div>
                                )}
                            </Droppable>

                            <div className={eclCss.defineCategoryBTNContainer}>
                                <button type="button" onClick={()=>{setActiveStage('C4')}} className={eclCss.defineCategoryPDBtn}>Define PD</button>
                            </div>
                        </div>

                    </div> */}

                </div>
                
                {/* seprator */}
                <div className={eclCss.containerSeprator}> </div>
                
                {/* right container */}
                <div className={eclCss.stage3RightContainer}>

                    <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                        <span className={eclCss.stage2labelSide}>Do you want categorization?</span>
                        <div className={eclCss.stage2radioContainer}>
                            <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setActiveStage('C3'); setStageThreeCategorization('Yes')}}>
                                {/* <div className={eclCss.customRadioOuter}>
                                    {StageThreeCategorization === Number.isInteger(StageThreeCategorization) ? <div className={eclCss.customRadioInner}></div> : ''}
                                </div> */}
                                {StageThreeCategorization === Number.isInteger(StageThreeCategorization) ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                YES
                            </label>

                            <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setActiveStage(3); setStageThreeCategorization('No')}}>
                                {/* <div className={eclCss.customRadioOuter}>
                                    {StageThreeCategorization !== Number.isInteger(StageThreeCategorization) ? <div className={eclCss.customRadioInner}></div> : ''}
                                </div> */}
                                {StageThreeCategorization !== Number.isInteger(StageThreeCategorization) ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                NO
                            </label>
                        </div>
                    </div>

                    {/* <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                        <span className={eclCss.stage2labelSide}>Do you want to consider bad debts written off ?</span>
                        <div className={eclCss.stage2radioContainer}>
                            <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setbadDebtConsider('Yes')}}>
                                {badDebtConsider === 'Yes' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                YES
                            </label>
                            <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setbadDebtConsider('No')}}>
                                {badDebtConsider === 'No' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                NO
                            </label>
                        </div>
                    </div> */}

                    <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                        <div className={eclCss.dragDropMainContainer}>
                            <div className={eclCss.dragtextLabel}>Drag and drop your file here or</div>
                            <button className={eclCss.uploadBtn} type="button"> <UploadIcon style={{ height:'14px' }} />  Uplaod</button>
                        </div>
                    </div>

                    {/* <div className={ `${StageThreeCategorization == 'N' ? eclCss.UnhideContainerHideCategoryContainer : eclCss.hideContainerUnHideCategoryContainer}`}>
                        
                        <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                            <span className={eclCss.stage2labelSide}>Add overlay factor</span>
                            <div className={eclCss.stage2radioContainer}>
                                <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageThreeAddOverlayFactor('Y')}}>
                                    <div className={eclCss.customRadioOuter}>
                                        {StageThreeAddOverlayFactor == 'Y' ? <div className={eclCss.customRadioInner}></div> : ''}
                                    </div>
                                    YES
                                </label>

                                <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageThreeAddOverlayFactor('N')}}>
                                    <div className={eclCss.customRadioOuter}>
                                        {StageThreeAddOverlayFactor == 'N' ? <div className={eclCss.customRadioInner}></div> : ''}
                                    </div>
                                    NO
                                </label>
                            </div>
                        </div>

                        <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                            <input className={eclCss.remarkInptEclCreate} type="text" name="" id="" 
                                value={StageThreeRemarkPercentage}
                                onChange={(e) => setStageThreeRemarkPercentage(e.target.value)}
                                placeholder='Enter Remarks..'
                            />
                            <div className={eclCss.custNumInptContainer}>
                                <div className={eclCss.custInptBox}>
                                    <input
                                        className={eclCss.custInpt}
                                        type="text"
                                        value={StageThreePercentage}
                                        onChange={(e) => setStageThreePercentage(Number(e.target.value))}
                                    />
                                </div>
                                <div className={eclCss.custInptIncDescContainerRitPer}>
                                    <div className={eclCss.custInptNumUpArrCont}><PercebtageIcn/></div>
                                </div>
                            </div>
                        </div>

                        <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}>
                            <div className={eclCss.infoStage2}>
                                <div className={eclCss.infoStageBox}>
                                    <div className={eclCss.stage1IconBox}>
                                        <QuestionMartInfo />
                                    &nbsp; &nbsp;
                                    </div>
                                    <div className={eclCss.stage1InfoText}>
                                        Lorem ipsum dolor sit amet consectetur. Vivamus scelerisque orci et pellentesque nunc ut
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                            <span className={eclCss.addFactorBtn}> <AddEclPlusIcon /> &nbsp; Add New Factor</span>
                        </div>

                        <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                            <span className={eclCss.stage2labelSide}>Do you want to add a further factor?</span>
                            <div className={eclCss.stage2radioContainer}>
                                <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageThreeAddFutherFactor('Y')}}>
                                    <div className={eclCss.customRadioOuter}>
                                        {StageThreeAddFutherFactor == 'Y' ? <div className={eclCss.customRadioInner}></div> : ''}
                                    </div>
                                    YES
                                </label>

                                <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageThreeAddFutherFactor('N')}}>
                                    <div className={eclCss.customRadioOuter}>
                                        {StageThreeAddFutherFactor == 'N' ? <div className={eclCss.customRadioInner}></div> : ''}
                                    </div>
                                    NO
                                </label>
                            </div>
                        </div> */}
                        
                        <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                            <span className={eclCss.stage2labelSide}>Add overlay factor</span>
                            <div className={eclCss.stage2radioContainer}>
                                <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabelRadio} onClick={() => {setaddOverlayFactor('Yes')}}>
                                    {/* <div className={eclCss.customRadioOuter}>
                                        {addOverlayFactor === 'Yes' ? <div className={eclCss.customRadioInner}></div> : ''}
                                    </div> */}
                                    {addOverlayFactor === 'Yes'  ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                    Yes
                                </label>

                                <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabelRadio} onClick={() => {setaddOverlayFactor('No')}}>
                                    {/* <div className={eclCss.customRadioOuter}>
                                        {addOverlayFactor === 'No' ? <div className={eclCss.customRadioInner}></div> : ''}
                                    </div> */}
                                    {addOverlayFactor === 'No' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                    No
                                </label>
                            </div>
                        </div>

                        {[...Array(overlayFactorCount)].map((_, i) => (
                            <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainerFactor}`}>
                                <div className={eclCss.w100}>
                                    <div className={eclCss.stage2radioContainer}>
                                        <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} 
                                            // onClick={() => {saveOveryLayFactores('multiply', 'FactoreMethod', i);}}
                                            onClick={(event) => {
                                                setoverlayFactorDataList(
                                                    prev => {
                                                    const newFactors = [...prev];
                                                    if (newFactors[i]) {
                                                        newFactors[i] = {
                                                        ...newFactors[i],
                                                        method: 'multiply'
                                                        };
                                                    }
                                                    return newFactors;
                                                    }
                                                );
                                            }}
                                        >
                                            {/* <div className={eclCss.customRadioOuter}>
                                                {StageThreeAddOrMultiply === 'multiply' ? <div className={eclCss.customRadioInner}></div> : ''}
                                            </div> */}
                                            {!overlayFactorDataList[i] ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  :  overlayFactorDataList[i].method === 'multiply' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                            MULTIPLY
                                        </label>

                                        <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} 
                                            // onClick={() => {saveOveryLayFactores('add', 'FactoreMethod', i);}}
                                            onClick={(event) => {
                                                setoverlayFactorDataList(
                                                    prev => {
                                                    const newFactors = [...prev];
                                                    if (newFactors[i]) {
                                                        newFactors[i] = {
                                                        ...newFactors[i],
                                                        method: 'add'
                                                        };
                                                    }
                                                    return newFactors;
                                                    }
                                                );
                                            }}
                                        >
                                            {/* <div className={eclCss.customRadioOuter}>
                                                {StageThreeAddOrMultiply === 'add' ? <div className={eclCss.customRadioInner}></div> : ''}
                                            </div> */}
                                            {!overlayFactorDataList[i] ?  <InactiveRadioBtn className={eclCss.custuRadioBtn} />  : overlayFactorDataList[i].method === 'add' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                            ADD
                                        </label>
                                    </div>
                                    <div style={{ marginTop : '10px', width:'100%'}}>
                                        <div className={eclCss.pdsInptsContainer} style={{ width: '50%'}}>
                                            <div className={eclCss.stage2labelSide} style={{width:'max-content'}}>
                                                {!overlayFactorDataList[i] ?  'Multiply by'  : overlayFactorDataList[i].method === 'add' ? 'Add by'  : 'Multiply by'}
                                            </div>
                                            <div className={eclCss.custNumInptContainer}>
                                                <div className={eclCss.custInptBox}>
                                                    <input
                                                        value={overlayFactorDataList[i]?.percentage || ''}
                                                        onChange={(event) => {
                                                                setoverlayFactorDataList(
                                                                    prev => {
                                                                    const newFactors = [...prev];
                                                                    if (newFactors[i]) {
                                                                        newFactors[i] = {
                                                                        ...newFactors[i],
                                                                        percentage: event.target.value
                                                                        };
                                                                    }
                                                                    return newFactors;
                                                                    }
                                                                );
                                                            }}
                                                        className={eclCss.custInpt}
                                                        type="text"
                                                    />
                                                </div>
                                                <div className={eclCss.custInptIncDescContainerRitPer}>
                                                    <div className={eclCss.custInptNumUpArrCont}><PercebtageIcn/></div>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <input type="text" 
                                                className={eclCss.custInptStageThree} 
                                                placeholder='Enter marks...' 
                                                // onChange={(event) => saveOveryLayFactores(event.target.value, 'RemarkInput', i)}    
                                                value={overlayFactorDataList[i]?.remarks || ''}
                                                onChange={(event) => {
                                                                setoverlayFactorDataList(
                                                                    prev => {
                                                                    const newFactors = [...prev];
                                                                    if (newFactors[i]) {
                                                                        newFactors[i] = {
                                                                        ...newFactors[i],
                                                                        remarks: event.target.value
                                                                        };
                                                                    }
                                                                    return newFactors;
                                                                    }
                                                                );
                                                            }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )

                        )}

                        <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainerFactorDir}`}>
                            <button type="button" className={eclCss.stageThreeCatgeAddNewFactBtnContainer} 
                                onClick={() => {
                                    setoverlayFactorCount(overlayFactorCount + 1);
                                    setoverlayFactorDataList(prevList => [
                                    ...prevList,
                                    {
                                        method: 'multiply',
                                        percentage: '',
                                        remarks: '',
                                    }
                                    ]);
                                }}
                                >
                                <AddEclPlusIcon/>&#8201; Add New Factor
                            </button>
                        </div>

                        {/* <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainerFactor}`}>
                            <div className={eclCss.w100}>
                                <div className={eclCss.stage2radioContainer}>
                                    <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageThreeAddOrMultiply('multiply')}}>
                                        <div className={eclCss.customRadioOuter}>
                                            {StageThreeAddOrMultiply == 'multiply' ? <div className={eclCss.customRadioInner}></div> : ''}
                                        </div>
                                        MULTIPLY
                                    </label>

                                    <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageThreeAddOrMultiply('add')}}>
                                        <div className={eclCss.customRadioOuter}>
                                            {StageThreeAddOrMultiply == 'add' ? <div className={eclCss.customRadioInner}></div> : ''}
                                        </div>
                                        ADD
                                    </label>
                                </div>
                                <div style={{ marginTop : '20px', width:'100%'}}>
                                    <div className={eclCss.pdsInptsContainer}>
                                        <div className={eclCss.stage2labelSide}>
                                            Multiply by
                                        </div>
                                        <div className={eclCss.custNumInptContainer}>
                                            <div className={eclCss.custInptBox}>
                                                <input
                                                    className={eclCss.custInpt}
                                                    type="text"
                                                    value={StageThreeMultiplyBy}
                                                    onChange={(e) => setStageThreeMultiplyBy(Number(e.target.value))}
                                                />
                                            </div>
                                            <div className={eclCss.custInptIncDescContainerRitPer}>
                                                <div className={eclCss.custInptNumUpArrCont}><PercebtageIcn/></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <input type="text" className={eclCss.custInptStageThree} placeholder='Enter marks...' />
                                    </div>
                                </div>
                            </div>
                        </div> */}

                        

                        {/* <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                            <textarea
                                value={StageThreeRemarks}
                                onChange={(e) => setStageThreeRemarks(e.target.value)}
                                placeholder="Enter Remarks..."
                                rows={5}
                                cols={40}
                                className={eclCss.textareaCustomECl}
                            />
                        </div> */}

                    {/* </div>  */}

                    {/* Right Category Container */}
                    {/* <div className={ `${StageThreeCategorization == 'Y' ? eclCss.UnhideContainerHideCategoryContainer : eclCss.hideContainerUnHideCategoryContainer}` }>
                        <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                            <span className={eclCss.stage2CategoryDesc}>All possible permutations from definitions have been listed below,
                                Select and click add to continue 
                            </span>
                            <div className={eclCss.stage2radioContainer}>
                            
                            </div>
                            <button type="button" className={eclCss.catgeoryAddSeclectedBtn}>
                                Add Selected
                            </button>
                        </div>
                        
                        <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                            <Droppable droppableId="right" >
                                {(provided) => (
                                    <div className={`${eclCss.defineCardsRightContainer} ${eclCss.Stage2RightDragCustStyl}}`} ref={provided.innerRef} {...provided.droppableProps}> 
                                        
                                        {rightItems.map((item, index) => (
                                            <Draggable key={item.id} draggableId={item.id} index={index}>
                                            {(provided) => (
                                                <div className={eclCss.defineCategorycardContainerRight} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} >
                                                    <div className={eclCss.stage2rightCategoryCardInnerContainer} >
                                                        <div>
                                                            <input type="checkbox" name="" id="" 
                                                                defaultChecked={item.active === 'Y'}
                                                            />
                                                        </div>
                                                        <div>
                                                            <div className={eclCss.defineCategoryCardHead}>{item.heading}</div>
                                                            <div className={eclCss.defineCategoryCardDesc}>
                                                                <div>
                                                                    {item.desc}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            </Draggable>
                                        ))}
                                    </div>
                                )}
                            </Droppable>
                        </div>
                        
                            <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}>
                                <div className={eclCss.infoStage2}>
                                    <div className={eclCss.infoStageBoxNoBg}>
                                        <div className={eclCss.stage1IconBox}>
                                            <QuestionMartInfo />
                                        &nbsp; &nbsp;
                                        </div>
                                        <div className={eclCss.stage1InfoText}>
                                            Lorem ipsum dolor sit amet consectetur. Vivamus scelerisque
                                        </div>
                                        <div className={eclCss.categoryRightBtnNoBgclr}>
                                            Define Category
                                        </div>
                                    </div>
                                </div>
                            </div>

                    </div> */}

                </div>
            </DragDropContext>
        </div>
    )

}



const StageThreeCategoryHeader = ({
    setStageTwoCategoryScenarioModel,
    StageTwoCategoryoptions,
    ActiveStage,
    setActiveStage,
    setStageThreeCategorization
    }) => {
    return(
        <div>
            <div className={`${eclCss.stageTwoCatgorSelecContainer} ${eclCss.custmfadein}`}>

                <div className={eclCss.width40Per}>
                    <Select
                        defaultValue={StageTwoCategoryoptions[0]}
                        components={{ IndicatorSeparator: () => null }} // remove separator
                        onChange={(selectedOption) => setStageTwoCategoryScenarioModel(selectedOption)}
                        options={StageTwoCategoryoptions}
                        placeholder="Select Status"
                        name="status"
                        className={`w-100 mt-0 ${eclCss.selectstyl}`}
                        classNamePrefix="select"
                        styles={customStyles}
                        isClearable={false}
                        isSearchable={false}
                    />
                </div>

                <div className={eclCss.width40Per}>
                    <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer_}`}>
                        <span className={eclCss.stage2labelSide}>Do you want categorization?</span>
                        <div className={eclCss.stage2radioContainer}>
                            <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setActiveStage('C3'); setStageThreeCategorization('Yes')}}>
                                {/* <div className={eclCss.customRadioOuter}>
                                    {ActiveStage !== Number.isInteger(ActiveStage) ? <div className={eclCss.customRadioInner}></div> : ''}
                                </div> */}
                                {ActiveStage !== Number.isInteger(ActiveStage) ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                YES
                            </label>

                            <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setActiveStage(3); setStageThreeCategorization('No')}}>
                                {/* <div className={eclCss.customRadioOuter}>
                                    {ActiveStage === Number.isInteger(ActiveStage) ? <div className={eclCss.customRadioInner}></div> : ''}
                                </div> */}
                                {ActiveStage === Number.isInteger(ActiveStage) ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                NO
                            </label>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}



const StageThreeCategory = ({
    categorysLGDObj,
    setcategorysLGDObj,
    StageThreeActiveCategory,
    setStageThreeActiveCategory,
    categorysData,
}) =>{
    // console.log('categorysLGDObj :: cat three :: ',categorysLGDObj);
    return(

        <div className={`${eclCss.custmfadein} ${eclCss.categoryContainerMain}`}>

            <div className={eclCss.catgegoryContainer}>
                {categorysData.map((item, index) => (
                    <div className={ StageThreeActiveCategory === index ?  index === 0 ? eclCss.activeCategoryTab : eclCss.activeCategoryTabNoRadius : eclCss.inActiveCategoryTab} onClick={() => {setStageThreeActiveCategory(index)}}>
                        <div key={index} style={{ height:'100%', padding: '5px', display:'flex', alignItems:'center' }}>
                            <div className={eclCss.WMaxContant} > {item.category} - {item.subcategory} </div>
                            {/* {item.categoryID} */}
                            {/* <small className={eclCss.smallTxt}>{item.subcategory}</small> */}
                            {/* {item.subcategoryID} */}
                        </div>
                    </div>
                ))}
            </div>

            {categorysData.map((item, index) => ( 
                
                <div className={StageThreeActiveCategory === index ? eclCss.containerShow : eclCss.containerNone}>
                        
                    <div className={eclCss.stage2CategoryContainer}>
                        <div className={eclCss.stageLeftContainer}>
                            
                            <div>

                                <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}>
                                    <div className={eclCss.stagelabel}>PD rate calculation</div>
                                    <div className={eclCss.pdsInptsContainer}>
                                        <div className={`${eclCss.pdInpts} 
                                            ${categorysLGDObj[item.subcategoryID]?.values?.computeLossOn === 'loanSanctionedValue' ? eclCss.pdInptsActive : eclCss.pdInptsInActive}`} 
                                            onClick={() => {
                                                            setcategorysLGDObj(prev => ({
                                                                        ...prev,
                                                                        [item.subcategoryID]: {
                                                                        ...prev[item.subcategoryID],
                                                                        values: {
                                                                            ...prev[item.subcategoryID]?.values,
                                                                            computeLossOn: 'loanSanctionedValue'
                                                                        }
                                                                        }
                                                                }));
                                                            }}
                                        >
                                            Loan sanctioned value
                                        </div>
                                        <div className={`${eclCss.pdInpts}
                                            ${categorysLGDObj[item.subcategoryID]?.values?.computeLossOn === 'loanDisbursedValue' ? eclCss.pdInptsActive : eclCss.pdInptsInActive}`} 
                                            onClick={() => {
                                                            setcategorysLGDObj(prev => ({
                                                                    ...prev,
                                                                    [item.subcategoryID]: {
                                                                    ...prev[item.subcategoryID],
                                                                    values: {
                                                                        ...prev[item.subcategoryID]?.values,
                                                                        computeLossOn: 'loanDisbursedValue'
                                                                    }
                                                                }
                                                            }));
                                                            }}
                                            >
                                            Loan disbursed value
                                        </div>
                                        <div className={`${eclCss.pdInpts} 
                                            ${categorysLGDObj[item.subcategoryID]?.values?.computeLossOn === 'outstandingLoanValue' ? eclCss.pdInptsActive : eclCss.pdInptsInActive}`} 
                                            onClick={() => {
                                                            setcategorysLGDObj(prev => ({
                                                                    ...prev,
                                                                    [item.subcategoryID]: {
                                                                    ...prev[item.subcategoryID],
                                                                    values: {
                                                                        ...prev[item.subcategoryID]?.values,
                                                                        computeLossOn: 'outstandingLoanValue'
                                                                    }
                                                                }
                                                            }));
                                                        }}
                                            >
                                            Outstanding loan value
                                        </div>
                                    </div>
                                </div>

                                <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                                    <span className={eclCss.stage2labelSide}>Do you want to consider interest on EMI for delayed payment ?</span>
                                    <div className={eclCss.stage2radioContainer}>
                                        <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} 
                                            onClick={() => {
                                                                setcategorysLGDObj(prev => ({
                                                                        ...prev,
                                                                        [item.subcategoryID]: {
                                                                        ...prev[item.subcategoryID],
                                                                        values: {
                                                                            ...prev[item.subcategoryID]?.values,
                                                                            considerInterestEMIDelayedPayment: 'Yes'
                                                                        }
                                                                    }
                                                                }));
                                                            }}
                                        >
                                            {/* <div className={eclCss.customRadioOuter}> */}
                                                {categorysLGDObj[item.subcategoryID]?.values?.considerInterestEMIDelayedPayment === 'Yes' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} /> : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                            {/* </div> */}
                                            YES
                                        </label>

                                        <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} 
                                            onClick={() => {
                                                                setcategorysLGDObj(prev => ({
                                                                        ...prev,
                                                                        [item.subcategoryID]: {
                                                                        ...prev[item.subcategoryID],
                                                                        values: {
                                                                            ...prev[item.subcategoryID]?.values,
                                                                            considerInterestEMIDelayedPayment: 'No'
                                                                        }
                                                                    }
                                                                }));
                                                            }}
                                        >
                                            {/* <div className={eclCss.customRadioOuter}> */}
                                                {categorysLGDObj[item.subcategoryID]?.values?.considerInterestEMIDelayedPayment === 'No' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} /> : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                            {/* </div> */}
                                            NO
                                        </label>
                                    </div>
                                </div>

                                <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                                    <span className={eclCss.stage2labelSide}>Do you want to consider penal charges for computation ?</span>
                                    <div className={eclCss.stage2radioContainer}>
                                        <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} 
                                            onClick={() => {
                                                                setcategorysLGDObj(prev => ({
                                                                        ...prev,
                                                                        [item.subcategoryID]: {
                                                                        ...prev[item.subcategoryID],
                                                                        values: {
                                                                            ...prev[item.subcategoryID]?.values,
                                                                            considerPenalCharges: 'Yes'
                                                                        }
                                                                    }
                                                                }));
                                                            }}
                                            // onClick={() => {setStageThreeCategorization('Y')}}
                                            >
                                            {/* <div className={eclCss.customRadioOuter}> */}
                                                {/* {StageThreeCategorization == 'Y' ? <div className={eclCss.customRadioInner}></div> : ''} */}
                                            {/* </div> */}
                                            {categorysLGDObj[item.subcategoryID]?.values?.considerPenalCharges === 'Yes' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} /> : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                            YES
                                        </label>

                                        <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} 
                                            onClick={() => {setcategorysLGDObj(prev => ({
                                                                        ...prev,
                                                                        [item.subcategoryID]: {
                                                                        ...prev[item.subcategoryID],
                                                                        values: {
                                                                            ...prev[item.subcategoryID]?.values,
                                                                            considerPenalCharges: 'No'
                                                                        }
                                                                    }
                                                                }));
                                                            }}
                                            // onClick={() => {setStageThreeCategorization('N')}}
                                            >
                                            {/* <div className={eclCss.customRadioOuter}>
                                                {StageThreeCategorization == 'N' ? <div className={eclCss.customRadioInner}></div> : ''}
                                            </div> */}
                                            {categorysLGDObj[item.subcategoryID]?.values?.considerPenalCharges === 'No' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} /> : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                            NO
                                        </label>
                                    </div>
                                </div>

                                <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                                    <span className={eclCss.stage2labelSide}>Would you like to consider charges incurred on recovery of loan amount ?</span>
                                    <div className={eclCss.stage2radioContainer}>
                                        <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} 
                                            onClick={() => {setcategorysLGDObj(prev => ({
                                                                        ...prev,
                                                                        [item.subcategoryID]: {
                                                                        ...prev[item.subcategoryID],
                                                                        values: {
                                                                            ...prev[item.subcategoryID]?.values,
                                                                            considerRecoveryCharges: 'Yes'
                                                                        }
                                                                    }
                                                                }));
                                                            }}
                                            // onClick={() => {setStageThreeCategorization('Y')}}
                                            >
                                            {/* <div className={eclCss.customRadioOuter}>
                                                {StageThreeCategorization == 'Y' ? <div className={eclCss.customRadioInner}></div> : ''}
                                            </div> */}
                                            {categorysLGDObj[item.subcategoryID]?.values?.considerRecoveryCharges === 'Yes' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} /> : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                            YES
                                        </label>

                                        <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} 
                                            onClick={() => {setcategorysLGDObj(prev => ({
                                                                        ...prev,
                                                                        [item.subcategoryID]: {
                                                                        ...prev[item.subcategoryID],
                                                                        values: {
                                                                            ...prev[item.subcategoryID]?.values,
                                                                            considerRecoveryCharges: 'No'
                                                                        }
                                                                    }
                                                                }));
                                                            }}
                                            // onClick={() => {setStageThreeCategorization('N')}}
                                            >
                                            {/* <div className={eclCss.customRadioOuter}>
                                                {StageThreeCategorization == 'N' ? <div className={eclCss.customRadioInner}></div> : ''}
                                            </div> */}
                                            {categorysLGDObj[item.subcategoryID]?.values?.considerRecoveryCharges === 'No' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} /> : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                            NO
                                        </label>
                                    </div>
                                </div>

                                <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                                    <span className={eclCss.stage2labelSide}>Do you want to consider only active NPA cases ?</span>
                                    <div className={eclCss.stage2radioContainer}>
                                        <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} 
                                            onClick={() => {setcategorysLGDObj(prev => ({
                                                                        ...prev,
                                                                        [item.subcategoryID]: {
                                                                        ...prev[item.subcategoryID],
                                                                        values: {
                                                                            ...prev[item.subcategoryID]?.values,
                                                                            onlyActiveNPA: 'Yes'
                                                                        }
                                                                    }
                                                                }));
                                                            }}
                                        >
                                            {/* <div className={eclCss.customRadioOuter}>
                                                {StageThreeCategorization == 'Y' ? <div className={eclCss.customRadioInner}></div> : ''}
                                            </div> */}
                                            {categorysLGDObj[item.subcategoryID]?.values?.onlyActiveNPA === 'Yes' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} /> : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                            YES
                                        </label>

                                        <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} 
                                            onClick={() => {setcategorysLGDObj(prev => ({
                                                                        ...prev,
                                                                        [item.subcategoryID]: {
                                                                        ...prev[item.subcategoryID],
                                                                        values: {
                                                                            ...prev[item.subcategoryID]?.values,
                                                                            onlyActiveNPA: 'No'
                                                                        }
                                                                    }
                                                                }));
                                                            }}
                                        >
                                            {/* <div className={eclCss.customRadioOuter}>
                                                {StageThreeCategorization == 'N' ? <div className={eclCss.customRadioInner}></div> : ''}
                                            </div> */}
                                            {categorysLGDObj[item.subcategoryID]?.values?.onlyActiveNPA === 'No' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} /> : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                            NO
                                        </label>
                                    </div>
                                </div>

                                <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                                    <span className={eclCss.stage2labelSide}>Is LGD computation only for written off loans, or for Live loans also?</span>
                                    <div className={eclCss.stage2radioContainer}>
                                        <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} 
                                            onClick={() => {setcategorysLGDObj(prev => ({
                                                                        ...prev,
                                                                        [item.subcategoryID]: {
                                                                        ...prev[item.subcategoryID],
                                                                        values: {
                                                                            ...prev[item.subcategoryID]?.values,
                                                                            writtenOffOnly: 'Yes'
                                                                        }
                                                                    }
                                                                }));
                                                            }}
                                            // onClick={() => {setStageThreeCategorization('Y')}}
                                            >
                                            {/* <div className={eclCss.customRadioOuter}>
                                                {StageThreeCategorization == 'Y' ? <div className={eclCss.customRadioInner}></div> : ''}
                                            </div> */}
                                            {categorysLGDObj[item.subcategoryID]?.values?.writtenOffOnly === 'Yes' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} /> : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                            YES
                                        </label>

                                        <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} 
                                            onClick={() => {setcategorysLGDObj(prev => ({
                                                                        ...prev,
                                                                        [item.subcategoryID]: {
                                                                        ...prev[item.subcategoryID],
                                                                        values: {
                                                                            ...prev[item.subcategoryID]?.values,
                                                                            writtenOffOnly: 'No'
                                                                        }
                                                                    }
                                                                }));
                                                            }}
                                            // onClick={() => {setStageThreeCategorization('N')}}
                                            >
                                            {/* <div className={eclCss.customRadioOuter}>
                                                {StageThreeCategorization == 'N' ? <div className={eclCss.customRadioInner}></div> : ''}
                                            </div> */}
                                            {categorysLGDObj[item.subcategoryID]?.values?.writtenOffOnly === 'No' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} /> : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                            NO
                                        </label>
                                    </div>
                                </div>

                                <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                                    <span className={eclCss.stage2labelSide}>Do you want to consider security value ?</span>
                                    <div className={eclCss.stage2radioContainer}>
                                        <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} 
                                            onClick={() => {setcategorysLGDObj(prev => ({
                                                                        ...prev,
                                                                        [item.subcategoryID]: {
                                                                        ...prev[item.subcategoryID],
                                                                        values: {
                                                                            ...prev[item.subcategoryID]?.values,
                                                                            considerSecurityValue: 'Yes'
                                                                        }
                                                                    }
                                                                }));
                                                            }}
                                            // onClick={() => {setStageThreeCategorization('Y')}}
                                            >
                                            {/* <div className={eclCss.customRadioOuter}>
                                                {StageThreeCategorization == 'Y' ? <div className={eclCss.customRadioInner}></div> : ''}
                                            </div> */}
                                            {categorysLGDObj[item.subcategoryID]?.values?.considerSecurityValue === 'Yes' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} /> : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                            YES
                                        </label>

                                        <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} 
                                            onClick={() => {setcategorysLGDObj(prev => ({
                                                                        ...prev,
                                                                        [item.subcategoryID]: {
                                                                        ...prev[item.subcategoryID],
                                                                        values: {
                                                                            ...prev[item.subcategoryID]?.values,
                                                                            considerSecurityValue: 'No'
                                                                        }
                                                                    }
                                                                }));
                                                            }}
                                            // onClick={() => {setStageThreeCategorization('N')}}
                                            >
                                            {/* <div className={eclCss.customRadioOuter}>
                                                {StageThreeCategorization == 'N' ? <div className={eclCss.customRadioInner}></div> : ''}
                                            </div> */}
                                            {categorysLGDObj[item.subcategoryID]?.values?.considerSecurityValue === 'No' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} /> : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                            NO
                                        </label>
                                    </div>
                                </div>

                                <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                                    <span className={eclCss.stage2labelSide}>Do you want to consider secondary security as well ?</span>
                                    <div className={eclCss.stage2radioContainer}>
                                        <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} 
                                            // onClick={() => {setStageThreeCategorization('Y')}}
                                            onClick={() => {
                                                                setcategorysLGDObj(prev => ({
                                                                        ...prev,
                                                                        [item.subcategoryID]: {
                                                                        ...prev[item.subcategoryID],
                                                                        values: {
                                                                            ...prev[item.subcategoryID]?.values,
                                                                             considerSecondarySecurity: 'Yes'
                                                                        }
                                                                    }
                                                                }));
                                                            }}
                                        >
                                            {/* <div className={eclCss.customRadioOuter}>
                                                {StageThreeCategorization == 'Y' ? <div className={eclCss.customRadioInner}></div> : ''}
                                            </div> */}
                                             {categorysLGDObj[item.subcategoryID]?.values?.considerSecondarySecurity === 'Yes' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} /> : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                            YES
                                        </label>

                                        <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} 
                                            onClick={() => {setcategorysLGDObj(prev => ({
                                                                        ...prev,
                                                                        [item.subcategoryID]: {
                                                                        ...prev[item.subcategoryID],
                                                                        values: {
                                                                            ...prev[item.subcategoryID]?.values,
                                                                             considerSecondarySecurity: 'No'
                                                                        }
                                                                    }
                                                                }));
                                                            }}
                                            // onClick={() => {setStageThreeCategorization('N')}}
                                        >
                                            {/* <div className={eclCss.customRadioOuter}>
                                                {StageThreeCategorization == 'N' ? <div className={eclCss.customRadioInner}></div> : ''}
                                            </div> */}
                                            {categorysLGDObj[item.subcategoryID]?.values?.considerSecondarySecurity === 'No' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} /> : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                            NO
                                        </label>
                                    </div>
                                </div>

                                <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                                    <span className={eclCss.stage2labelSide}>What is the base value of security? (Primary security)</span>
                                    <div className={eclCss.stage2radioContainer}>
                                        <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabelRadio} 
                                            onClick={() => {setcategorysLGDObj(prev => ({
                                                                        ...prev,
                                                                        [item.subcategoryID]: {
                                                                        ...prev[item.subcategoryID],
                                                                        values: {
                                                                            ...prev[item.subcategoryID]?.values,
                                                                            baseValuePrimarySecurity: 'cost'
                                                                        }
                                                                    }
                                                                }));
                                                            }}
                                            >
                                            {categorysLGDObj[item.subcategoryID]?.values?.baseValuePrimarySecurity === 'cost' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} /> : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                            COST
                                        </label>

                                        <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabelRadio} 
                                            onClick={() => {setcategorysLGDObj(prev => ({
                                                                        ...prev,
                                                                        [item.subcategoryID]: {
                                                                        ...prev[item.subcategoryID],
                                                                        values: {
                                                                            ...prev[item.subcategoryID]?.values,
                                                                            baseValuePrimarySecurity: 'fairValue'
                                                                        }
                                                                    }
                                                                }));
                                                            }}
                                            >
                                            {categorysLGDObj[item.subcategoryID]?.values?.baseValuePrimarySecurity === 'fairValue' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} /> : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                            FAIR VALUE
                                        </label>
                                    </div>
                                </div>

                                <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                                    <span className={eclCss.stage2labelSide}>What is the base value of security? (Secondary security)</span>
                                    <div className={eclCss.stage2radioContainer}>
                                        <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabelRadio} 
                                            onClick={() => {
                                                                setcategorysLGDObj(prev => ({
                                                                        ...prev,
                                                                        [item.subcategoryID]: {
                                                                        ...prev[item.subcategoryID],
                                                                        values: {
                                                                            ...prev[item.subcategoryID]?.values,
                                                                            baseValueSecondarySecurity: 'cost'
                                                                        }
                                                                    }
                                                                }));
                                                            }}
                                            >
                                            {categorysLGDObj[item.subcategoryID]?.values?.baseValueSecondarySecurity === 'cost' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} /> : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                            COST
                                        </label>

                                        <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabelRadio} 
                                            onClick={() => {setcategorysLGDObj(prev => ({
                                                                        ...prev,
                                                                        [item.subcategoryID]: {
                                                                        ...prev[item.subcategoryID],
                                                                        values: {
                                                                            ...prev[item.subcategoryID]?.values,
                                                                            baseValueSecondarySecurity: 'fairValue'
                                                                        }
                                                                    }
                                                                }));
                                                            }}
                                            >
                                            {categorysLGDObj[item.subcategoryID]?.values?.baseValueSecondarySecurity === 'fairValue' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} /> : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                            FAIR VALUE
                                        </label>
                                    </div>
                                </div>

                                {/* <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                                    <div className={eclCss.pdsInptsContainer}>
                                        <div className={eclCss.stage2labelSide}>
                                            Enter Percentage
                                            <div><small className={eclCss.secondaryLabel}>Primary security</small></div>
                                        </div>
                                        <div className={eclCss.custNumInptContainer}>
                                            <div className={eclCss.custInptBox}>
                                                <input
                                                    className={eclCss.custInpt}
                                                    type="text"
                                                    value={ categorysLGDObj[item.subcategoryID]?.values?.percentageOfPrimarySecurity}
                                                    onChange={(e) => {
                                                        const newVal = e.target.value;
                                                        setcategorysLGDObj(prev => ({
                                                                            ...prev,
                                                                            [item.subcategoryID]: {
                                                                            ...prev[item.subcategoryID],
                                                                            values: {
                                                                                ...prev[item.subcategoryID]?.values,
                                                                                percentageOfPrimarySecurity: Number(newVal)
                                                                            }
                                                                        }
                                                                    }));
                                                    }}
                                                />
                                            </div>
                                            <div className={eclCss.custInptIncDescContainerRitPer}>
                                                <div className={eclCss.custInptNumUpArrCont}><PercebtageIcn/></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                                    <div className={eclCss.pdsInptsContainer}>
                                        <div className={eclCss.stage2labelSide}>
                                            Enter Percentage
                                            <div><small className={eclCss.secondaryLabel}>Secondary security</small></div>
                                        </div>
                                        <div className={eclCss.custNumInptContainer}>
                                            <div className={eclCss.custInptBox}>
                                                <input
                                                    className={eclCss.custInpt}
                                                    type="text"
                                                    value={ categorysLGDObj[item.subcategoryID]?.values?.percentageOfSecondarySecurity || ""}
                                                    onChange={(e) => {
                                                        const newVal = e.target.value;
                                                        setcategorysLGDObj(prev => ({
                                                                            ...prev,
                                                                            [item.subcategoryID]: {
                                                                            ...prev[item.subcategoryID],
                                                                            values: {
                                                                                ...prev[item.subcategoryID]?.values,
                                                                                percentageOfSecondarySecurity: Number(newVal)
                                                                            }
                                                                        }
                                                                    }));
                                                    }}
                                                />
                                            </div>
                                            <div className={eclCss.custInptIncDescContainerRitPer}>
                                                <div className={eclCss.custInptNumUpArrCont}><PercebtageIcn/></div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}

                                <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                                            
                                    <div className={eclCss.pdsInptsContainer} style={{width: '47%'}}>
                                        <div className={eclCss.stage2labelSide}>
                                            Enter Percentage
                                            <div><small className={eclCss.secondaryLabel}>Primary security</small></div>
                                        </div>
                                        <div className={eclCss.custNumInptContainer} style={{width: '95px'}}>
                                            <div className={eclCss.custInptBox}>
                                                <input
                                                    className={eclCss.custInpt}
                                                    type="text"
                                                    value={ categorysLGDObj[item.subcategoryID]?.values?.percentageOfPrimarySecurity}
                                                    onChange={(e) => {
                                                        const newVal = e.target.value;
                                                        setcategorysLGDObj(prev => ({
                                                                            ...prev,
                                                                            [item.subcategoryID]: {
                                                                            ...prev[item.subcategoryID],
                                                                            values: {
                                                                                ...prev[item.subcategoryID]?.values,
                                                                                percentageOfPrimarySecurity: Number(newVal)
                                                                            }
                                                                        }
                                                                    }));
                                                    }}
                                                />
                                            </div>
                                            <div className={eclCss.custInptIncDescContainerRitPer} style={{ paddingRight:'10px' }}>
                                                <div className={eclCss.custInptNumUpArrCont}><PercebtageIcn/></div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <div className={eclCss.pdsInptsContainer} style={{width: '47%'}}>
                                        <div className={eclCss.stage2labelSide}>
                                            Enter Percentage
                                            <div><small className={eclCss.secondaryLabel}>Secondary security</small></div>
                                        </div>
                                        <div className={eclCss.custNumInptContainer} style={{width: '95px'}}>
                                            <div className={eclCss.custInptBox}>
                                                <input
                                                    className={eclCss.custInpt}
                                                    type="text"
                                                    value={ categorysLGDObj[item.subcategoryID]?.values?.percentageOfSecondarySecurity || ""}
                                                    onChange={(e) => {
                                                        const newVal = e.target.value;
                                                        setcategorysLGDObj(prev => ({
                                                                            ...prev,
                                                                            [item.subcategoryID]: {
                                                                            ...prev[item.subcategoryID],
                                                                            values: {
                                                                                ...prev[item.subcategoryID]?.values,
                                                                                percentageOfSecondarySecurity: Number(newVal)
                                                                            }
                                                                        }
                                                                    }));
                                                    }}
                                                />
                                            </div>
                                            <div className={eclCss.custInptIncDescContainerRitPer} style={{ paddingRight:'10px' }}>
                                                <div className={eclCss.custInptNumUpArrCont}><PercebtageIcn/></div>
                                            </div>
                                        </div>
                                    </div>


                                </div>

                                {/* <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                                    <span className={eclCss.stage2labelSide}>What percentage of base value would you consider?</span>
                                </div>

                                <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}>
                                    <div className={eclCss.pdsInptsContainer}>
                                        <div className={eclCss.stage2labelSide}>
                                            Enter Percentage
                                        </div>
                                        <div className={eclCss.custNumInptContainer}>
                                            <div className={eclCss.custInptBox}>
                                                <input
                                                    className={eclCss.custInpt}
                                                    type="text"
                                                    value={StageThreeCatgoryPercentage}
                                                    onChange={(e) => setStageThreeCatgoryPercentage(e.target.value)}
                                                />
                                            </div>
                                            <div className={eclCss.custInptIncDescContainerRitPer}>
                                                <div className={eclCss.custInptNumUpArrCont}><PercebtageIcn/></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}>
                                    <div className={eclCss.infoStage2}>
                                        <div className={eclCss.infoStageBox}>
                                            <div className={eclCss.stage1IconBox}>
                                                <QuestionMartInfo />
                                            &nbsp; &nbsp;
                                            </div>
                                            <div className={eclCss.stage1InfoText}>
                                                Lorem ipsum dolor sit amet consectetur. Vivamus scelerisque orci et pellentesque nunc ut
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                                    <span className={eclCss.stage2labelSide}>Include interest on defaulted payments?</span>
                                    <div className={eclCss.stage2radioContainer}>
                                        <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageThreeCatgorydefaultPayment('Y')}}>
                                            <div className={eclCss.customRadioOuter}>
                                                {StageThreeCatgorydefaultPayment == 'Y' ? <div className={eclCss.customRadioInner}></div> : ''}
                                            </div>
                                            YES
                                        </label>

                                        <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageThreeCatgorydefaultPayment('N')}}>
                                            <div className={eclCss.customRadioOuter}>
                                                {StageThreeCatgorydefaultPayment == 'N' ? <div className={eclCss.customRadioInner}></div> : ''}
                                            </div>
                                            NO
                                        </label>
                                    </div>
                                </div> */}

                            </div>

                        </div>

                        {/* seprator */}
                        <div className={eclCss.containerSeprator}></div>

                        <div className={eclCss.stage2RightContainer}>

                            <div className={ `${ eclCss.UnhideContainerHideCategoryContainer }`}>

                                <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                                    <span className={eclCss.stage2labelSide}>Do you want to consider bad debts written off ?</span>
                                    <div className={eclCss.stage2radioContainer}>
                                        <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} 
                                            onClick={() => {
                                                            setcategorysLGDObj(prev => ({
                                                                    ...prev,
                                                                    [item.subcategoryID]: {
                                                                    ...prev[item.subcategoryID],
                                                                    values: {
                                                                        ...prev[item.subcategoryID]?.values,
                                                                        badDebtConsider: 'Yes'
                                                                    }
                                                                }
                                                            }));

                                                        }}
                                        >
                                            {categorysLGDObj[item.subcategoryID]?.values?.badDebtConsider === 'Yes' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} /> : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                            YES
                                        </label>

                                        <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} 
                                            onClick={() => {setcategorysLGDObj(prev => ({
                                                                        ...prev,
                                                                        [item.subcategoryID]: {
                                                                        ...prev[item.subcategoryID],
                                                                        values: {
                                                                            ...prev[item.subcategoryID]?.values,
                                                                            badDebtConsider: 'No'
                                                                        }
                                                                    }
                                                                }));
                                                            }}
                                        >
                                            {categorysLGDObj[item.subcategoryID]?.values.badDebtConsider === 'No' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} /> : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                            NO
                                        </label>
                                    </div>
                                </div>
                                
                                <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                                    <div className={eclCss.dragDropMainContainer}>
                                        <div className={eclCss.dragtextLabel}>Drag and drop your file here or</div>
                                        <button className={eclCss.uploadBtn} type="button"> <UploadIcon />  Uplaod</button>
                                    </div>
                                </div>

                                <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                                    <span className={eclCss.stage2labelSide}>Add overlay factor</span>
                                    <div className={eclCss.stage2radioContainer}>
                                        <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabelRadio} 
                                            onClick={() => {setcategorysLGDObj(prev => ({
                                                                        ...prev,
                                                                        [item.subcategoryID]: {
                                                                        ...prev[item.subcategoryID],
                                                                        values: {
                                                                            ...prev[item.subcategoryID]?.values,
                                                                            addOverlayFactor: 'Yes'
                                                                        }
                                                                    }
                                                                }));
                                                            }}
                                            >
                                            {/* <div className={eclCss.customRadioOuter}>
                                                {addOverlayFactor === 'Yes' ? <div className={eclCss.customRadioInner}></div> : ''}
                                            </div> */}
                                            {categorysLGDObj?.[item.subcategoryID]?.values?.addOverlayFactor === 'Yes'  ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                            Yes
                                        </label>

                                        <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabelRadio} 
                                            // onClick={() => {setaddOverlayFactor('No')}}
                                            onClick={() => {setcategorysLGDObj(prev => ({
                                                                            ...prev,
                                                                            [item.subcategoryID]: {
                                                                            ...prev[item.subcategoryID],
                                                                            values: {
                                                                                ...prev[item.subcategoryID]?.values,
                                                                                addOverlayFactor: 'No'
                                                                            }
                                                                        }
                                                                    }));
                                                                }}
                                        >
                                            {/* <div className={eclCss.customRadioOuter}>
                                                {addOverlayFactor === 'No' ? <div className={eclCss.customRadioInner}></div> : ''}
                                            </div> */}
                                            {categorysLGDObj?.[item.subcategoryID]?.values?.addOverlayFactor === 'No' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                            No
                                        </label>
                                    </div>
                                </div>

                                {[...Array(categorysLGDObj[item.subcategoryID]?.values.overlayFactor.length)].map((_, i) => ( 
                                    <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainerFactor}`}>
                                        <div className={eclCss.w100}>
                                            <div className={eclCss.stage2radioContainer}>
                                                <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} 
                                                        onClick={() => {
                                                        setcategorysLGDObj(prev => {
                                                            const subID = item.subcategoryID;
                                                            const prevGlobal = prev?.[subID]?.values || {};
                                                            const oldOverlay = prevGlobal.overlayFactor || [];

                                                            const newOverlay = [...oldOverlay];
                                                            newOverlay[i] = {
                                                            ...newOverlay[i],
                                                            method: 'multiply',
                                                            };

                                                            return {
                                                            ...prev,
                                                            [subID]: {
                                                                ...prev[subID],
                                                                values: {
                                                                ...prevGlobal,
                                                                overlayFactor: newOverlay
                                                                }
                                                            }
                                                            };
                                                        });
                                                        }}
                                                    >
                                                    {
                                                        categorysLGDObj?.[item.subcategoryID]?.values?.overlayFactor?.[i]?.method === 'multiply'
                                                            ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />
                                                            : <InactiveRadioBtn className={eclCss.custuRadioBtn} />
                                                    }

                                                    MULTIPLY
                                                </label>

                                                <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} 
                                                    onClick={() => {
                                                        setcategorysLGDObj(prev => {
                                                            const subID = item.subcategoryID;
                                                            const prevGlobal = prev?.[subID]?.values || {};
                                                            const oldOverlay = prevGlobal.overlayFactor || [];

                                                            const newOverlay = [...oldOverlay];
                                                            newOverlay[i] = {
                                                            ...newOverlay[i],
                                                            method: 'add',
                                                            };

                                                            return {
                                                            ...prev,
                                                            [subID]: {
                                                                ...prev[subID],
                                                                values: {
                                                                ...prevGlobal,
                                                                overlayFactor: newOverlay
                                                                }
                                                            }
                                                            };
                                                        });
                                                        }}

                                                >
                                                    {
                                                        categorysLGDObj?.[item.subcategoryID]?.values?.overlayFactor?.[i]?.method === 'add'
                                                            ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />
                                                            : <InactiveRadioBtn className={eclCss.custuRadioBtn} />
                                                    }
                                                    ADD
                                                </label>
                                            </div>
                                            <div style={{ marginTop : '10px', width:'100%'}}>
                                                <div className={eclCss.pdsInptsContainer}>
                                                    <div className={eclCss.stage2labelSide} style={{width: 'max-content'}}>
                                                        {/* Multiply by */}

                                                        { categorysLGDObj[item.subcategoryID]?.values.overlayFactor[i].method === 'add' ? 'Add' : 'Multiply'}
                                                    </div>
                                                    <div className={eclCss.custNumInptContainer}>
                                                        <div className={eclCss.custInptBox}>
                                                            <input
                                                                className={eclCss.custInpt}
                                                                type="text"
                                                                value={
                                                                    categorysLGDObj?.[item.subcategoryID]?.values?.overlayFactor?.[i]?.percentage || ''
                                                                }
                                                                onChange={(e) => {
                                                                    const newVal = e.target.value;
                                                                    setcategorysLGDObj(prev => {
                                                                        const subID = item.subcategoryID;
                                                                        const old = prev[subID] || {};
                                                                        const oldGlobal = old.values || {};
                                                                        const oldOverlay = oldGlobal.overlayFactor || [];

                                                                        const newOverlay = [...oldOverlay];
                                                                        newOverlay[i] = {
                                                                        ...newOverlay[i],
                                                                        percentage: parseInt(newVal)
                                                                        };

                                                                        return {
                                                                        ...prev,
                                                                        [subID]: {
                                                                            ...old,
                                                                            values: {
                                                                            ...oldGlobal,
                                                                            overlayFactor: newOverlay
                                                                            }
                                                                        }
                                                                        };
                                                                    });
                                                                    }}
                                                            />
                                                        </div>
                                                        <div className={eclCss.custInptIncDescContainerRitPer}>
                                                            <div className={eclCss.custInptNumUpArrCont}><PercebtageIcn/></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div>
                                                    <input type="text" className={eclCss.custInptStageThree} placeholder='Enter marks...'
                                                    value={
                                                            categorysLGDObj?.[item.subcategoryID]?.values?.overlayFactor?.[i]?.remarks || ''
                                                        }
                                                    onChange={(e) => {
                                                        const newVal = e.target.value;

                                                        setcategorysLGDObj(prev => {
                                                            const subID = item.subcategoryID;
                                                            const old = prev[subID] || {};
                                                            const oldGlobal = old.values || {};
                                                            const oldOverlay = oldGlobal.overlayFactor || [];

                                                            const newOverlay = [...oldOverlay];
                                                            newOverlay[i] = {
                                                            ...newOverlay[i],
                                                            remarks: newVal
                                                            };

                                                            return {
                                                            ...prev,
                                                            [subID]: {
                                                                ...old,
                                                                values: {
                                                                ...oldGlobal,
                                                                overlayFactor: newOverlay
                                                                }
                                                            }
                                                            };
                                                        });
                                                        }}

                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                                
                                

                                <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainerFactorDir}`}>
                                    <button type="button" className={eclCss.stageThreeCatgeAddNewFactBtnContainer} 
                                        onClick={() => {
                                            setcategorysLGDObj(prev => {
                                                const subID = item.subcategoryID;
                                                const old = prev[subID] || {};
                                                const oldGlobal = old.values || {};

                                                const newCount = (oldGlobal.overlayFactorCount || 0) + 1;
                                                const oldFactors = oldGlobal.overlayFactor || [];

                                                const newOverlayFactor = {
                                                method: 'multiply',
                                                percentage: '',
                                                remarks: ''
                                                };

                                                return {
                                                ...prev,
                                                [subID]: {
                                                    ...old,
                                                    values: {
                                                    ...oldGlobal,
                                                    overlayFactorCount: newCount,
                                                    overlayFactor: [...oldFactors, newOverlayFactor]
                                                    }
                                                }
                                                };
                                            });
                                            }}
                                    >
                                        <AddEclPlusIcon/> Add New Factor
                                    </button>
                                </div>
                                
                                
                                {/* <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                                    <span className={eclCss.stage2labelSide}>Add macro-economic factors?</span>
                                    <div className={eclCss.stage2radioContainer}>
                                        <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageThreeCatgoryMicroEcom('Y')}}>
                                            <div className={eclCss.customRadioOuter}>
                                                {StageThreeCatgoryMicroEcom == 'Y' ? <div className={eclCss.customRadioInner}></div> : ''}
                                            </div>
                                            YES
                                        </label>

                                        <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageThreeCatgoryMicroEcom('N')}}>
                                            <div className={eclCss.customRadioOuter}>
                                                {StageThreeCatgoryMicroEcom == 'N' ? <div className={eclCss.customRadioInner}></div> : ''}
                                            </div>
                                            NO
                                        </label>
                                    </div>
                                </div>

                                <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                                    <input className={eclCss.remarkInptEclCreate} type="text" name="" id="" 
                                        value={StageThreeCatgoryRemarkPercentage}
                                        onChange={(e) => setStageThreeCatgoryRemarkPercentage(e.target.value)}
                                        placeholder='Enter Remarks..'
                                    />
                                    <div className={eclCss.custNumInptContainer}>
                                        <div className={eclCss.custInptBox}>
                                            <input
                                                className={eclCss.custInpt}
                                                type="text"
                                                value={StageThreeCatgoryPercentageVal}
                                                onChange={(e) => setStageThreeCatgoryPercentageVal(e.target.value)}
                                            />
                                        </div>
                                        <div className={eclCss.custInptIncDescContainerRitPer}>
                                            <div className={eclCss.custInptNumUpArrCont}><PercebtageIcn/></div>
                                        </div>
                                    </div>
                                </div>

                                <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}>
                                    <div className={eclCss.infoStage2}>
                                        <div className={eclCss.infoStageBox}>
                                            <div className={eclCss.stage1IconBox}>
                                                <QuestionMartInfo />
                                            &nbsp; &nbsp;
                                            </div>
                                            <div className={eclCss.stage1InfoText}>
                                                Lorem ipsum dolor sit amet consectetur. Vivamus scelerisque orci et pellentesque nunc ut
                                            </div>
                                        </div>
                                    </div>
                                </div> */}

                                {/* <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                                    <span style={{ display: 'flex', alignItems:'center', justifyContent:'center', color:'#2D8861' }} className={eclCss.stage2labelSide}> <AddEclPlusIcon /> &nbsp; Add New Factor</span>
                                </div> */}

                                {/* <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                                    <span className={eclCss.addFactorBtn}> <AddEclPlusIcon /> &nbsp; Add New Factor</span>
                                </div>

                                <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                                    <span className={eclCss.stage2labelSide}>Do you want to add a further factor?</span>
                                    <div className={eclCss.stage2radioContainer}>
                                        <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageThreeCatgoryFrutherFactor('Y')}}>
                                            <div className={eclCss.customRadioOuter}>
                                                {StageThreeCatgoryFrutherFactor == 'Y' ? <div className={eclCss.customRadioInner}></div> : ''}
                                            </div>
                                            YES
                                        </label>

                                        <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageThreeCatgoryFrutherFactor('N')}}>
                                            <div className={eclCss.customRadioOuter}>
                                                {StageThreeCatgoryFrutherFactor == 'N' ? <div className={eclCss.customRadioInner}></div> : ''}
                                            </div>
                                            NO
                                        </label>
                                    </div>
                                </div> */}

                                {/* <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainerFactor}`}>
                                    <div>
                                        <div className={eclCss.stage2radioContainer}>
                                            <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageThreeCatgoryAddOrMultiply('multiply')}}>
                                                <div className={eclCss.customRadioOuter}>
                                                    {StageThreeCatgoryAddOrMultiply == 'multiply' ? <div className={eclCss.customRadioInner}></div> : ''}
                                                </div>
                                                MULTIPLY
                                            </label>

                                            <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageThreeCatgoryAddOrMultiply('add')}}>
                                                <div className={eclCss.customRadioOuter}>
                                                    {StageThreeCatgoryAddOrMultiply == 'add' ? <div className={eclCss.customRadioInner}></div> : ''}
                                                </div>
                                                ADD
                                            </label>
                                        </div>
                                        <div style={{ marginTop : '20px'}}>
                                            <div className={eclCss.pdsInptsContainer}>
                                                <div className={eclCss.stage2labelSide}>
                                                    Multiply by
                                                </div>
                                                <div className={eclCss.custNumInptContainer}>
                                                    <div className={eclCss.custInptBox}>
                                                        <input
                                                            className={eclCss.custInpt}
                                                            type="text"
                                                            value={StageThreeCatgoryMultiplyBy}
                                                            onChange={(e) => setStageThreeCatgoryMultiplyBy(e.target.value)}
                                                        />
                                                    </div>
                                                    <div className={eclCss.custInptIncDescContainerRitPer}>
                                                        <div className={eclCss.custInptNumUpArrCont}><PercebtageIcn/></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={eclCss.calCulationInfoAlrt}>
                                                <div>
                                                    <EclExcaclamater /> 
                                                </div>
                                                &nbsp;
                                                Lorem ipsum dolor sit amet consectetur adipisicing elit. Ad, autem.
                                            </div>
                                        </div>
                                    </div>
                                </div> */}

                            </div>

                        </div>
                    </div>
                    
                </div>
            ))}

            <div className={eclCss.stage2CategorySaveBtnContainer} hidden>
                <button className={eclCss.categorySaveBtn} type="button">Save</button>
            </div>

        </div>        
    )
}    


const StageFour = ({
    ActiveStage,
    setActiveStage,
    // StageFourFactoryAddOrMultiply, 
    setStageFourFactoryAddOrMultiply,

    StageFourfactorsCount,
    setStageFourfactorsCount,
    StageFourfactors,
    setStageFourfactors,
    StageFourCategorization, 
    setStageFourCategorization
}) => {

    const options = [
        { value: 'LGDModel', label: 'LGD Model' },
    ];

    const initialLeftItems = [
        { id: '1', heading: 'Category 1', desc: 'Home Loans › Salaried'},
        { id: '2', heading: 'Category 2', desc: 'Car Loans › Salaried'},
        { id: '3', heading: 'Category 3', desc: 'Education Loans › Salaried'},
    ];

    const initialRightItems = [
        { id: '4', heading: 'Posible Category', desc: 'Home Loans › Salaried', active : 'Y' },
        { id: '5', heading: 'Posible Category', desc: 'Car Loans › Salaried', active : 'Y' },
        { id: '6', heading: 'Posible Category', desc: 'Education Loans › Salaried', active : 'Y' },
    ];

    const [leftItems, setLeftItems] = useState(initialLeftItems);
    const [rightItems, setRightItems] = useState(initialRightItems);

    function onDragEnd(result) {
        const { source, destination } = result;
        if (!destination) return;

        // If dropped in the same list
        if (source.droppableId === destination.droppableId) {
        const items = source.droppableId === 'left' ? Array.from(leftItems) : Array.from(rightItems);
        const [moved] = items.splice(source.index, 1);
        items.splice(destination.index, 0, moved);

        if (source.droppableId === 'left') {
            setLeftItems(items);
        } else {
            setRightItems(items);
        }
        return;
        }

        // Moving between different lists
        const sourceList = source.droppableId === 'left' ? Array.from(leftItems) : Array.from(rightItems);
        const destList = destination.droppableId === 'left' ? Array.from(leftItems) : Array.from(rightItems);

        const [movedItem] = sourceList.splice(source.index, 1);
        destList.splice(destination.index, 0, movedItem);

        if (source.droppableId === 'left') {
        setLeftItems(sourceList);
        setRightItems(destList);
        } else {
        setRightItems(sourceList);
        setLeftItems(destList);
        }
    }

    return(
        <div className={`${eclCss.stage3Container} ${eclCss.custmfadein}`}>
            <DragDropContext onDragEnd={onDragEnd}>

                <div className={eclCss.stageLeftContainer}>

                    <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                        <span className={eclCss.stage2labelSide}>Do you want categorization?</span>
                        <div className={eclCss.stage2radioContainer}>
                            <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setActiveStage('C4'); setStageFourCategorization('Yes')}}>
                                {/* <div className={eclCss.customRadioOuter}>
                                    {ActiveStage === Number.isInteger(ActiveStage) ? <div className={eclCss.customRadioInner}></div> : ''}
                                </div> */}
                                {ActiveStage === Number.isInteger(ActiveStage) ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                YES
                            </label>

                            <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setActiveStage(4); setStageFourCategorization('No')}}>
                                {/* <div className={eclCss.customRadioOuter}>
                                    {ActiveStage !== Number.isInteger(ActiveStage) ? <div className={eclCss.customRadioInner}></div> : ''}
                                </div> */}
                                {ActiveStage !== Number.isInteger(ActiveStage) ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                NO
                            </label>
                        </div>
                    </div>

                    {/* Hide and un hide left container */}

                    {/* <div className={ `${StageFourCategorization === 'N' ? eclCss.UnhideContainerHideCategoryContainer : eclCss.hideContainerUnHideCategoryContainer}` }> */}
                        
                        <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                            <span className={eclCss.stage2labelSide}>Factor description goes here</span>
                        </div>
{/* 
                        <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainerFactor}`}>
                            <div>
                                <div className={eclCss.stage2radioContainer}>
                                    <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageFourFactoryAddOrMultiply('multiply')}}>
                                        <div className={eclCss.customRadioOuter}>
                                            {StageFourFactoryAddOrMultiply == 'multiply' ? <div className={eclCss.customRadioInner}></div> : ''}
                                        </div>
                                        MULTIPLY
                                    </label>

                                    <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageFourFactoryAddOrMultiply('add')}}>
                                        <div className={eclCss.customRadioOuter}>
                                            {StageFourFactoryAddOrMultiply == 'add' ? <div className={eclCss.customRadioInner}></div> : ''}
                                        </div>
                                        ADD
                                    </label>
                                </div>
                                <div className={eclCss.mt15}>
                                    <div className={eclCss.pdsInptsContainer2}>
                                        <div className={eclCss.stage2labelSide}>
                                            Multiply by
                                        </div>
                                        <div className={eclCss.custNumInptContainer}>
                                            <div className={eclCss.custInptBox}>
                                                <input
                                                    className={eclCss.custInpt}
                                                    type="text"
                                                    value={StageFourFactoryAddOrMultiplyFutherFactory}
                                                    // onChange={(e) => setStageFourFactoryAddOrMultiplyFutherFactory(Number(e.target.value))}
                                                />
                                            </div>
                                            <div className={eclCss.custInptIncDescContainerRitPer}>
                                                <div className={eclCss.custInptNumUpArrCont}><PercebtageIcn/></div>
                                            </div>
                                        </div>
                                        <div className={eclCss.calCulationInfoAlrt2}>
                                            <div>
                                                <EclExcaclamater /> 
                                            </div>
                                            &nbsp;
                                            <span className={eclCss.infoText}>Lorem ipsum dolor sit amet consectetur Ad, autem.</span>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div> */}

                        {/* <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                            <span className={eclCss.stage2labelSide}>Factor description goes here</span>
                        </div> */}

{/* 
                        <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainerFactor}`}>
                            <div>
                                <div className={eclCss.stage2radioContainer}>
                                    <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageFourFactoryAddOrMultiply('multiply')}}>
                                        <div className={eclCss.customRadioOuter}>
                                            {StageFourFactoryAddOrMultiply == 'multiply' ? <div className={eclCss.customRadioInner}></div> : ''}
                                        </div>
                                        MULTIPLY
                                    </label>

                                    <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageFourFactoryAddOrMultiply('add')}}>
                                        <div className={eclCss.customRadioOuter}>
                                            {StageFourFactoryAddOrMultiply == 'add' ? <div className={eclCss.customRadioInner}></div> : ''}
                                        </div>
                                        ADD
                                    </label>
                                </div>
                                <div className={eclCss.mt15}>
                                    <div className={eclCss.pdsInptsContainer2}>
                                        <div className={eclCss.stage2labelSide}>
                                            Multiply by
                                        </div>
                                        <div className={eclCss.custNumInptContainer}>
                                            <div className={eclCss.custInptBox}>
                                                <input
                                                    className={eclCss.custInpt}
                                                    type="text"
                                                    value={StageFourFactoryAddOrMultiplyFutherFactory}
                                                    // onChange={(e) => setStageFourFactoryAddOrMultiplyFutherFactory(Number(e.target.value))}
                                                />
                                            </div>
                                            <div className={eclCss.custInptIncDescContainerRitPer}>
                                                <div className={eclCss.custInptNumUpArrCont}><PercebtageIcn/></div>
                                            </div>
                                        </div>
                                        <div className={eclCss.calCulationInfoAlrt2}>
                                            <div>
                                                <EclExcaclamater /> 
                                            </div>
                                            &nbsp;
                                            <span className={eclCss.infoText}>Lorem ipsum dolor sit amet consectetur Ad, autem.</span>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div> */}

                        {[...Array(StageFourfactorsCount)].map((_, i) => (
                            <div key={i} className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainerFactor} ${eclCss.mt15}`}>
                                <div>
                                    <div className={eclCss.stage2radioContainer}>
                                        <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} 
                                            onClick={() => {
                                                setStageFourfactors(prev => {
                                                const newFactors = [...prev];
                                                if (newFactors[i]) {
                                                    newFactors[i] = {
                                                    ...newFactors[i],
                                                    method: 'multiply'
                                                    };
                                                }
                                                return newFactors;
                                                });
                                            }}
                                        >
                                            {/* <div className={eclCss.customRadioOuter}>
                                                {StageFourFactoryAddOrMultiply == 'multiply' ? <div className={eclCss.customRadioInner}></div> : ''}
                                            </div> */}
                                            {!StageFourfactors[i] ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  :  StageFourfactors[i].method === 'multiply' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                            MULTIPLY
                                        </label>

                                        <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} 
                                            onClick={() => {
                                                setStageFourfactors(prev => {
                                                const newFactors = [...prev];
                                                if (newFactors[i]) {
                                                    newFactors[i] = {
                                                    ...newFactors[i],
                                                    method: 'add'
                                                    };
                                                }
                                                return newFactors;
                                                });
                                            }}
                                        >
                                            {/* <div className={eclCss.customRadioOuter}>
                                                {StageFourFactoryAddOrMultiply == 'add' ? <div className={eclCss.customRadioInner}></div> : ''}
                                            </div> */}
                                            {!StageFourfactors[i] ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  :  StageFourfactors[i].method === 'add' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                            ADD
                                        </label>
                                    </div>
                                    <div className={eclCss.mt10}>
                                        <div className={eclCss.pdsInptsContainer2}>
                                            <div className={eclCss.stage2labelSide} style={{ width: 'max-content' }}>
                                                {StageFourfactors[i].method === 'multiply' ? 'Multiply by' : 'Add by'}
                                            </div>
                                            <div className={eclCss.custNumInptContainer}>
                                                <div className={eclCss.custInptBox}>
                                                    <input
                                                        className={eclCss.custInpt}
                                                        type="text"
                                                        value={StageFourfactors[i]?.percentage || ''}
                                                        onChange={(e) => {
                                                            setStageFourfactors(prev => {
                                                            const newFactors = [...prev];
                                                            if (newFactors[i]) {
                                                                newFactors[i] = {
                                                                ...newFactors[i],
                                                                percentage: e.target.value
                                                                };
                                                            }
                                                            return newFactors;
                                                            });
                                                        }}
                                                    />
                                                </div>
                                                <div className={eclCss.custInptIncDescContainerRitPer}>
                                                    <div className={eclCss.custInptNumUpArrCont}><PercebtageIcn/></div>
                                                </div>
                                            </div>
                                            &nbsp;
                                            <div className={eclCss.calCulationInfoAlrt2}>
                                                <div>
                                                    <EclExcaclamater /> 
                                                </div>
                                                {/* &nbsp; */}
                                                &nbsp;
                                                <span className={eclCss.infoText}>Lorem ipsum dolor sit amet consectetur Ad, autem.</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <input className={eclCss.custInptStageFour}
                                            placeholder='Enter factor description...'
                                            type="text" name="" id="" 
                                            value={StageFourfactors[i]?.description || ''}
                                            onChange={(e) => {
                                                setStageFourfactors(prev => {
                                                const newFactors = [...prev];
                                                if (newFactors[i]) {
                                                    newFactors[i] = {
                                                    ...newFactors[i],
                                                    description: e.target.value
                                                    };
                                                }
                                                return newFactors;
                                                });
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        ))}

                        

                        {/* <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage4rightCatgeContainer}`}>
                            <button type="button" className={eclCss.addFactorEclCreate}>Add Factor</button>
                        </div> */}

                        <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`} 
                            onClick={() => {
                                setStageFourfactorsCount(prev => prev + 1);
                                setStageFourfactors(prev => [
                                    ...prev,
                                    {
                                    method: "multiply",
                                    percentage: '',
                                    description: ''
                                    }
                                ]);
                            }}

                        >
                            <span className={eclCss.addFactorBtn}> <AddEclPlusIcon /> &nbsp;  Add New Factor</span>
                        </div>

                        {/* <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainerFactor}`}>
                            <div>
                                <div className={eclCss.stage2radioContainer}>
                                    <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageFourFactoryAddOrMultiply('multiply')}}>
                                        <div className={eclCss.customRadioOuter}>
                                            {StageFourFactoryAddOrMultiply == 'multiply' ? <div className={eclCss.customRadioInner}></div> : ''}
                                        </div>
                                        MULTIPLY
                                    </label>

                                    <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageFourFactoryAddOrMultiply('add')}}>
                                        <div className={eclCss.customRadioOuter}>
                                            {StageFourFactoryAddOrMultiply == 'add' ? <div className={eclCss.customRadioInner}></div> : ''}
                                        </div>
                                        ADD
                                    </label>
                                </div>
                                <div style={{ marginTop : '20px'}}>
                                    <div className={eclCss.pdsInptsContainer}>
                                        <div className={eclCss.stage2labelSide}>
                                            Multiply by
                                        </div>
                                        <div className={eclCss.custNumInptContainer}>
                                            <div className={eclCss.custInptBox}>
                                                <input
                                                    className={eclCss.custInpt}
                                                    type="text"
                                                    value={StageFourFactoryAddOrMultiplyPercentage}
                                                    onChange={(e) => setStageFourFactoryAddOrMultiplyPercentage(e.target.value)}
                                                />
                                            </div>
                                            <div className={eclCss.custInptIncDescContainerRitPer}>
                                                <div className={eclCss.custInptNumUpArrCont}><PercebtageIcn/></div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={eclCss.calCulationInfoAlrt}>
                                        <div>
                                            <EclExcaclamater /> 
                                        </div>
                                        &nbsp;
                                        Lorem ipsum dolor sit amet consectetur adipisicing elit. Ad, autem.
                                    </div>
                                </div>
                            </div>
                        </div> */}

                        {/* <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                            <span className={eclCss.stage2labelSide}>Do you want to add a further factor?</span>
                            <div className={eclCss.stage2radioContainer}>
                                <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageFourAddFactor('Y')}}>
                                    <div className={eclCss.customRadioOuter}>
                                        {StageFourAddFactor == 'Y' ? <div className={eclCss.customRadioInner}></div> : ''}
                                    </div>
                                    YES
                                </label>

                                <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageFourAddFactor('N')}}>
                                    <div className={eclCss.customRadioOuter}>
                                        {StageFourAddFactor == 'N' ? <div className={eclCss.customRadioInner}></div> : ''}
                                    </div>
                                    NO
                                </label>
                            </div>
                        </div> */}

                        
                    
                    {/* </div> */}

                    {/* Left Category Container */}
                    {/* <div className={ `${StageFourCategorization == 'Y' ? eclCss.UnhideContainerHideCategoryContainer : eclCss.hideContainerUnHideCategoryContainer}` }>

                        <div className={`${eclCss.defineCatgegorysContainer}`}>
                            <div className={eclCss.stagelabel}>Define Categories</div>
                            <Droppable droppableId="left">
                                {(provided) => (
                                    <div className={`${eclCss.defineCardsContainer}`} ref={provided.innerRef} {...provided.droppableProps}>

                                        {leftItems.map((item, index) => (
                                            <Draggable key={item.id} draggableId={item.id} index={index}>
                                                {(provided) => (
                                                    <div className={eclCss.defineCategorycardContainer}  ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} >
                                                        <div className={eclCss.defineCategoryCardHead}>{item.heading}</div>
                                                        <div className={eclCss.defineCategoryCardDesc}>
                                                            <div>
                                                                {item.desc}
                                                            </div> 
                                                        </div>
                                                    </div>
                                                )}
                                            </Draggable>
                                        ))}
                                
                                </div>
                                )}
                            </Droppable>

                            <div className={eclCss.defineCategoryBTNContainer}>
                                <button type="button" onClick={()=>{setActiveStage('C4')}} className={eclCss.defineCategoryPDBtn}>Define PD</button>
                            </div>
                        </div>

                    </div> */}

                </div>
                
                {/* seprator */}
                <div className={eclCss.containerSeprator}> </div>
                
                {/* right container */}
                <div className={eclCss.stage3RightContainer}>

                    {/* <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`} 
                        onClick={() => {
                                setStageFourfactorsCount(prev => prev + 1);
                                setStageFourfactors(prev => [
                                    ...prev,
                                    {
                                    method: "multiply",
                                    percentage: '',
                                    description: ''
                                    }
                                ])}}
                    >
                        <button type="button" className={eclCss.stageFourAddNewFact}> <GrayAddIcon /> &nbsp; Add New Factor</button>
                    </div> */}

                    <div style={{ width: '95%', cursor: 'pointer' }} 
                        onClick={() => {
                                setStageFourfactorsCount(prev => prev + 1);
                                setStageFourfactors(prev => [
                                    ...prev,
                                    {
                                    method: "multiply",
                                    percentage: '',
                                    description: ''
                                    }
                                ])}}
                    >
                        <AddFactorBtn  style={{ width: '100%' }}/>
                    </div>

                    {/* <div className={ `${StageFourCategorization == 'N' ? eclCss.UnhideContainerHideCategoryContainer : eclCss.hideContainerUnHideCategoryContainer}`}>
                        
                        <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage4RightCatgeContainer}`}>

                            <div className={eclCss.stage4Rightlabel}>Enter factor description</div>

                            <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage4rightCatgeContainer}`}>
                                <textarea
                                    value={StageFourDescription}
                                    onChange={(e) => setStageFourDescription(e.target.value)}
                                    placeholder="Enter description..."
                                    rows={5}
                                    cols={40}
                                    className={eclCss.textareaCustomECl}
                                />
                            </div>

                            <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                                <div className={eclCss.stage2radioContainer}>
                                    <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageFourFactoryAddOrMultiply('multiply')}}>
                                        <div className={eclCss.customRadioOuter}>
                                            {StageFourFactoryAddOrMultiply == 'multiply' ? <div className={eclCss.customRadioInner}></div> : ''}
                                        </div>
                                        YES
                                    </label>

                                    <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageFourFactoryAddOrMultiply('add')}}>
                                        <div className={eclCss.customRadioOuter}>
                                            {StageFourFactoryAddOrMultiply == 'add' ? <div className={eclCss.customRadioInner}></div> : ''}
                                        </div>
                                        NO
                                    </label>
                                </div>
                            </div>
                            
                            <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}>
                                <div className={eclCss.pdsInptsContainer}>
                                    <div className={eclCss.stage2labelSide}>
                                        Enter Percentage
                                    </div>
                                    <div className={eclCss.custNumInptContainer}>
                                        <div className={eclCss.custInptBox}>
                                            <input
                                                className={eclCss.custInpt}
                                                type="text"
                                                value={StageFourFactoryPercentage}
                                                onChange={(e) => setStageFourFactoryPercentage(e.target.value)}
                                            />
                                        </div>
                                        <div className={eclCss.custInptIncDescContainerRitPer}>
                                            <div className={eclCss.custInptNumUpArrCont}><PercebtageIcn/></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage4rightCatgeContainer}`}>
                                <button type="button" className={eclCss.addFactorEclCreate}>Add Factor</button>
                            </div>

                        </div>

                        <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                            <span style={{ display: 'flex', alignItems:'center', justifyContent:'center', color:'#2D8861' }} className={eclCss.stage2labelSide}> <AddEclPlusIcon /> &nbsp; Add New Factor</span>
                        </div>

                        <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                            <span className={eclCss.addFactorBtn}> <AddEclPlusIcon /> &nbsp; Add New Factor</span>
                        </div>


                    </div> */}

                    {/* Right Category Container */}
                    {/* <div className={ `${StageFourCategorization == 'Y' ? eclCss.UnhideContainerHideCategoryContainer : eclCss.hideContainerUnHideCategoryContainer}` }>
                        <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                            <span className={eclCss.stage2CategoryDesc}>All possible permutations from definitions have been listed below,
                                Select and click add to continue 
                            </span>
                            <div className={eclCss.stage2radioContainer}>
                            
                            </div>
                            <button type="button" className={eclCss.catgeoryAddSeclectedBtn}>
                                    Add Selected
                            </button>
                        </div>
                        
                        <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                            <Droppable droppableId="right" >
                                {(provided) => (
                                    <div className={`${eclCss.defineCardsRightContainer} ${eclCss.Stage2RightDragCustStyl}}`} ref={provided.innerRef} {...provided.droppableProps}> 
                                        
                                        {rightItems.map((item, index) => (
                                            <Draggable key={item.id} draggableId={item.id} index={index}>
                                            {(provided) => (
                                                <div className={eclCss.defineCategorycardContainerRight} ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} >
                                                    <div className={eclCss.stage2rightCategoryCardInnerContainer} >
                                                        <div>
                                                            <input type="checkbox" name="" id="" 
                                                                defaultChecked={item.active === 'Y'}
                                                            />
                                                        </div>
                                                        <div>
                                                            <div className={eclCss.defineCategoryCardHead}>{item.heading}</div>
                                                            <div className={eclCss.defineCategoryCardDesc}>
                                                                <div>
                                                                    {item.desc}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )}
                                            </Draggable>
                                        ))}

                                    </div>
                                )}
                            </Droppable>

                        </div>
                        
                        <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}>
                            <div className={eclCss.infoStage2}>
                                <div className={eclCss.infoStageBoxNoBg}>
                                    <div className={eclCss.stage1IconBox}>
                                        <QuestionMartInfo />
                                    &nbsp; &nbsp;
                                    </div>
                                    <div className={eclCss.stage1InfoText}>
                                        Lorem ipsum dolor sit amet consectetur. Vivamus scelerisque
                                    </div>
                                    <div className={eclCss.categoryRightBtnNoBgclr}>
                                        Define Category
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div> */}

                </div>
            </DragDropContext>
        </div>
    )

}




const StageFourCategoryHeader = ({
    ActiveStage,
    setActiveStage,
    setStageFourCategorization
    }) => {

    return(
        <div>
            <div className={`${eclCss.stageTwoCatgorSelecContainer} ${eclCss.custmfadein}`}>

                {/* <div className={eclCss.width40Per}> */}
                    <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer_}`}>
                        <span className={eclCss.stage2labelSide}>Do you want categorization?</span>
                        <div className={eclCss.stage2radioContainer}>
                            <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setActiveStage('C4'); setStageFourCategorization('Yes')}}>
                                {/* <div className={eclCss.customRadioOuter}>
                                    {ActiveStage !== Number.isInteger(ActiveStage) ? <div className={eclCss.customRadioInner}></div> : ''}
                                </div> */}
                                {ActiveStage !== Number.isInteger(ActiveStage) ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                YES
                            </label>

                            <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setActiveStage(4); setStageFourCategorization('No')}}>
                                {/* <div className={eclCss.customRadioOuter}>
                                    {ActiveStage === Number.isInteger(ActiveStage) ? <div className={eclCss.customRadioInner}></div> : ''}
                                </div> */}
                                {ActiveStage === Number.isInteger(ActiveStage) ? <ActiveRadioBtn className={eclCss.custuRadioBtn} />  : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                NO
                            </label>
                        </div>
                    </div>
                {/* </div> */}

            </div>
        </div>
    )
}




const StageFourCategory = ({
    // StageFourFactoryAddOrMultiply,
    setStageFourFactoryAddOrMultiply,
    categorysData,
    StageFourActiveCategory,
    setStageFourActiveCategory,
    categorysFLFObj,
    setcategorysFLFObj,
}) => {
    console.log('categorysFLFObj cat for :: ', categorysFLFObj);
    return(

        <div className={`${eclCss.custmfadein} ${eclCss.categoryContainerMain}`}>

            <div className={eclCss.catgegoryContainer}>
                {categorysData.map((item, index) => (
                    <div key={index} className={ StageFourActiveCategory === index ?  index === 0 ? eclCss.activeCategoryTab : eclCss.activeCategoryTabNoRadius : eclCss.inActiveCategoryTab} onClick={() => {setStageFourActiveCategory(index)}}>
                        <div key={index} style={{ height:'100%', padding: '5px', display:'flex', alignItems:'center' }}>
                            <div className={eclCss.WMaxContant}> {item.category} - {item.subcategory} </div>
                            {/* {item.categoryID} */}
                            {/* <small className={eclCss.smallTxt}>{item.subcategory}</small> */}
                            {/* {item.subcategoryID} */}
                        </div>
                    </div>
                ))}
            </div>
            
            {categorysData.map((item, index) => (
                <div className={StageFourActiveCategory === index ? eclCss.containerShow : eclCss.containerNone}>
                    <div key={index} className={eclCss.stage2CategoryContainer}>
                        <div key={index} className={eclCss.stageLeftContainer}>
                            {/* <div className={eclCss.factorsMainContainer}>
                                
                                <div className={eclCss.addFactorPanel}>
                                    
                                    <div>
                                        <EclExcaclamater style={{ height: '35px', width: '35px', marginBottom : '10px'}} />
                                    </div>

                                    <div>
                                        List of added factors will be displayed here
                                    </div>
                                    <div>
                                        Add a factor using the right panel
                                    </div>
                                </div>
                            
                            </div> */}

                            <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                                <span className={eclCss.stage2labelSide}>Factor description goes here</span>
                            </div>
                            
                            {[...Array(categorysFLFObj?.[item.subcategoryID]?.values?.factorsCount)].map((_, i) => 
                                // console.log('sub if four cat :: ',item.subcategoryID);
                            ( 
                                <div key={i} className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainerFactor} ${eclCss.mt10}`}>
                                    <div key={i}>
                                        <div key={i} className={eclCss.stage2radioContainer}>
                                            <label key={i} style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} 
                                                onClick={() => {
                                                    setcategorysFLFObj(prev => {
                                                        const subID = item.subcategoryID;
                                                        const prevData = prev?.[subID]?.values || {};
                                                        const oldFactors = [...(prevData.factors || [])];

                                                        // Update method at index i
                                                        oldFactors[i] = {
                                                            ...oldFactors[i],
                                                            method: 'multiply'
                                                        };

                                                        return {
                                                            ...prev,
                                                            [subID]: {
                                                                ...prev[subID],
                                                                values: {
                                                                    ...prevData,
                                                                    factors: oldFactors
                                                                }
                                                            }
                                                        };
                                                    });
                                                }}

                                            >   
                                                {categorysFLFObj[item.subcategoryID]?.values?.factors[i].method === 'multiply' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} /> : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                                MULTIPLY
                                            </label>

                                            <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} 
                                                onClick={() => {
                                                    setcategorysFLFObj(prev => {
                                                        const subID = item.subcategoryID;
                                                        const prevData = prev?.[subID]?.values || {};
                                                        const oldFactors = [...(prevData.factors || [])];

                                                        // Update method at index i
                                                        oldFactors[i] = {
                                                            ...oldFactors[i],
                                                            method: 'add'
                                                        };

                                                        return {
                                                            ...prev,
                                                            [subID]: {
                                                                ...prev[subID],
                                                                values: {
                                                                    ...prevData,
                                                                    factors: oldFactors
                                                                }
                                                            }
                                                        };
                                                    });
                                                }}

                                                >
                                                {categorysFLFObj[item.subcategoryID]?.values?.factors[i].method === 'add' ? <ActiveRadioBtn className={eclCss.custuRadioBtn} /> : <InactiveRadioBtn className={eclCss.custuRadioBtn} />}
                                                ADD
                                            </label>
                                        </div>
                                        <div className={eclCss.mt10}>
                                            <div className={eclCss.pdsInptsContainer2}>
                                                <div className={eclCss.stage2labelSide} style={{ width: 'max-content' }}>
                                                    {categorysFLFObj[item.subcategoryID].values?.factors[i].method === 'add' ? 'Add' : 'Multiply by' }
                                                </div>
                                                <div className={eclCss.custNumInptContainer}>
                                                    <div className={eclCss.custInptBox}>
                                                        <input
                                                            className={eclCss.custInpt}
                                                            type="text"
                                                            value={categorysFLFObj[item.subcategoryID].values?.factors[i].percentage}
                                                            onChange={(e) => {
                                                                const newVal = e.target.value;

                                                                setcategorysFLFObj(prev => {
                                                                    const subID = item.subcategoryID;
                                                                    const prevData = prev?.[subID]?.values || {};
                                                                    const oldFactors = [...(prevData.factors || [])];

                                                                    oldFactors[i] = {
                                                                        ...oldFactors[i],
                                                                        percentage: newVal
                                                                    };

                                                                    return {
                                                                        ...prev,
                                                                        [subID]: {
                                                                            ...prev[subID],
                                                                            values: {
                                                                                ...prevData,
                                                                                factors: oldFactors
                                                                            }
                                                                        }
                                                                    };
                                                                });
                                                            }}

                                                        />
                                                    </div>
                                                    <div className={eclCss.custInptIncDescContainerRitPer}>
                                                        <div className={eclCss.custInptNumUpArrCont}><PercebtageIcn/></div>
                                                    </div>
                                                </div>
                                                <div className={eclCss.calCulationInfoAlrt2}>
                                                    <div>
                                                        <EclExcaclamater /> 
                                                    </div>
                                                    &nbsp;
                                                    &nbsp;
                                                    <span className={eclCss.infoText}>Lorem ipsum dolor sit amet consectetur Ad, autem.</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            <input className={eclCss.custInptStageFour}
                                                placeholder='Enter factor description...'
                                                type="text" name="" id="" 
                                                value={categorysFLFObj[item.subcategoryID].values?.factors[i].description}
                                                onChange={(e) => {
                                                    setcategorysFLFObj(prev => {
                                                        const subID = item.subcategoryID;
                                                        const prevData = prev?.[subID]?.values || {};
                                                        const oldFactors = [...(prevData.factors || [])];

                                                        oldFactors[i] = {
                                                        ...oldFactors[i],
                                                        description: e.target.value
                                                        };

                                                        return {
                                                        ...prev,
                                                        [subID]: {
                                                            ...prev[subID],
                                                            values: {
                                                            ...prevData,
                                                            factors: oldFactors
                                                            }
                                                        }
                                                        };
                                                    });
                                                    }}

                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}

                            <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainerFactorDir}`}>
                                    <button type="button" className={eclCss.stageThreeCatgeAddNewFactBtnContainer} 
                                        onClick={() => {
                                            setcategorysFLFObj(prev => {
                                                const subID = item.subcategoryID;
                                                const prevData = prev?.[subID]?.values || {};
                                                const newCount = (prevData.factorsCount || 0) + 1;
                                                const oldFactors = prevData.factors || [];

                                                const newFactor = {
                                                    method: 'multiply',
                                                    percentage: '',
                                                    description: ''
                                                };

                                                return {
                                                    ...prev,
                                                    [subID]: {
                                                        ...prev[subID],
                                                        values: {
                                                            ...prevData,
                                                            factorsCount: newCount,
                                                            factors: [...oldFactors, newFactor]
                                                        }
                                                    }
                                                };
                                            });
                                        }}

                                    >
                                        <AddEclPlusIcon/> &nbsp; Add New Factor
                                </button>
                            </div>

                        </div>

                        {/* seprator */}
                        <div className={eclCss.containerSeprator}></div>

                        <div className={eclCss.stage2RightContainer}>

                            <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}
                                onClick={() => {
                                            setcategorysFLFObj(prev => {
                                                const subID = item.subcategoryID;
                                                const prevData = prev?.[subID]?.values || {};
                                                const newCount = (prevData.factorsCount || 0) + 1;
                                                const oldFactors = prevData.factors || [];

                                                const newFactor = {
                                                    method: 'multiply',
                                                    percentage: '',
                                                    description: ''
                                                };

                                                return {
                                                    ...prev,
                                                    [subID]: {
                                                        ...prev[subID],
                                                        values: {
                                                            ...prevData,
                                                            factorsCount: newCount,
                                                            factors: [...oldFactors, newFactor]
                                                        }
                                                    }
                                                };
                                            });
                                        }}
                            >
                                <button type="button" className={eclCss.stageFourAddNewFact}> <GrayAddIcon /> &nbsp; Add New Factor</button>
                            </div>

                            {/* <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage4RightCatgeContainer}`}>

                                <div className={eclCss.stage4Rightlabel}>Enter factor description</div>

                                <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage4rightCatgeContainer}`}>
                                    <textarea
                                        value={StageFourCategoryFactorDescription}
                                        onChange={(e) => setStageFourCategoryFactorDescription(e.target.value)}
                                        placeholder="Enter description..."
                                        rows={5}
                                        cols={40}
                                        className={eclCss.textareaCustomECl}
                                    />
                                </div>

                                <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                                    <div className={eclCss.stage2radioContainer}>
                                        <label style={{ marginRight: '20px', marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageFourCategoryFactorMuliOrAdd('multiply')}}>
                                            <div className={eclCss.customRadioOuter}>
                                                {StageFourCategoryFactorMuliOrAdd == 'multiply' ? <div className={eclCss.customRadioInner}></div> : ''}
                                            </div>
                                            YES
                                        </label>

                                        <label style={{ marginBottom : '0px' }} className={eclCss.stage2LeftCatgeorLabel} onClick={() => {setStageFourCategoryFactorMuliOrAdd('add')}}>
                                            <div className={eclCss.customRadioOuter}>
                                                {StageFourCategoryFactorMuliOrAdd == 'add' ? <div className={eclCss.customRadioInner}></div> : ''}
                                            </div>
                                            NO
                                        </label>
                                    </div>
                                </div>
                                    
                                <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftLabelAndInpt}`}>
                                    <div className={eclCss.pdsInptsContainer}>
                                        <div className={eclCss.stage2labelSide}>
                                            Enter Percentage
                                        </div>
                                        <div className={eclCss.custNumInptContainer}>
                                            <div className={eclCss.custInptBox}>
                                                <input
                                                    className={eclCss.custInpt}
                                                    type="text"
                                                    value={StageFourCategoryFactorPercentage}
                                                    onChange={(e) => setStageFourCategoryFactorPercentage(e.target.value)}
                                                />
                                            </div>
                                            <div className={eclCss.custInptIncDescContainerRitPer}>
                                                <div className={eclCss.custInptNumUpArrCont}><PercebtageIcn/></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage4rightCatgeContainer}`}>
                                    <button type="button" className={eclCss.addFactorEclCreate}>Add Factor</button>
                                </div>

                            </div>

                            <div className={`${eclCss.stageLeftSubContainer} ${eclCss.stage2LeftCatgeContainer}`}>
                                <span className={eclCss.addFactorBtn}> <AddEclPlusIcon /> &nbsp; Add New Factor</span>
                            </div> */}

                        </div>
                    </div>
                </div>
            ))}
            
            <div className={eclCss.stage2CategorySaveBtnContainer} hidden>
                <button className={eclCss.categorySaveBtn} type="button">Save</button>
            </div>

        </div>
    )

}


const StageFive = ({
    finallObjectData, 
    setfinallObjectData,
    stageFourActiveTab, 
    setstageFourActiveTab,
    stageTwoActiveTab, 
    setstageTwoActiveTab,
    categorysData,
    stageThreeActiveTab, 
    setstageThreeActiveTab
}) => {
        console.log('finallObjectData :: ', finallObjectData);
    return(
        <div className={`${eclCss.stage3Container} ${eclCss.custmfadein}`}>

                <div className={eclCss.stageLeftContainer}>

                    {/* Scenario Details */}
                    <div className={eclCss.StageOnecontainer}>
                        <div className={eclCss.reviewContainerHeader}>
                            Scenario Details
                        </div>

                         <div className={eclCss.reviewQuestionContainer}>
                            <div className={eclCss.reviewQuestionLabel}>
                                Scenario Name
                            </div>
                            <div className={eclCss.reviewQuestionAnswer}>
                                {finallObjectData?.name}
                            </div>
                        </div>

                        <div className={eclCss.reviewQuestionContainer}>
                            <div className={eclCss.reviewQuestionLabel}>
                                IndAS Provisioning
                            </div>
                            <div className={eclCss.reviewQuestionAnswer}>
                                {finallObjectData?.indASProvisioning === 'generalApproach' ? 'General Approach' : 'Simplified Approach'}
                            </div>
                        </div>
                    </div>

                    {/* PD */}
                    <div className={eclCss.StageOnecontainer}>
                        
                        <div className={eclCss.reviewContainerHeader}>
                            PD Calculation
                        </div>

                        <div className={eclCss.reviewQuestionContainer}>
                            <div className={eclCss.reviewQuestionLabel}>
                                PD Model
                            </div>
                            <div className={eclCss.reviewQuestionAnswer}>
                                {finallObjectData?.pd?.model}
                            </div>
                        </div>

                        <div className={eclCss.reviewQuestionContainer}>
                            <div className={eclCss.reviewQuestionLabel}>
                                Do you want categorization?
                            </div>
                            <div className={eclCss.reviewQuestionAnswer}>
                                {finallObjectData?.pd?.categorize}
                            </div>
                        </div>

                        {
                            finallObjectData?.pd?.categorize === 'Yes'
                            ?
                                <div>

                                    <div className={eclCss.reviewCategoryContainer}>
                                    
                                        <div className={eclCss.catgegoryContainer}>
                                            {finallObjectData?.pd?.categorized.map((item, index) => {
                                                const match = categorysData.find(
                                                (c) => c.categoryID === item.categoryID && c.subcategoryID === item.subcategoryID
                                                );

                                                return (
                                                <div
                                                    key={index}
                                                    className={
                                                    stageTwoActiveTab === index
                                                        ? index === 0
                                                        ? eclCss.activeCategoryTab
                                                        : eclCss.activeCategoryTabNoRadius
                                                        : eclCss.inActiveCategoryTab
                                                    }
                                                    onClick={() => setstageTwoActiveTab(index)}
                                                >
                                                    <div>
                                                    <div className={eclCss.WMaxContant}>{match?.category || 'Category'}</div>
                                                    <small className={eclCss.smallTxt}>{match?.subcategory || 'Subcategory'}</small>
                                                    </div>
                                                </div>
                                                );
                                            })}
                                        </div>

                                        {finallObjectData?.pd?.categorized.map((item, index) => (
                                            <div key={index} className={stageTwoActiveTab === index ? eclCss.containerShow : eclCss.containerNone}>
                                                <div className={eclCss.reviewQuestionContainer}>
                                                    <div className={eclCss.reviewQuestionLabel}>PD rate calculation</div>
                                                    <div className={eclCss.reviewQuestionAnswer}>{item.values.rateCalculation}</div>
                                                </div>

                                                <div className={eclCss.reviewQuestionContainer}>
                                                    <div className={eclCss.reviewQuestionLabel}>Frequency for PD Calculation</div>
                                                    <div className={eclCss.reviewQuestionAnswer}>{item.values.frequency}</div>
                                                </div>

                                                <div className={eclCss.reviewQuestionContainer}>
                                                    <div className={eclCss.reviewQuestionLabel}>How many periods to consider?</div>
                                                    <div className={eclCss.reviewQuestionAnswer}>{item.values.periods}</div>
                                                </div>

                                                <div className={eclCss.reviewQuestionContainer}>
                                                    <div className={eclCss.reviewQuestionLabel}>Base value for PD Calculation post period-1</div>
                                                    <div className={eclCss.reviewQuestionAnswer}>{item.values.baseValuePostPeriodOne}</div>
                                                </div>

                                                <div className={eclCss.reviewQuestionContainer}>
                                                    <div className={eclCss.reviewQuestionLabel}>Include interest on defaulted payments?</div>
                                                    <div className={eclCss.reviewQuestionAnswer}>{item.values.includeInterestDefaultPayments}</div>
                                                </div>

                                                <div className={eclCss.reviewQuestionContainer}>
                                                    <div className={eclCss.reviewQuestionLabel}>Do you want to calculate 12 months PD?</div>
                                                    <div className={eclCss.reviewQuestionAnswer}>{item.values.calculateTwelveMonthsPD}</div>
                                                </div>

                                                <div className={eclCss.reviewQuestionContainer}>
                                                    <div className={eclCss.reviewQuestionLabel}>What should consider as period?</div>
                                                    <div className={eclCss.reviewQuestionAnswer}>{item.values.considerAsPeriodOne}</div>
                                                </div>

                                                <div className={eclCss.reviewQuestionContainer}>
                                                    <div className={eclCss.reviewQuestionLabel}>Extrapolation method</div>
                                                    <div className={eclCss.reviewQuestionAnswer}>{item.values.extrapolationMethod}</div>
                                                </div>

                                                <div className={eclCss.reviewQuestionContainer}>
                                                    <div className={eclCss.reviewQuestionLabel}>Weighted average percentage</div>
                                                    <div className={eclCss.reviewQuestionAnswer}>{item.values.extrapolationPercentage}</div>
                                                </div>

                                                <div className={eclCss.reviewQuestionContainer}>
                                                    <div className={eclCss.reviewQuestionLabel}>Specific weights</div>
                                                </div>

                                                <div className={eclCss.reviewQuestionContainer}>
                                                    <div className={eclCss.weightsContainerDisplay}>
                                                        {item.values.weights?.length > 0 ? (
                                                            item.values.weights.map((w, i) => (
                                                                <div key={i} className={eclCss.wrapContainer}>
                                                                    <div className={eclCss.weightLabel}>Period - {w.period}</div>
                                                                    <div className={eclCss.weightVal}>{w.percentage}</div>
                                                                </div>
                                                            ))
                                                        ) : (
                                                            <div>No weights Data Entered</div>
                                                        )}
                                                    </div>
                                                </div>

                                                <div className={eclCss.reviewQuestionContainer}>
                                                    <div className={eclCss.reviewQuestionLabel}>
                                                        {item.values.addOrMultiplyFactor === 'add' ? "Add" : "Multiply"} PD by
                                                    </div>
                                                    <div className={eclCss.reviewQuestionAnswer}>
                                                        {item.values.addOrMultiplyPercentage}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            :
                                <div>

                                    <div className={eclCss.reviewQuestionContainer}>
                                        <div className={eclCss.reviewQuestionLabel}>
                                            PD rate calculation
                                        </div>
                                        <div className={eclCss.reviewQuestionAnswer}>
                                            {finallObjectData?.pd?.global?.rateCalculation}
                                        </div>
                                    </div>

                                    <div className={eclCss.reviewQuestionContainer}>
                                        <div className={eclCss.reviewQuestionLabel}>
                                            Frequency for PD Calculation
                                        </div>
                                        <div className={eclCss.reviewQuestionAnswer}>
                                            {finallObjectData?.pd?.global?.frequency}
                                        </div>
                                    </div>

                                    <div className={eclCss.reviewQuestionContainer}>
                                        <div className={eclCss.reviewQuestionLabel}>
                                            How many periods to consider?
                                        </div>
                                        <div className={eclCss.reviewQuestionAnswer}>
                                            {finallObjectData?.pd?.global?.periods}
                                        </div>
                                    </div>

                                    <div className={eclCss.reviewQuestionContainer}>
                                        <div className={eclCss.reviewQuestionLabel}>
                                            Base value for PD Calculation post period-1
                                        </div>
                                        <div className={eclCss.reviewQuestionAnswer}>
                                            {finallObjectData?.pd?.global?.baseValuePostPeriodOne}
                                        </div>
                                    </div>

                                     <div className={eclCss.reviewQuestionContainer}>
                                        <div className={eclCss.reviewQuestionLabel}>
                                            Include interest on defaulted payments?
                                        </div>
                                        <div className={eclCss.reviewQuestionAnswer}>
                                            {finallObjectData?.pd?.global?.includeInterestDefaultPayments}
                                        </div>
                                    </div>

                                    <div className={eclCss.reviewQuestionContainer}>
                                        <div className={eclCss.reviewQuestionLabel}>
                                            Do you want to calculate 12 months PD?
                                        </div>
                                        <div className={eclCss.reviewQuestionAnswer}>
                                            {finallObjectData?.pd?.global?.calculateTwelveMonthsPD}
                                        </div>
                                    </div>

                                    <div className={eclCss.reviewQuestionContainer}>
                                        <div className={eclCss.reviewQuestionLabel}>
                                            What should consider as period?
                                        </div>
                                        <div className={eclCss.reviewQuestionAnswer}>
                                            {finallObjectData?.pd?.global?.considerAsPeriodOne}
                                        </div>
                                    </div>

                                    <div className={eclCss.reviewQuestionContainer}>
                                        <div className={eclCss.reviewQuestionLabel}>
                                            Extrapolation based on past history for missing periods ?
                                        </div>
                                        <div className={eclCss.reviewQuestionAnswer}>
                                            {finallObjectData?.pd?.global?.extrapolationMethod}
                                        </div>
                                    </div>

                                    <div className={eclCss.reviewQuestionContainer}>
                                        <div className={eclCss.reviewQuestionLabel}>
                                            Weighted average percentage 
                                        </div>
                                        <div className={eclCss.reviewQuestionAnswer}>
                                            {finallObjectData?.pd?.global?.extrapolationPercentage}
                                        </div>
                                    </div>

                                    <div className={eclCss.reviewQuestionContainer}> 
                                        <div className={eclCss.reviewQuestionLabel}>
                                            Specific weights assigned to periods while calculating PD
                                        </div>
                                    </div>

                                    <div className={eclCss.reviewQuestionContainer}>
                                        {/* <div className={eclCss.reviewQuestionAnswer}> */}
                                            <div className={eclCss.weightsContainerDisplay}>
                                                {finallObjectData?.pd?.global?.weights?.length > 0 ? (
                                                    finallObjectData.pd.global.weights.map((item, index) => (
                                                        <div key={index} className={eclCss.wrapContainer}>
                                                        <div className={eclCss.weightLabel}>Period - {item.period}</div>
                                                        <div className={eclCss.weightVal}>{item.percentage}</div>
                                                        </div>
                                                    ))
                                                    ) : (
                                                    <div>No weights Data Entered</div>
                                                )}
                                            </div>
                                        {/* </div> */}
                                    </div>

                                    <div className={eclCss.reviewQuestionContainer}>
                                        <div className={eclCss.reviewQuestionLabel}>
                                            {finallObjectData?.pd?.global?.addOrMultiplyFactor === 'add' ? "Add" : 'Multiply'}  by PD% by
                                        </div>
                                        <div className={eclCss.reviewQuestionAnswer}>
                                            {finallObjectData?.pd?.global?.addOrMultiplyPercentage}
                                        </div>
                                    </div>
                                </div>
                        }


                    </div>
                   
                </div>
                
                {/* seprator */}
                {/* <div className={eclCss.containerSeprator}> </div> */}
                
                {/* right container */}
                <div className={eclCss.stage3RightContainer}>

                    <div className={eclCss.StageOnecontainer}>
                        <div className={eclCss.reviewContainerHeader}>
                            FLF Calculation
                        </div>

                         <div className={eclCss.reviewQuestionContainer}>
                            <div className={eclCss.reviewQuestionLabel}>
                                Do you want categorization?
                            </div>
                            <div className={eclCss.reviewQuestionAnswer}>
                                {finallObjectData?.flf?.categorize}
                            </div>
                        </div>

                        {
                            finallObjectData?.flf?.categorize === 'Yes'
                            ?
                                <div className={eclCss.reviewCategoryContainer}>
                                    
                                    <div className={eclCss.catgegoryContainer}>
                                        {finallObjectData?.flf?.categorized.map((item, index) => {
                                            const match = categorysData.find(
                                            (c) => c.categoryID === item.categoryID && c.subcategoryID === item.subcategoryID
                                            );

                                            return (
                                            <div
                                                key={index}
                                                className={
                                                stageFourActiveTab === index
                                                    ? index === 0
                                                    ? eclCss.activeCategoryTab
                                                    : eclCss.activeCategoryTabNoRadius
                                                    : eclCss.inActiveCategoryTab
                                                }
                                                onClick={() => setstageFourActiveTab(index)}
                                            >
                                                <div>
                                                <div className={eclCss.WMaxContant}>{match?.category || 'Category'}</div>
                                                <small className={eclCss.smallTxt}>{match?.subcategory || 'Subcategory'}</small>
                                                </div>
                                            </div>
                                            );
                                        })}
                                    </div>

                                    {finallObjectData?.flf?.categorized.map((item, index) => (
                                        <div key={index} className={stageFourActiveTab === index ? eclCss.containerShow : eclCss.containerNone}>
                                            {item.values.factors.map((factor, i) => (
                                            <div key={i} className={`${eclCss.reviewQuestionContainer}`}>
                                                <div className={eclCss.reviewQuestionLabel}>
                                                    {factor.description} - {factor.method === 'add' ? 'Add by' : 'Multiply by'}
                                                </div>
                                                <div className={eclCss.reviewQuestionAnswer}>
                                                    {factor.percentage}%
                                                </div>
                                            </div>
                                            ))}
                                        </div>
                                    ))}

                                </div>
                            :
                                // No category
                                <div>
                                    {finallObjectData?.flf?.global?.factors?.map((item, index) => (
                                        <div key={index} className={eclCss.reviewQuestionContainer}>
                                            <div className={eclCss.reviewQuestionLabel}>
                                                {item.description} - {item.method}
                                            </div>
                                            <div className={eclCss.reviewQuestionAnswer}>
                                                {item.percentage}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                        }
                    </div>
                    

                    <div className={eclCss.StageOnecontainer}>
                        <div className={eclCss.reviewContainerHeader}>
                            LGD Calculation
                        </div>

                         <div className={eclCss.reviewQuestionContainer}>
                            <div className={eclCss.reviewQuestionLabel}>
                                model
                            </div>
                            <div className={eclCss.reviewQuestionAnswer}>
                                {finallObjectData?.lgd?.model}
                            </div>
                        </div>

                        <div className={eclCss.reviewQuestionContainer}>
                            <div className={eclCss.reviewQuestionLabel}>
                                Do you want categorization?
                            </div>
                            <div className={eclCss.reviewQuestionAnswer}>
                                {finallObjectData?.lgd?.categorize}
                            </div>
                        </div>

                        {/* LGD */}
                        {
                            finallObjectData?.lgd?.categorize === 'Yes'
                            ?
                                <div className={eclCss.reviewCategoryContainer}>
                                    {/* Tabs */}

                                    <div className={eclCss.catgegoryContainer}>
                                        {finallObjectData?.lgd?.categorized.map((item, index) => (
                                            <div
                                            key={index}
                                            className={
                                                stageThreeActiveTab === index
                                                ? index === 0
                                                    ? eclCss.activeCategoryTab
                                                    : eclCss.activeCategoryTabNoRadius
                                                : eclCss.inActiveCategoryTab
                                            }
                                            onClick={() => setstageThreeActiveTab(index)}
                                            >
                                            <div>
                                                <div className={eclCss.WMaxContant}>
                                                {item.category || `Category ${index + 1}`}
                                                </div>
                                                <small className={eclCss.smallTxt}>
                                                {item.subcategory || 'Subcategory'}
                                                </small>
                                            </div>
                                            </div>
                                        ))}
                                    </div>

                                    {/* Body */}
                                    {finallObjectData?.lgd?.categorized.map((item, index) => (
                                        <div
                                        key={index}
                                        className={stageThreeActiveTab === index ? eclCss.containerShow : eclCss.containerNone}
                                        >
                                        <div className={eclCss.reviewQuestionContainer}>
                                            <div className={eclCss.reviewQuestionLabel}>
                                            What amount would you like to compute loss on?
                                            </div>
                                            <div className={eclCss.reviewQuestionAnswer}>
                                            {item.values.computeLossOn === 'loanDisbursedValue'
                                                ? 'Loan disbursed value'
                                                : item.values.computeLossOn === 'loanSanctionedValue'
                                                ? 'Loan sanctioned value'
                                                : item.values.computeLossOn === 'outstandingLoanValue'
                                                ? 'Outstanding loan value'
                                                : ''}
                                            </div>
                                        </div>

                                        <div className={eclCss.reviewQuestionContainer}>
                                            <div className={eclCss.reviewQuestionLabel}>
                                            Interest on EMI for delayed payment?
                                            </div>
                                            <div className={eclCss.reviewQuestionAnswer}>
                                            {item.values.considerInterestEMIDelayedPayment}
                                            </div>
                                        </div>

                                        <div className={eclCss.reviewQuestionContainer}>
                                            <div className={eclCss.reviewQuestionLabel}>
                                            Consider charges on loan recovery?
                                            </div>
                                            <div className={eclCss.reviewQuestionAnswer}>
                                            {item.values.considerPenalCharges}
                                            </div>
                                        </div>

                                        <div className={eclCss.reviewQuestionContainer}>
                                            <div className={eclCss.reviewQuestionLabel}>
                                            Only active NPA cases?
                                            </div>
                                            <div className={eclCss.reviewQuestionAnswer}>{item.values.onlyActiveNPA}</div>
                                        </div>

                                        <div className={eclCss.reviewQuestionContainer}>
                                            <div className={eclCss.reviewQuestionLabel}>
                                            Written off or Live loans?
                                            </div>
                                            <div className={eclCss.reviewQuestionAnswer}>{item.values.writtenOffOnly}</div>
                                        </div>

                                        <div className={eclCss.reviewQuestionContainer}>
                                            <div className={eclCss.reviewQuestionLabel}>
                                            Consider security value?
                                            </div>
                                            <div className={eclCss.reviewQuestionAnswer}>
                                            {item.values.considerSecurityValue}
                                            </div>
                                        </div>

                                        <div className={eclCss.reviewQuestionContainer}>
                                            <div className={eclCss.reviewQuestionLabel}>
                                            Consider secondary security?
                                            </div>
                                            <div className={eclCss.reviewQuestionAnswer}>
                                            {item.values.considerSecondarySecurity}
                                            </div>
                                        </div>

                                        <div className={eclCss.reviewQuestionContainer}>
                                            <div className={eclCss.reviewQuestionLabel}>
                                            Base value of Primary security
                                            </div>
                                            <div className={eclCss.reviewQuestionAnswer}>
                                            {item.values.baseValuePrimarySecurity}
                                            </div>
                                        </div>

                                        <div className={eclCss.reviewQuestionContainer}>
                                            <div className={eclCss.reviewQuestionLabel}>
                                            Base value of Secondary security
                                            </div>
                                            <div className={eclCss.reviewQuestionAnswer}>
                                            {item.values.baseValueSecondarySecurity}
                                            </div>
                                        </div>

                                        <div className={eclCss.weightsContainerDisplay} style={{ flexDirection: 'column' }}>
                                            <div className={eclCss.weightLabel}>Primary security percentage &nbsp;&nbsp; {item.values.percentageOfPrimarySecurity} </div>
                                            <div className={eclCss.weightLabel}>Secondary security percentage &nbsp;&nbsp; {item.values.percentageOfSecondarySecurity} </div>
                                        </div>

                                        {item.values.overlayFactor.map((factor, i) => (
                                            <div key={i} className={eclCss.reviewQuestionContainer}>
                                            <div className={eclCss.reviewQuestionLabel}>
                                                Overlay factor - {factor.method === 'add' ? 'Add by' : 'Multiply by'}
                                            </div>
                                            <div className={eclCss.reviewQuestionAnswer}>{factor.percentage}%</div>
                                            </div>
                                        ))}
                                        </div>
                                    ))}
                                </div>
                            :
                                <div>
                                    <div className={eclCss.reviewQuestionContainer}>
                                        <div className={eclCss.reviewQuestionLabel}>
                                            What amount would you like 
                                            <br />
                                            to compute loss on?
                                        </div>
                                        <div className={eclCss.reviewQuestionAnswer}>
                                            {
                                                finallObjectData?.lgd?.global?.computeLossOn === 'loanDisbursedValue'
                                                    ? 'Loan disbursed value'
                                                : finallObjectData?.lgd?.global?.computeLossOn === 'loanSanctionedValue'
                                                    ? 'Loan sanctioned value'
                                                : finallObjectData?.lgd?.global?.computeLossOn === 'outstandingLoanValue'
                                                    ? 'Outstanding loan value'
                                                : ''
                                            }

                                        </div>
                                    </div>

                                    <div className={eclCss.reviewQuestionContainer}>
                                        <div className={eclCss.reviewQuestionLabel}>
                                            Do you want to consider interest on 
                                            <br />
                                            EMI for delayed payment?
                                        </div>
                                        <div className={eclCss.reviewQuestionAnswer}>
                                            {finallObjectData?.lgd?.global?.considerInterestEMIDelayedPayment}
                                        </div>
                                    </div>

                                    <div className={eclCss.reviewQuestionContainer}>
                                        <div className={eclCss.reviewQuestionLabel}>
                                            Would you like to consider charges 
                                            <br />
                                            incurred on recovery of loan amount ?
                                        </div>
                                        <div className={eclCss.reviewQuestionAnswer}>
                                            {finallObjectData?.lgd?.global?.considerPenalCharges}
                                        </div>
                                    </div>

                                    <div className={eclCss.reviewQuestionContainer}>
                                        <div className={eclCss.reviewQuestionLabel}>
                                            Do you want to consider 
                                            <br />
                                            only active NPA cases ?
                                        </div>
                                        <div className={eclCss.reviewQuestionAnswer}>
                                            {finallObjectData?.lgd?.global?.considerRecoveryCharges}
                                        </div>
                                    </div>

                                    <div className={eclCss.reviewQuestionContainer}>
                                        <div className={eclCss.reviewQuestionLabel}>
                                            Is LGD computation only for written off 
                                            <br />
                                            loans, or for Live loans also?
                                        </div>
                                        <div className={eclCss.reviewQuestionAnswer}>
                                            {finallObjectData?.lgd?.global?.writtenOffOnly}
                                        </div>
                                    </div>

                                    <div className={eclCss.reviewQuestionContainer}>
                                        <div className={eclCss.reviewQuestionLabel}>
                                            Do you want to consider security value ?
                                        </div>
                                        <div className={eclCss.reviewQuestionAnswer}>
                                            {finallObjectData?.lgd?.global?.considerSecurityValue}
                                        </div>
                                    </div>

                                    <div className={eclCss.reviewQuestionContainer}>
                                        <div className={eclCss.reviewQuestionLabel}>
                                            Do you want to consider secondary security as well ?
                                        </div>
                                        <div className={eclCss.reviewQuestionAnswer}>
                                            {finallObjectData?.lgd?.global?.considerSecondarySecurity}
                                        </div>
                                    </div>

                                    <div className={eclCss.reviewQuestionContainer}>
                                        <div className={eclCss.reviewQuestionLabel}>
                                            What is the base value of security? (Primary security)
                                        </div>
                                        <div className={eclCss.reviewQuestionAnswer}>
                                            {finallObjectData?.lgd?.global?.baseValuePrimarySecurity}
                                        </div>
                                    </div>

                                    <div className={eclCss.reviewQuestionContainer}>
                                        <div className={eclCss.reviewQuestionLabel}>
                                            What is the base value of security? (Secondary security)
                                        </div>
                                        <div className={eclCss.reviewQuestionAnswer}>
                                            {finallObjectData?.lgd?.global?.baseValueSecondarySecurity}
                                        </div>
                                    </div>

                                    <div className={eclCss.reviewQuestionContainer}>
                                        <div className={eclCss.reviewQuestionLabel}>
                                            What percentage of base value would you consider?
                                        </div>
                                    </div>
                                    
                                    <div className={eclCss.reviewQuestionContainer}>
                                        <div className={eclCss.weightsContainerDisplay}>
                                            <div style={{ width:'100%', display:'flex', justifyContent:'space-between' }}>
                                                <div className={eclCss.weightLabel}>
                                                    Primary security percentage 
                                                </div>
                                                <div className={eclCss.weightVal}>
                                                    {finallObjectData?.lgd?.global?.percentageOfPrimarySecurity}
                                                </div>
                                            </div>
                                            <br />
                                            <div style={{ width:'100%', display:'flex', justifyContent:'space-between' }}>
                                                <div className={eclCss.weightLabel}>
                                                    Secondary security percentage
                                                </div>
                                                <div className={eclCss.weightVal}>
                                                    {finallObjectData?.lgd?.global?.percentageOfSecondarySecurity}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {finallObjectData?.lgd?.global?.overlayFactor?.map((item, index) => (
                                        <div key={index} className={eclCss.reviewQuestionContainer}>
                                            <div className={eclCss.reviewQuestionLabel}>
                                            Overlay factor - {item.method === 'add' ? 'Add by' : item.method === 'multiply' ? 'Multiply by' : ''}
                                            </div>
                                            <div className={eclCss.reviewQuestionAnswer}>
                                            {item.percentage}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                        }
                        
                    </div>

                </div>
        </div>
    )

}


const EclHeader = ({
    createOrupdate,
    scenarioId,
    ActiveStage,
    setActiveStage,
    companyID,
    companyName,
    StageOneScenarioName
    }) => {

    const routerHistory = useHistory();
    const handleClick = (Link) => {
        routerHistory.push(Link);
    };

    const deleteScenario = async (scenarioId) => {
        await deleteLoanECLScenario(scenarioId);
        handleClick(`/myfinv2/loan-policy/${companyID}`)
    }

    const breadcrumbItems = [
        {
            label: "My companies",
            link: `/myfinV2/my-companies`,
            className: `${commoncss.nav_cnt_color} clickable`,
        },
        {
            label: companyName,
            link: `/myfinV2/company-details/${companyID}`,
            className: `${commoncss.nav_cnt_color} clickable`,
        },
        {
            label: "Accounting policy",
            link: `/myfinV2/accounting-policy/${companyID}`,
            className: `${commoncss.nav_cnt_color} clickable`,
        },
        {
            label: "ECL",
            link: `/myfinV2/loan-policy/${companyID}`,
            className: `${commoncss.nav_cnt_color} clickable`,
        },
        {
            label: createOrupdate === 'updateFlow' ? StageOneScenarioName : "Create Scenario",
            className: `${commoncss.nav_cnt_color}`,
        },
    ];
    
    return(
        <div className={eclCss.breadMainCumbContainer}> 
            <Breadcrumb
                addCls="bgTransprent"
                items={breadcrumbItems}
                headerActions={<></>}
                p0={true}
            />

            <button className={` ${createOrupdate === 'updateFlow' ? eclCss.unhideContant : eclCss.hiddeContant} ${eclCss.delBtn}`} onClick={() => {deleteScenario(scenarioId);}} type="button">Delete</button>
        </div>
    )
}






// const StageNumberBadge = ({
//     ActiveStage,
//     setActiveStage,
//     }) => {

//         var outerBadge1 = ''
//         var innerBadge1 = ''
//         var badgeConnecter1 = ''
//         var content1 = 1

//         var outerBadge2 = ''
//         var innerBadge2 = ''
//         var badgeConnecter2 = ''
//         var content2 = 2

//         var outerBadge3 = ''
//         var innerBadge3 = ''
//         var badgeConnecter3 = ''
//         var content3 = 3

//         var outerBadge4 = ''
//         var innerBadge4 = ''
//         var badgeConnecter4 = ''
//         var content4 = 4

//         var outerBadge5 = ''
//         var innerBadge5 = ''
//         var badgeConnecter5 = ''
//         var content5 = 5

//         if (ActiveStage === 1) {
//                 outerBadge1 = `${eclCss.numBadge} ${eclCss.activeBadegClr}`;
//                 innerBadge1 = `${eclCss.numBadgeInner} ${eclCss.innerBadgeBgClr}`
//                 badgeConnecter1 = `${eclCss.numbConnterStart1} ${eclCss.activeBadgeBgClr}`
//                 content1 = 1
                
//                 outerBadge2 =  `${eclCss.numBadge} ${eclCss.inactiveBadgeBgClr}`
//                 innerBadge2 = `${eclCss.numBadgeInner} ${eclCss.innerBadgeBgClr}`
//                 badgeConnecter2 = `${eclCss.numbConnterStart2} ${eclCss.inactiveBadgeBgClr}`
//                 content2 = 2
                
//                 outerBadge3 = `${eclCss.numBadge} ${eclCss.inactiveBadgeBgClr}`
//                 innerBadge3 = `${eclCss.numBadgeInner} ${eclCss.innerBadgeBgClr}`
//                 badgeConnecter3 = `${eclCss.numbConnterStart3} ${eclCss.inactiveBadgeBgClr}`
//                 content3 = 3
                
//                 outerBadge4 = `${eclCss.numBadge} ${eclCss.inactiveBadgeBgClr}`
//                 innerBadge4 = `${eclCss.numBadgeInner} ${eclCss.innerBadgeBgClr}`
//                 badgeConnecter4 = `${eclCss.numbConnterStart4} ${eclCss.inactiveBadgeBgClr}`
//                 content4 = 4
                
//                 outerBadge5 = `${eclCss.numBadge} ${eclCss.inactiveBadgeBgClr}`
//                 innerBadge5 = `${eclCss.numBadgeInner} ${eclCss.innerBadgeBgClr}`
//                 badgeConnecter5 = `${eclCss.numbConnterStart5} ${eclCss.inactiveBadgeBgClr}`
//                 content5 = 5
//             } 
//             else if (ActiveStage === 2 || ActiveStage === 'C2') {
//                 outerBadge1 = `${eclCss.numBadge} ${eclCss.completeBadgeClr}`;
//                 innerBadge1 = `${eclCss.numBadgeInner} ${eclCss.completeBadgeClr}`
//                 badgeConnecter1 = `${eclCss.numbConnterStart1} ${eclCss.completedBadgConnecterClr}`
//                 content1 = <CompleteECLIcon />

//                 outerBadge2 =  `${eclCss.numBadge} ${eclCss.activeBadegClr}`
//                 innerBadge2 = `${eclCss.numBadgeInner} ${eclCss.innerBadgeBgClr}`
//                 badgeConnecter2 = `${eclCss.numbConnterStart2} ${eclCss.activeBadgeBgClr}`

//                 outerBadge3 = `${eclCss.numBadge} ${eclCss.inactiveBadgeBgClr}`
//                 innerBadge3 = `${eclCss.numBadgeInner} ${eclCss.innerBadgeBgClr}`
//                 badgeConnecter3 = `${eclCss.numbConnterStart3} ${eclCss.inactiveBadgeBgClr}`

//                 outerBadge4 = `${eclCss.numBadge} ${eclCss.inactiveBadgeBgClr}`
//                 innerBadge4 = `${eclCss.numBadgeInner} ${eclCss.innerBadgeBgClr}`
//                 badgeConnecter4 = `${eclCss.numbConnterStart4} ${eclCss.inactiveBadgeBgClr}`

//                 outerBadge5 = `${eclCss.numBadge} ${eclCss.inactiveBadgeBgClr}`
//                 innerBadge5 = `${eclCss.numBadgeInner} ${eclCss.innerBadgeBgClr}`
//                 badgeConnecter5 = `${eclCss.numbConnterStart5} ${eclCss.inactiveBadgeBgClr}`
//             } 
//             else if (ActiveStage === 3 || ActiveStage === 'C3') {
//                 outerBadge1 = `${eclCss.numBadge} ${eclCss.completeBadgeClr}`;
//                 innerBadge1 = `${eclCss.numBadgeInner} ${eclCss.completeBadgeClr}`
//                 badgeConnecter1 = `${eclCss.numbConnterStart1} ${eclCss.fullCompletedBadgConnecterClr}`
//                 content1 = <CompleteECLIcon />

//                 outerBadge2 =  `${eclCss.numBadge} ${eclCss.completeBadgeClr}`
//                 innerBadge2 = `${eclCss.numBadgeInner} ${eclCss.completeBadgeClr}`
//                 badgeConnecter2 = `${eclCss.numbConnterStart2} ${eclCss.completedBadgConnecterClr}`
//                 content2 = <CompleteECLIcon />

//                 outerBadge3 = `${eclCss.numBadge} ${eclCss.activeBadegClr}`
//                 innerBadge3 = `${eclCss.numBadgeInner} ${eclCss.innerBadgeBgClr}`
//                 badgeConnecter3 = `${eclCss.numbConnterStart3} ${eclCss.activeBadgeBgClr}`

//                 outerBadge4 = `${eclCss.numBadge} ${eclCss.inactiveBadgeBgClr}`
//                 innerBadge4 = `${eclCss.numBadgeInner} ${eclCss.innerBadgeBgClr}`
//                 badgeConnecter4 = `${eclCss.numbConnterStart4} ${eclCss.inactiveBadgeBgClr}`

//                 outerBadge5 = `${eclCss.numBadge} ${eclCss.inactiveBadgeBgClr}`
//                 innerBadge5 = `${eclCss.numBadgeInner} ${eclCss.innerBadgeBgClr}`
//                 badgeConnecter5 = `${eclCss.numbConnterStart5} ${eclCss.inactiveBadgeBgClr}`
//             } 
//             else if (ActiveStage === 4 || ActiveStage === 'C4') {
//                 outerBadge1 = `${eclCss.numBadge} ${eclCss.completeBadgeClr}`;
//                 innerBadge1 = `${eclCss.numBadgeInner} ${eclCss.completeBadgeClr}`
//                 badgeConnecter1 = `${eclCss.numbConnterStart1} ${eclCss.fullCompletedBadgConnecterClr}`
//                 content1 = <CompleteECLIcon />

//                 outerBadge2 =  `${eclCss.numBadge} ${eclCss.completeBadgeClr}`
//                 innerBadge2 = `${eclCss.numBadgeInner} ${eclCss.completeBadgeClr}`
//                 badgeConnecter2 = `${eclCss.numbConnterStart2} ${eclCss.fullCompletedBadgConnecterClr}`
//                 content2 = <CompleteECLIcon />

//                 outerBadge3 = `${eclCss.numBadge} ${eclCss.completeBadgeClr}`
//                 innerBadge3 = `${eclCss.numBadgeInner} ${eclCss.completeBadgeClr}`
//                 badgeConnecter3 = `${eclCss.numbConnterStart3} ${eclCss.completedBadgConnecterClr}`
//                 content3 = <CompleteECLIcon />

//                 outerBadge4 = `${eclCss.numBadge} ${eclCss.activeBadegClr}`
//                 innerBadge4 = `${eclCss.numBadgeInner} ${eclCss.innerBadgeBgClr}`
//                 badgeConnecter4 = `${eclCss.numbConnterStart4} ${eclCss.activeBadgeBgClr}`

//                 outerBadge5 = `${eclCss.numBadge} ${eclCss.inactiveBadgeBgClr}`
//                 innerBadge5 = `${eclCss.numBadgeInner} ${eclCss.innerBadgeBgClr}`
//                 badgeConnecter5 = `${eclCss.numbConnterStart5} ${eclCss.inactiveBadgeBgClr}`
//             } 
//             else if (ActiveStage === 5) {
//                 outerBadge1 = `${eclCss.numBadge} ${eclCss.completeBadgeClr}`;
//                 innerBadge1 = `${eclCss.numBadgeInner} ${eclCss.completeBadgeClr}`
//                 badgeConnecter1 = `${eclCss.numbConnterStart1} ${eclCss.fullCompletedBadgConnecterClr}`
//                 content1 = <CompleteECLIcon />

//                 outerBadge2 =  `${eclCss.numBadge} ${eclCss.completeBadgeClr}`
//                 innerBadge2 = `${eclCss.numBadgeInner} ${eclCss.completeBadgeClr}`
//                 badgeConnecter2 = `${eclCss.numbConnterStart2} ${eclCss.fullCompletedBadgConnecterClr}`
//                 content2 = <CompleteECLIcon />

//                 outerBadge3 = `${eclCss.numBadge} ${eclCss.completeBadgeClr}`
//                 innerBadge3 = `${eclCss.numBadgeInner} ${eclCss.completeBadgeClr}`
//                 badgeConnecter3 = `${eclCss.numbConnterStart3} ${eclCss.fullCompletedBadgConnecterClr}`
//                 content3 = <CompleteECLIcon />

//                 outerBadge4 = `${eclCss.numBadge} ${eclCss.completeBadgeClr}`
//                 innerBadge4 = `${eclCss.numBadgeInner} ${eclCss.completeBadgeClr}`
//                 badgeConnecter4 = `${eclCss.numbConnterStart4} ${eclCss.completedBadgConnecterClr}`
//                 content4 = <CompleteECLIcon />

//                 outerBadge5 = `${eclCss.numBadge} ${eclCss.activeBadegClr}`
//                 innerBadge5 = `${eclCss.numBadgeInner} ${eclCss.innerBadgeBgClr}`
//                 badgeConnecter5 = `${eclCss.numbConnterStart5} ${eclCss.activeBadgeBgClr}`
//             } 
            

//     return (

//         <div className={eclCss.numBadgeMainContainer}>
//             <div className={eclCss.numberContainer}>
//                 <div onClick={ () => {} } key={1} className={outerBadge1}>
//                     <div className={badgeConnecter1}></div>
//                     <div className={innerBadge1}>{content1}</div>
//                     <div className={`${eclCss.numberText} ${eclCss.numberText1}`}>SCENARIO INFO</div>
//                 </div>
//                 <div onClick={ () => {} } key={2} className={outerBadge2}>
//                     <div className={badgeConnecter2}></div>
//                     <div className={innerBadge2}>{content2}</div>
//                     <div className={`${eclCss.numberText} ${eclCss.numberText2}`}>DEFINE PD</div>
//                 </div>
//                 <div onClick={ () => {} } key={3} className={outerBadge3}>
//                     <div className={badgeConnecter3}></div>
//                     <div className={innerBadge3}>{content3}</div>
//                     <div className={`${eclCss.numberText} ${eclCss.numberText3}`}>DEFINE LGD</div>
//                 </div>
//                 <div onClick={ () => {} } key={4} className={outerBadge4}>
//                     <div className={badgeConnecter4}></div>
//                     <div className={innerBadge4}>{content4}</div>
//                     <div className={`${eclCss.numberText} ${eclCss.numberText4}`}>DEFINE FLF</div>
//                 </div>
//                 <div onClick={ () => {} } key={5} className={outerBadge5}>
//                     <div className={badgeConnecter5}></div>
//                     <div className={innerBadge5}>{content5}</div>
//                     <div className={`${eclCss.numberText} ${eclCss.numberText5}`}>REVIEW AND SUBMIT</div>
//                 </div>
            
//             </div>
//         </div>
//     );
// };


const StageNumberBadge = ({
    ActiveStage,
    setActiveStage,
}) => {

    // === DEFAULT CLASSES ===
    let outerBadge1 = `${eclCss.numBadge} ${eclCss.inactiveBadgeBgClr} ${eclCss.badge}`;
    let innerBadge1 = `${eclCss.numBadgeInner} ${eclCss.innerBadgeBgClr}`;
    let badgeConnecter1 = `${eclCss.numbConnterStart1} ${eclCss.inactiveBadgeBgClr}`;
    let content1 = 1;

    let outerBadge2 = `${eclCss.numBadge} ${eclCss.inactiveBadgeBgClr} ${eclCss.badge}`;
    let innerBadge2 = `${eclCss.numBadgeInner} ${eclCss.innerBadgeBgClr}`;
    let badgeConnecter2 = `${eclCss.numbConnterStart2} ${eclCss.inactiveBadgeBgClr}`;
    let content2 = 2;

    let outerBadge3 = `${eclCss.numBadge} ${eclCss.inactiveBadgeBgClr} ${eclCss.badge}`;
    let innerBadge3 = `${eclCss.numBadgeInner} ${eclCss.innerBadgeBgClr}`;
    let badgeConnecter3 = `${eclCss.numbConnterStart3} ${eclCss.inactiveBadgeBgClr}`;
    let content3 = 3;

    let outerBadge4 = `${eclCss.numBadge} ${eclCss.inactiveBadgeBgClr} ${eclCss.badge}`;
    let innerBadge4 = `${eclCss.numBadgeInner} ${eclCss.innerBadgeBgClr}`;
    let badgeConnecter4 = `${eclCss.numbConnterStart4} ${eclCss.inactiveBadgeBgClr}`;
    let content4 = 4;

    let outerBadge5 = `${eclCss.numBadge} ${eclCss.inactiveBadgeBgClr} ${eclCss.badge}`;
    let innerBadge5 = `${eclCss.numBadgeInner} ${eclCss.innerBadgeBgClr}`;
    let badgeConnecter5 = `${eclCss.numbConnterStart5} ${eclCss.inactiveBadgeBgClr}`;
    let content5 = 5;

    if (ActiveStage === 1) {
        outerBadge1 = `${eclCss.numBadge} ${eclCss.activeBadegClr} ${eclCss.badge}`;
        badgeConnecter1 = `${eclCss.numbConnterStart1} ${eclCss.middleActiveBar}`;

        badgeConnecter2 = `${eclCss.numbConnterStart2} ${eclCss.lastInActiverBar}`;
    } else if (ActiveStage === 2 || ActiveStage === 'C2') {
        outerBadge1 = `${eclCss.numBadge} ${eclCss.completeBadgeClr} ${eclCss.badge}`;
        innerBadge1 = `${eclCss.numBadgeInner} ${eclCss.completeBadgeClr}`;
        badgeConnecter1 = `${eclCss.numbConnterStart1} ${eclCss.completedBadgConnecterClr}`;
        content1 = <CompleteECLIcon />;

        outerBadge2 = `${eclCss.numBadge} ${eclCss.activeBadegClr} ${eclCss.badge}`;
        badgeConnecter2 = `${eclCss.numbConnterStart2} ${eclCss.middleActiveBar}`;

        badgeConnecter3 = `${eclCss.numbConnterStart3} ${eclCss.lastInActiverBar}`;
    } else if (ActiveStage === 3 || ActiveStage === 'C3') {
        outerBadge1 = `${eclCss.numBadge} ${eclCss.completeBadgeClr} ${eclCss.badge}`;
        innerBadge1 = `${eclCss.numBadgeInner} ${eclCss.completeBadgeClr}`;
        badgeConnecter1 = `${eclCss.numbConnterStart1} ${eclCss.fullCompletedBadgConnecterClr}`;
        content1 = <CompleteECLIcon />;

        outerBadge2 = `${eclCss.numBadge} ${eclCss.completeBadgeClr} ${eclCss.badge}`;
        innerBadge2 = `${eclCss.numBadgeInner} ${eclCss.completeBadgeClr}`;
        badgeConnecter2 = `${eclCss.numbConnterStart2} ${eclCss.completedBadgConnecterClr}`;
        content2 = <CompleteECLIcon />;

        outerBadge3 = `${eclCss.numBadge} ${eclCss.activeBadegClr} ${eclCss.badge}`;
        badgeConnecter3 = `${eclCss.numbConnterStart3} ${eclCss.middleActiveBar}`;

        badgeConnecter4 = `${eclCss.numbConnterStart4} ${eclCss.lastInActiverBar}`;
    } else if (ActiveStage === 4 || ActiveStage === 'C4') {
        outerBadge1 = `${eclCss.numBadge} ${eclCss.completeBadgeClr} ${eclCss.badge}`;
        innerBadge1 = `${eclCss.numBadgeInner} ${eclCss.completeBadgeClr}`;
        badgeConnecter1 = `${eclCss.numbConnterStart1} ${eclCss.fullCompletedBadgConnecterClr}`;
        content1 = <CompleteECLIcon />;

        outerBadge2 = `${eclCss.numBadge} ${eclCss.completeBadgeClr} ${eclCss.badge}`;
        innerBadge2 = `${eclCss.numBadgeInner} ${eclCss.completeBadgeClr}`;
        badgeConnecter2 = `${eclCss.numbConnterStart2} ${eclCss.fullCompletedBadgConnecterClr}`;
        content2 = <CompleteECLIcon />;

        outerBadge3 = `${eclCss.numBadge} ${eclCss.completeBadgeClr} ${eclCss.badge}`;
        innerBadge3 = `${eclCss.numBadgeInner} ${eclCss.completeBadgeClr}`;
        badgeConnecter3 = `${eclCss.numbConnterStart3} ${eclCss.completedBadgConnecterClr}`;
        content3 = <CompleteECLIcon />;

        outerBadge4 = `${eclCss.numBadge} ${eclCss.activeBadegClr} ${eclCss.badge}`;
        badgeConnecter4 = `${eclCss.numbConnterStart4} ${eclCss.middleActiveBar}`;

        badgeConnecter5 = `${eclCss.numbConnterStart5} ${eclCss.lastInActiverBar}`;
    } else if (ActiveStage === 5) {
        outerBadge1 = `${eclCss.numBadge} ${eclCss.completeBadgeClr} ${eclCss.badge}`;
        innerBadge1 = `${eclCss.numBadgeInner} ${eclCss.completeBadgeClr}`;
        badgeConnecter1 = `${eclCss.numbConnterStart1} ${eclCss.fullCompletedBadgConnecterClr}`;
        content1 = <CompleteECLIcon />;

        outerBadge2 = `${eclCss.numBadge} ${eclCss.completeBadgeClr} ${eclCss.badge}`;
        innerBadge2 = `${eclCss.numBadgeInner} ${eclCss.completeBadgeClr}`;
        badgeConnecter2 = `${eclCss.numbConnterStart2} ${eclCss.fullCompletedBadgConnecterClr}`;
        content2 = <CompleteECLIcon />;

        outerBadge3 = `${eclCss.numBadge} ${eclCss.completeBadgeClr} ${eclCss.badge}`;
        innerBadge3 = `${eclCss.numBadgeInner} ${eclCss.completeBadgeClr}`;
        badgeConnecter3 = `${eclCss.numbConnterStart3} ${eclCss.fullCompletedBadgConnecterClr}`;
        content3 = <CompleteECLIcon />;

        outerBadge4 = `${eclCss.numBadge} ${eclCss.completeBadgeClr} ${eclCss.badge}`;
        innerBadge4 = `${eclCss.numBadgeInner} ${eclCss.completeBadgeClr}`;
        badgeConnecter4 = `${eclCss.numbConnterStart4} ${eclCss.completedBadgConnecterClr}`;
        content4 = <CompleteECLIcon />;

        outerBadge5 = `${eclCss.numBadge} ${eclCss.activeBadegClr} ${eclCss.badge}`;
        badgeConnecter5 = `${eclCss.numbConnterStart5} ${eclCss.middleActiveBar}`;
    }

    return (
        <div className={eclCss.numBadgeMainContainer}>
            <div className={eclCss.numberContainer}>
                <div onClick={() => {}} key={1} className={`${eclCss.numBadgeContainer} ${eclCss.badgeContainerOne}`}>
                    <div className={badgeConnecter1}></div>
                    <div className={`${outerBadge1} ${eclCss.badge}`}>
                        <div className={innerBadge1}>{content1}</div> 
                    </div>
                    <div className={`${eclCss.numberText} ${eclCss.numberText1}`}>Scenario</div>
                </div>
                <div onClick={() => {}} key={2} className={`${eclCss.numBadgeContainer} ${eclCss.badgeContainerTwo}`}>
                    <div className={badgeConnecter2}></div>
                    <div className={`${outerBadge2} ${eclCss.badge}`}>
                        <div className={innerBadge2}>{content2}</div>
                    </div>
                    <div className={`${eclCss.numberText} ${eclCss.numberText2}`}>DEFINE PD</div>
                </div>
                <div onClick={() => {}} key={3} className={`${eclCss.numBadgeContainer} ${eclCss.badgeContainerThree}`}>
                    <div className={badgeConnecter3}></div>
                    <div className={`${outerBadge3} ${eclCss.badge}`}>
                        <div className={innerBadge3}>{content3}</div>
                    </div>
                    <div className={`${eclCss.numberText} ${eclCss.numberText3}`}>DEFINE LGD</div>
                </div>
                <div onClick={() => {}} key={4} className={`${eclCss.numBadgeContainer} ${eclCss.badgeContainerFour}`}>
                    <div className={badgeConnecter4}></div>
                    <div className={`${outerBadge4} ${eclCss.badge}`}>
                        <div className={innerBadge4}>{content4}</div>
                    </div>
                    <div className={`${eclCss.numberText} ${eclCss.numberText4}`}>DEFINE FLF</div>
                </div>
                <div onClick={() => {}} key={5} className={`${eclCss.numBadgeContainer} ${eclCss.badgeContainerFive}`}>
                    <div className={badgeConnecter5}></div>
                    <div className={`${outerBadge5} ${eclCss.badge}`}>
                        <div className={innerBadge5}>{content5}</div>
                    </div>
                    <div className={`${eclCss.numberText} ${eclCss.numberText5}`}>REVIEW AND SUBMIT</div>
                </div>
            </div>
        </div>
    );
};


const EclFooter = ({ 
    finallObjectData, 
    setfinallObjectData,
    createOrupdate,
    scenarioId,
    StageTwoCategorization,
    StageThreeCategorization,
    StageFourCategorization,

    companyID,
    
    ActiveStage,
    setActiveStage,

    stageOneWholeData,

    stageTwoWholeData,

    stageTwoCategoryWholeData,

    stageThreeWholeData,

    stageThreeCategoryWholeData,

    stageFourWholeData,

    stageFourCategoryWholeData,

    }) => {

    const routerHistory = useHistory();
    const handleClick = (Link) => {
        routerHistory.push(Link);
    };

    const formateData = (sendDataToApi) => {

        let stageTwoCategorys = Object.values(stageTwoCategoryWholeData);
        const stageTwoCategorysArray = stageTwoCategorys.map(({ category, subcategory, ...rest }) => rest);

        let stageThreeCategorys = Object.values(stageThreeCategoryWholeData);
        const stageThreeCategorysArray = stageThreeCategorys.map(({ category, subcategory, ...rest }) => rest);

        let stageFourCategorys = Object.values(stageFourCategoryWholeData);
        const stageFourCategorysArray = stageFourCategorys.map(({ category, subcategory, ...rest }) => rest);

        const finallObj = {
            'name': stageOneWholeData.name,
            'companyID':companyID, // Company ObjectId
            'indASProvisioning':stageOneWholeData.indASProvisioning,

            'pd':{
                'model' : stageTwoWholeData.model, // Only valid value
                'categorize' : stageTwoWholeData.categorize, // Yes | No
                'global': stageTwoWholeData.global,
                'categorized': stageTwoCategorysArray,
            },

            "lgd": {
                'model': stageThreeWholeData.model, // You can decide allowed values
                'categorize': stageThreeWholeData.categorize, // Yes | No
                'global': stageThreeWholeData.global,
                'categorized': stageThreeCategorysArray,
            },

            'flf': {
                // "model": 'Simple FLF',
                'categorize': stageFourWholeData.categorize, // Yes | No
                'global': stageFourWholeData.global,
                'categorized': stageFourCategorysArray,
            }

        }

        if (stageTwoWholeData.categorize === 'Yes'){
            
            delete finallObj.pd.global

            var cateObj = finallObj.pd.categorized

            for (let index = 0; index < cateObj.length; index++) {

                let eachObj = cateObj[index];
                let delObj = eachObj.values
                delete eachObj.values

                eachObj['values'] = {
                    "rateCalculation": delObj.StageTwoCategoryPDInpt, // Valid: count, loanSanctionedValue, loanOutstandingValue, loanDisbursedValue
                    "frequency": delObj.StageTwoCategoryPDCalculation,
                    "periods": delObj.StageTwoCategoryNumberOfPeriods,
                    "baseValuePostPeriodOne": delObj.StageTwoCategoryLoanSect, // total | nonDefault
                    "includeInterestDefaultPayments": delObj.StageTwoDefaultPayment, // Yes | No
                    "calculateTwelveMonthsPD": delObj.calculateTwelveMonthsPD, // Yes | No
                    "considerAsPeriodOne": delObj.StageTwoCategoryConsiderPeriod, // financialYear | disbursementYear
                    "extrapolationForMissingPeriod": delObj.StageTwoCategoryExtraploation,
                    "extrapolationMethod": delObj.StageTwoCategorySAWApE, // simpleAverage, weightedAverage, proportionateExtrapolation
                    "extrapolationPercentage": delObj.StageTwoCategoryNumberOfPeriods,
                    "useWeights": delObj.StageTwoCategorySpecificWe, // Yes | No
                    "weights": delObj.weights,
                    "addOrMultiplyFactor": delObj.StageTwoCategoryMulpliyPDSelect, // add | multiply
                    "addOrMultiplyPercentage": delObj.StageTwoCategoryMulpliyPDInpt
                }
            }
        }
        else{ // category No
            delete finallObj.pd.categorized
        }

        if (stageThreeWholeData.categorize === 'Yes'){
            delete finallObj.lgd.global

            var CateThreeObje = finallObj.lgd.categorized

            for (let index = 0; index < CateThreeObje.length; index++) {

                let CateThreeEachObje = CateThreeObje[index];
                let CateThreedelObj = CateThreeEachObje.values
                delete CateThreeEachObje.values

                CateThreeEachObje['values'] = {
                    "computeLossOn":CateThreedelObj.computeLossOn,
                    "considerInterestEMIDelayedPayment":CateThreedelObj.considerInterestEMIDelayedPayment,
                    "considerPenalCharges":CateThreedelObj.considerPenalCharges,
                    "considerRecoveryCharges":CateThreedelObj.considerRecoveryCharges,
                    "onlyActiveNPA":CateThreedelObj.onlyActiveNPA,
                    "writtenOffOnly":CateThreedelObj.writtenOffOnly,
                    "considerSecurityValue":CateThreedelObj.considerSecurityValue,
                    "considerSecondarySecurity":CateThreedelObj.considerSecondarySecurity,
                    "baseValuePrimarySecurity":CateThreedelObj.baseValuePrimarySecurity,
                    "baseValueSecondarySecurity":CateThreedelObj.baseValueSecondarySecurity,
                    "percentageOfPrimarySecurity":CateThreedelObj.percentageOfPrimarySecurity,
                    "percentageOfSecondarySecurity":CateThreedelObj.percentageOfSecondarySecurity,
                    // "badDebtConsider":CateThreedelObj.badDebtConsider,
                    "addOverlayFactor":CateThreedelObj.addOverlayFactor,
                    "overlayFactor":CateThreedelObj.overlayFactor,
                }
            }
        }
        else{ // category No
            delete finallObj.lgd.categorized
        }

        if (stageFourWholeData.categorize === 'Yes'){
            
            delete finallObj.flf.global
            var CateFourObje = finallObj.flf.categorized

            for (let index = 0; index < CateFourObje.length; index++) {

                let CateFourEachObje = CateFourObje[index];
                let CateFourdelObj = CateFourEachObje.values
                delete CateFourEachObje.values

                CateFourEachObje['values'] = {
                    "factors": CateFourdelObj.factors
                }

            }

        }
        else{ // category No
            delete finallObj.flf.categorized
        }

        if(sendDataToApi){

            if (createOrupdate === 'updateFlow') {
    
                updateLoanECLScenario(scenarioId,finallObj)
                    .then(response => {
                        toast.success("Scenario Updated Successfully.");
                        handleClick(`/myfinv2/loan-policy/${companyID}`)
                    })
                    .catch(error => {
                        swal("Error", error.response?.data?.error || "Saving Upldate scenario!", 'error');
                });
    
            }
    
            if (createOrupdate === 'createFlow') {
                createNewEclScenario(finallObj)
                    .then(response => {
                        toast.success("New Scenario Created Successfully.");
                        handleClick(`/myfinv2/loan-policy/${companyID}`)
                    })
                    .catch(error => {
                        swal("Error", error.response?.data?.error || "Saving new staging!", 'error');
                });
            }

        }
        else{
            setfinallObjectData(finallObj)
        }

    }

    return(
        <div className={`${eclCss.footerContainer} ${eclCss.custmfadein}`}>
            <div>
                <button 
                onClick={() => {handleClick(`/myfinv2/loan-policy/${companyID}`)}}
                className={eclCss.cancelBtn} type="button">Cancel</button>
            </div>
            <div className={eclCss.footerbtnContainer}>
                <button onClick={() => {
                            // console.log('ActiveStage :: ',ActiveStage);
                            if(ActiveStage === 'C2' || ActiveStage === 2){
                                setActiveStage(1) 
                            }
                            else if(ActiveStage === 'C3' || ActiveStage === 3){
                                if(StageTwoCategorization === 'Yes'){
                                    setActiveStage('C2') 
                                }
                                else{
                                    setActiveStage(2) 
                                }
                            }
                            else if(ActiveStage === 'C4' || ActiveStage === 4){
                                if(StageThreeCategorization === 'Yes'){
                                    setActiveStage('C3') 
                                }
                                else{
                                    setActiveStage(3) 
                                }
                            }
                            else if(ActiveStage === 5){
                                if(StageFourCategorization === 'Yes'){
                                    setActiveStage('C4')
                                }
                                else{
                                    setActiveStage(4)
                                }
                            }
                            
                        }}
                        
                        className={eclCss.perviewBtn} type="button"> <PervBtnIcon /> Previous</button>
                <button onClick={()=>{ 
                            if(ActiveStage === 1){
                                if(StageTwoCategorization === 'Yes'){
                                    setActiveStage('C2')
                                }
                                else{
                                    setActiveStage(2)
                                }
                            }
                            else if(ActiveStage === 'C2' || ActiveStage === 2){
                                if(StageThreeCategorization === 'Yes'){
                                    setActiveStage('C3')
                                }
                                else{
                                    setActiveStage(3) 
                                }
                            }
                            else if(ActiveStage === 'C3' || ActiveStage === 3){
                                if(StageFourCategorization === 'Yes'){
                                    setActiveStage('C4')
                                }
                                else{
                                    setActiveStage(4)
                                }
                            }
                            else if(ActiveStage === 'C4' || ActiveStage === 4){
                                setActiveStage(5) 
                                formateData(false)
                            }
                            else if(ActiveStage === 5){
                                // setActiveStage(ActiveStage + 1) 
                                formateData(true)
                            }
                          
                        }} 
                        className={eclCss.saveBtn} type="button">{ ActiveStage === 5 ? createOrupdate === 'updateFlow' ? 'Update Scenario' : 'Create Scenario' : 'Next'}
                </button>
            </div>
        </div>
    )
}




// export const customStyles = {
//   control: (provided, state) => ({
//     ...provided,
//     backgroundColor: '#f4faf5',
//     borderColor: '#c2e6d1',
//     color: '#b3c0bd',
//     boxShadow: state.isFocused ? '0 0 0 1px #c2e6d1' : 'none',
//     borderWidth: '1px',
//     borderRadius: '10px',
//     '&:hover': {
//       borderColor: '#b3c0bd',
//     },
//     minHeight: '38px',
//     height: '38px'
//   }),
//   valueContainer: (provided) => ({
//     ...provided,
//     padding: '2px 8px',
//     paddingTop: '1px'
//   }),
//   input: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//   }),
//   placeholder: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//     fontSize: "14px"
//   }),
//   singleValue: (provided) => ({
//     ...provided,
//     color: '#4d6d64',
//     fontSize: "14px"
//   }),
//   multiValue: (provided) => ({
//     ...provided,
//     backgroundColor: '#e0f5e9', // softer variant
//     borderRadius: '0.25rem',
//     border: '1px solid #c2e6d1',
//     width: 'fit-content'
//   }),
//   multiValueLabel: (provided) => ({
//     ...provided,
//     color: '#4d6d64',
//   }),
//   multiValueRemove: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//     ':hover': {
//       backgroundColor: '#c2e6d1',
//       color: '#4f665f',
//     },
//   }),
//   indicatorsContainer: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//   }),
//   dropdownIndicator: (provided, state) => ({
//     ...provided,
//     color: '#b3c0bd',
//     ':hover': {
//       color: '#4f665f',
//     },
//   }),
//   clearIndicator: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//     ':hover': {
//       color: '#4f665f',
//     },
//   }),
//   menu: (provided) => ({
//     ...provided,
//     backgroundColor: '#f4faf5',
//     border: '1px solid #c2e6d1',
//     boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)',
//     borderRadius: '0.5rem',
//     zIndex: 10,
//   }),
//   menuList: (provided) => ({
//     ...provided,
//     padding: 0,
//   }),
//   option: (provided, state) => ({
//     ...provided,
//     backgroundColor: state.isSelected
//       ? '#c2e6d1'
//       : state.isFocused
//         ? '#e9f7ef'
//         : 'transparent',
//     color: '#4f665f',
//     padding: '10px 12px',
//     cursor: 'pointer',
//     fontSize: "14px"
//   }),
//   noOptionsMessage: (provided) => ({
//     ...provided,
//     color: '#b3c0bd',
//     padding: '8px 12px',
//   }),
// };



export const customStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: '#f4faf5',
    borderColor: '#c2e6d1',
    color: '#b3c0bd',
    boxShadow: state.isFocused ? '0 0 0 1px #c2e6d1' : 'none',
    borderWidth: '1px',
    borderRadius: '10px',
    '&:hover': {
      borderColor: '#b3c0bd',
    },
    minHeight: '38px',
    height: '38px',
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '2px 8px',
    paddingTop: '1px',
  }),
  input: (provided) => ({
    ...provided,
    color: '#b3c0bd',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    fontSize: '14px',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#4d6d64',
    fontSize: '14px',
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: '#e0f5e9',
    borderRadius: '0.25rem',
    border: '1px solid #c2e6d1',
    width: 'fit-content',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: '#4d6d64',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    ':hover': {
      backgroundColor: '#c2e6d1',
      color: '#4f665f',
    },
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    color: '#b3c0bd',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#205a46', 
    ':hover': {
        color: '#205a46',
    },
    }),
  clearIndicator: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    ':hover': {
      color: '#4f665f',
    },
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: '#ffffff',
    border: '1px solid #c2e6d1',
    borderRadius: '10px',
    boxShadow: '0 0 0 1px #c2e6d1',
    marginTop: '6px',
    zIndex: 10,
  }),
  menuList: (provided) => ({
    ...provided,
    padding: '4px',
    borderRadius: '10px',
  }),
option: (provided, state) => ({
  ...provided,
  backgroundColor: state.isFocused
    ? '#f4faf5'
    : 'transparent',
  color: '#4f665f',
  padding: '10px 12px',
  cursor: 'pointer',
  fontSize: '14px',
  borderRadius: '8px',
}),

  noOptionsMessage: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    padding: '8px 12px',
  }),
};
